export const Upload = () => {
  return (
    <>
      <path
        d="M21 15V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V15M17 8L12 3M12 3L7 8M12 3V15"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const Refresh = () => {
  return (
    <>
      <path
        d="M2 14C2 14 2.12132 14.8492 5.63604 18.364C9.15076 21.8787 14.8492 21.8787 18.364 18.364C19.6092 17.1187 20.4133 15.5993 20.7762 14M2 14V20M2 14H8M22 10C22 10 21.8787 9.15076 18.364 5.63604C14.8492 2.12132 9.15076 2.12132 5.63604 5.63604C4.39076 6.88131 3.58669 8.40072 3.22383 10M22 10V4M22 10H16"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const Save = () => {
  return (
    <>
      <path
        d="M15 4V2.6C15 2.03995 15 1.75992 14.891 1.54601C14.7951 1.35785 14.6422 1.20487 14.454 1.10899C14.2401 1 13.9601 1 13.4 1H4.6C4.03995 1 3.75992 1 3.54601 1.10899C3.35785 1.20487 3.20487 1.35785 3.10899 1.54601C3 1.75992 3 2.03995 3 2.6V21.4C3 21.9601 3 22.2401 3.10899 22.454C3.20487 22.6422 3.35785 22.7951 3.54601 22.891C3.75992 23 4.03995 23 4.6 23H13.4C13.9601 23 14.2401 23 14.454 22.891C14.6422 22.7951 14.7951 22.6422 14.891 22.454C15 22.2401 15 21.9601 15 21.4V20M15 4L18 1M15 4L18 7M18 1V7M18 1H22M18 7H22"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const ContainerFilled = () => {
  return (
    <>
      <path
        d="M12.4028 1.18505C12.137 1.13038 11.8628 1.13038 11.597 1.18505C11.2897 1.24824 11.0151 1.40207 10.7967 1.52436L10.7372 1.55761C8.97428 2.53701 5.99197 4.19467 4.31057 5.12928C3.90233 5.3562 3.69821 5.46967 3.62999 5.61962C3.57053 5.75035 3.57015 5.90034 3.62895 6.03137C3.6964 6.18167 3.90012 6.29627 4.30757 6.52545L11.6076 10.6318C11.7507 10.7122 11.8222 10.7525 11.8981 10.7683C11.9652 10.7822 12.0345 10.7822 12.1016 10.7683C12.1775 10.7525 12.249 10.7122 12.3921 10.6318L19.6922 6.52544C20.0996 6.29625 20.3033 6.18166 20.3708 6.03136C20.4296 5.90033 20.4292 5.75034 20.3697 5.61961C20.3015 5.46965 20.0974 5.35619 19.6892 5.12926C18.0078 4.19465 15.0255 2.53701 13.2626 1.55761L13.203 1.52436C12.9847 1.40207 12.7101 1.24824 12.4028 1.18505Z"
        fill="currentColor"
      />
      <path
        d="M21.9958 8.89015C21.9954 8.44181 21.9952 8.21764 21.9007 8.08675C21.8182 7.97256 21.6914 7.89845 21.5514 7.88267C21.3909 7.86457 21.1952 7.97469 20.8036 8.19493L13.4077 12.3552C13.2592 12.4387 13.185 12.4805 13.1309 12.5395C13.0831 12.5918 13.047 12.6536 13.0249 12.7209C12.9999 12.7969 12.9999 12.8821 12.9999 13.0524V21.2277C12.9999 21.6749 12.9999 21.8985 13.0939 22.0293C13.1759 22.1434 13.3022 22.2177 13.4418 22.234C13.6018 22.2527 13.7966 22.1445 14.1864 21.9281C15.8527 21.0028 18.8814 19.321 20.6626 18.3314L20.7257 18.2966C20.9568 18.1693 21.2474 18.0092 21.4706 17.767C21.6636 17.5576 21.8096 17.3095 21.8989 17.0391C22.0022 16.7264 22.001 16.3946 22.0001 16.1308L21.9999 16.0586C21.9999 14.0956 21.9973 10.7563 21.9958 8.89015Z"
        fill="currentColor"
      />
      <path
        d="M9.81339 21.9281C10.2031 22.1445 10.398 22.2527 10.558 22.234C10.6975 22.2177 10.8238 22.1434 10.9059 22.0293C10.9999 21.8985 10.9999 21.6749 10.9999 21.2277V13.0525C10.9999 12.8821 10.9999 12.797 10.9749 12.7209C10.9528 12.6536 10.9166 12.5918 10.8688 12.5396C10.8148 12.4805 10.7406 12.4387 10.5921 12.3552L3.19611 8.19496C2.80458 7.97472 2.60881 7.8646 2.44837 7.88269C2.3084 7.89848 2.18156 7.97259 2.09908 8.08677C2.00454 8.21766 2.00436 8.44183 2.00398 8.89017C2.00242 10.7563 1.99988 14.0956 1.99988 16.0586L1.9997 16.1308C1.99874 16.3946 1.99753 16.7264 2.10085 17.0391C2.19018 17.3095 2.3362 17.5576 2.52915 17.767C2.75231 18.0092 3.04291 18.1692 3.27404 18.2966L3.33721 18.3314C5.1184 19.321 8.14703 21.0028 9.81339 21.9281Z"
        fill="currentColor"
      />
    </>
  )
}

export const SaveFilled = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.6 0C3.85995 0 3.31244 0 2.89102 0.163954C2.43423 0.342892 2.07211 0.705008 1.89317 1.16179C1.72922 1.58321 1.72922 2.13072 1.72922 2.87077V21.4C1.72922 22.1401 1.72922 22.6876 1.89317 23.109C2.07211 23.5658 2.43423 23.9279 2.89102 24.1068C3.31244 24.2708 3.85995 24.2708 4.6 24.2708H13.4C14.1401 24.2708 14.6876 24.2708 15.109 24.1068C15.5658 23.9279 15.9279 23.5658 16.1068 23.109C16.2708 22.6876 16.2708 22.1401 16.2708 21.4V20.2031L22.5 14.2031C22.8978 13.8167 23.1068 13.6235 23.1068 13.4C23.1068 13.1765 22.8978 12.9833 22.5 12.5969L19.5 9.59692C19.1036 9.20051 18.9104 8.99115 18.6869 8.99115C18.4634 8.99115 18.2701 9.20051 17.8737 9.59692L16.2708 11.2031V2.87077C16.2708 2.13072 16.2708 1.58321 16.1068 1.16179C15.9279 0.705008 15.5658 0.342892 15.109 0.163954C14.6876 0 14.1401 0 13.4 0H4.6ZM22.5 1V7.59692C22.8978 7.98333 23.1068 8.17654 23.1068 8.4C23.1068 8.62346 22.8978 8.81667 22.5 9.20308L20.5 11.2031L16.7969 7.5L18.7969 5.5C19.1833 5.11358 19.3765 4.92038 19.6 4.92038C19.8235 4.92038 20.0167 5.11358 20.4031 5.5L22.5 7.59692V1Z"
        fill="currentColor"
      />
    </>
  )
}

export const DataFlow02Icon = () => {
  return (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.82929 3C7.41746 1.83481 6.30622 1 5 1C3.34315 1 2 2.34315 2 4C2 5.65685 3.34315 7 5 7C6.30622 7 7.41746 6.16519 7.82929 5L11 5L11 15.2413C11 16.0462 11 16.7106 11.0442 17.2518C11.0901 17.8139 11.1887 18.3306 11.436 18.816C11.8195 19.5686 12.4314 20.1805 13.184 20.564C13.6694 20.8113 14.1861 20.9099 14.7482 20.9558C15.1515 20.9888 15.6232 20.9971 16.1705 20.9993C16.5821 22.1648 17.6935 23 19 23C20.6569 23 22 21.6569 22 20C22 18.3431 20.6569 17 19 17C17.6941 17 16.5831 17.8344 16.171 18.9992C15.6425 18.997 15.2412 18.9894 14.911 18.9624C14.4726 18.9266 14.2484 18.8617 14.092 18.782C13.7157 18.5903 13.4097 18.2843 13.218 17.908C13.1383 17.7516 13.0734 17.5274 13.0376 17.089C13.0008 16.6389 13 16.0566 13 15.2V13L16.1707 13C16.5825 14.1652 17.6938 15 19 15C20.6569 15 22 13.6569 22 12C22 10.3431 20.6569 9 19 9C17.6938 9 16.5825 9.83481 16.1707 11L13 11V5L16.1707 5C16.5825 6.16519 17.6938 7 19 7C20.6569 7 22 5.65685 22 4C22 2.34315 20.6569 1 19 1C17.6938 1 16.5825 1.83481 16.1707 3L7.82929 3Z"
      fill="currentColor"
    />
  )
}

export const Announcement03Icon = () => {
  return (
    <path
      d="M18.5 16C20.433 16 22 13.0899 22 9.5C22 5.91015 20.433 3 18.5 3M18.5 16C16.567 16 15 13.0899 15 9.5C15 5.91015 16.567 3 18.5 3M18.5 16L5.44354 13.6261C4.51605 13.4575 4.05231 13.3731 3.67733 13.189C2.91447 12.8142 2.34636 12.1335 2.11414 11.3159C2 10.914 2 10.4427 2 9.5C2 8.5573 2 8.08595 2.11414 7.68407C2.34636 6.86649 2.91447 6.18577 3.67733 5.81105C4.05231 5.62685 4.51605 5.54254 5.44354 5.3739L18.5 3M5 14L5.39386 19.514C5.43126 20.0376 5.44996 20.2995 5.56387 20.4979C5.66417 20.6726 5.81489 20.8129 5.99629 20.9005C6.20232 21 6.46481 21 6.98979 21H8.7722C9.37234 21 9.67242 21 9.89451 20.8803C10.0897 20.7751 10.2443 20.6081 10.3342 20.4055C10.4365 20.1749 10.4135 19.8757 10.3675 19.2773L10 14.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  )
}

export const AddSymbol = () => {
  return (
    <>
      <path
        d="M8.00065 3.33203V12.6654M3.33398 7.9987H12.6673"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const ChevronDownIcon = () => {
  return (
    <path d="M1 1L7 7L13 1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  )
}

export const ChevronUp = () => {
  return (
    <path d="M13 7L7 1L1 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  )
}

export const ChevronRight = () => {
  return (
    <>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M9 18L15 12L9 6"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  )
}

export const ChevronLeft = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15 18L9 12L15 6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const Profile = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.85755 10.1654C7.28599 10.1657 8.71443 10.1657 10.1429 10.1654C10.6273 10.1652 10.9574 10.1652 11.2457 10.216C12.6257 10.4593 13.7062 11.5398 13.9496 12.9199C14.0004 13.2081 14.0003 13.5382 14.0002 14.0227C14.0002 14.1283 14.0034 14.2346 13.985 14.339C13.912 14.753 13.5879 15.0772 13.1739 15.1502C13.0831 15.1662 12.9874 15.1657 12.9399 15.1654C9.64711 15.1478 6.35332 15.1478 3.06056 15.1654C3.01298 15.1657 2.91735 15.1662 2.82657 15.1502C2.41256 15.0772 2.08841 14.753 2.01541 14.339C1.99699 14.2346 2.00023 14.1283 2.0002 14.0227C2.0001 13.5382 2.00003 13.2081 2.05086 12.9199C2.29419 11.5398 3.37468 10.4593 4.75472 10.216C5.04299 10.1652 5.3731 10.1652 5.85755 10.1654Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.33355 5.4987C4.33355 3.47365 5.97517 1.83203 8.00021 1.83203C10.0253 1.83203 11.6669 3.47365 11.6669 5.4987C11.6669 7.52374 10.0253 9.16536 8.00021 9.16536C5.97517 9.16536 4.33355 7.52374 4.33355 5.4987Z"
        fill="currentColor"
      />
    </>
  )
}

export const CopyIcon = () => {
  return (
    <>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8 8V5.2C8 4.0799 8 3.51984 8.21799 3.09202C8.40973 2.71569 8.71569 2.40973 9.09202 2.21799C9.51984 2 10.0799 2 11.2 2H18.8C19.9201 2 20.4802 2 20.908 2.21799C21.2843 2.40973 21.5903 2.71569 21.782 3.09202C22 3.51984 22 4.0799 22 5.2V12.8C22 13.9201 22 14.4802 21.782 14.908C21.5903 15.2843 21.2843 15.5903 20.908 15.782C20.4802 16 19.9201 16 18.8 16H16M5.2 22H12.8C13.9201 22 14.4802 22 14.908 21.782C15.2843 21.5903 15.5903 21.2843 15.782 20.908C16 20.4802 16 19.9201 16 18.8V11.2C16 10.0799 16 9.51984 15.782 9.09202C15.5903 8.71569 15.2843 8.40973 14.908 8.21799C14.4802 8 13.9201 8 12.8 8H5.2C4.0799 8 3.51984 8 3.09202 8.21799C2.71569 8.40973 2.40973 8.71569 2.21799 9.09202C2 9.51984 2 10.0799 2 11.2V18.8C2 19.9201 2 20.4802 2.21799 20.908C2.40973 21.2843 2.71569 21.5903 3.09202 21.782C3.51984 22 4.07989 22 5.2 22Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  )
}

export const SecondEmail = () => {
  return (
    <>
      <path
        d="M1.42169 5.95429C1.22174 5.81147 1.12177 5.74005 1.0346 5.73078C0.904251 5.71692 0.773611 5.78415 0.709129 5.89828C0.66601 5.97459 0.666012 6.0961 0.666016 6.33912V10.6609C0.666008 11.1975 0.666001 11.6404 0.695479 12.0012C0.726096 12.3759 0.791805 12.7204 0.956666 13.044C1.21233 13.5457 1.62028 13.9537 2.12204 14.2094C2.4456 14.3742 2.79007 14.4399 3.1648 14.4705C3.52559 14.5 3.96849 14.5 4.50513 14.5H11.4936C12.0302 14.5 12.4731 14.5 12.8339 14.4705C13.2086 14.4399 13.5531 14.3742 13.8767 14.2094C14.3784 13.9537 14.7864 13.5457 15.042 13.044C15.2069 12.7204 15.2726 12.3759 15.3032 12.0012C15.3327 11.6404 15.3327 11.1975 15.3327 10.6609V6.33912C15.3327 6.22001 15.3327 6.16045 15.3218 6.11886C15.2724 5.93084 15.068 5.82374 14.8854 5.89021C14.845 5.90491 14.7954 5.93924 14.6962 6.00789L9.53479 9.58129C9.16883 9.83544 8.84751 10.0586 8.48248 10.1471C8.1632 10.2245 7.82977 10.222 7.51166 10.1399C7.14797 10.0461 6.82996 9.81824 6.46778 9.55874L1.42169 5.95429Z"
        fill="currentColor"
      />
      <path
        d="M14.7546 4.34581C14.8776 4.26061 14.9392 4.21801 14.977 4.14949C15.0063 4.09629 15.0231 4.01203 15.0164 3.95163C15.0077 3.87386 14.9747 3.82251 14.9086 3.71982C14.6553 3.32643 14.2909 3.0017 13.8767 2.79065C13.5531 2.62579 13.2086 2.56008 12.8339 2.52946C12.4731 2.49999 12.0302 2.49999 11.4936 2.5H4.50515C3.96851 2.49999 3.52559 2.49999 3.1648 2.52946C2.79007 2.56008 2.4456 2.62579 2.12204 2.79065C1.74935 2.98054 1.42722 3.25507 1.18226 3.5889C1.10519 3.69393 1.06666 3.74644 1.05397 3.82614C1.04404 3.88846 1.0579 3.97505 1.08679 4.03116C1.12373 4.10291 1.18781 4.14868 1.31597 4.24022L7.16604 8.41884C7.65085 8.76514 7.75373 8.82539 7.84478 8.84888C7.95081 8.87624 8.06195 8.87706 8.16838 8.85126C8.25976 8.82911 8.36352 8.77038 8.85337 8.43125L14.7546 4.34581Z"
        fill="currentColor"
      />
    </>
  )
}

export const NotificationBell = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.60417 20.3383C8.96964 19.9242 9.60158 19.8848 10.0156 20.2503C10.5451 20.7176 11.2382 21 11.9997 21C12.7613 21 13.4544 20.7176 13.9838 20.2503C14.3979 19.8848 15.0298 19.9242 15.3953 20.3383C15.7608 20.7523 15.7214 21.3843 15.3073 21.7497C14.4265 22.5272 13.2671 23 11.9997 23C10.7324 23 9.57299 22.5272 8.69218 21.7497C8.27811 21.3843 8.23871 20.7523 8.60417 20.3383Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.04999 3.05025C8.36275 1.7375 10.1432 1 11.9997 1C13.8563 1 15.6367 1.7375 16.9495 3.05025C18.2622 4.36301 18.9997 6.14349 18.9997 8C18.9997 10.9127 19.7317 12.8439 20.4991 14.0771L20.511 14.0962C20.8683 14.6704 21.1507 15.1243 21.3411 15.4547C21.4366 15.6202 21.5235 15.7797 21.5879 15.9215C21.62 15.9922 21.6559 16.079 21.684 16.1733C21.7073 16.2515 21.7517 16.4187 21.7351 16.6223C21.7239 16.7591 21.696 16.9928 21.5618 17.2343C21.4277 17.4758 21.244 17.623 21.1337 17.7047C20.8834 17.8904 20.596 17.9329 20.5001 17.947L20.4957 17.9477C20.3482 17.9695 20.181 17.9804 20.0122 17.9869C19.677 18 19.2128 18 18.6356 18H5.36388C4.78666 18 4.32252 18 3.98726 17.9869C3.81851 17.9804 3.65123 17.9695 3.50382 17.9477L3.49939 17.947C3.40347 17.9329 3.11604 17.8904 2.86574 17.7047C2.7555 17.623 2.57178 17.4758 2.43762 17.2343C2.30347 16.9928 2.27558 16.7591 2.26439 16.6223C2.24774 16.4187 2.29214 16.2515 2.31545 16.1733C2.34354 16.079 2.37948 15.9922 2.41161 15.9215C2.47598 15.7797 2.56291 15.6202 2.65833 15.4547C2.84876 15.1243 3.13124 14.6703 3.48856 14.0961L3.50035 14.0771C4.26773 12.8439 4.99974 10.9127 4.99974 8C4.99974 6.14348 5.73724 4.36301 7.04999 3.05025Z"
        fill="currentColor"
      />
    </>
  )
}

export const BellRinging04 = () => {
  return (
    <>
      <path
        d="M15.6459 18.0148C16.0747 19.6152 15.125 21.2602 13.5246 21.689C11.9242 22.1178 10.2792 21.1681 9.85036 19.5677M2.05683 11.6133C1.66734 10.2151 2.07238 8.70349 3.10878 7.68738M12.1463 5.74085C12.4505 5.19355 12.5507 4.53205 12.3759 3.87945C12.0185 2.54579 10.6477 1.75433 9.314 2.11168C7.98034 2.46904 7.18888 3.83988 7.54624 5.17355C7.7211 5.82614 8.13863 6.34891 8.67573 6.67079M20.319 6.72C19.9572 5.31439 18.8506 4.20779 17.445 3.84602M17.4906 9.44528C17.1337 8.11315 16.1808 6.99919 14.8415 6.34845C13.5022 5.69772 11.8863 5.56352 10.3492 5.97538C8.81214 6.38724 7.47981 7.31142 6.64533 8.54461C5.81085 9.77779 5.54258 11.219 5.89952 12.5511C6.4901 14.7552 6.37542 16.5135 6.00247 17.8497C5.5774 19.3725 5.36487 20.134 5.42228 20.2869C5.48798 20.4618 5.53549 20.5098 5.70973 20.5773C5.86202 20.6363 6.50179 20.4649 7.78133 20.122L19.6464 16.9428C20.9259 16.5999 21.5657 16.4285 21.6681 16.3013C21.7852 16.1557 21.8024 16.0904 21.7718 15.906C21.7451 15.7449 21.1803 15.1918 20.0508 14.0855C19.0597 13.1148 18.0812 11.6493 17.4906 9.44528Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const Email = () => {
  return (
    <>
      <path
        d="M2 7.5L10.1649 13.2154C10.8261 13.6783 11.1567 13.9097 11.5163 13.9993C11.8339 14.0785 12.1661 14.0785 12.4837 13.9993C12.8433 13.9097 13.1739 13.6783 13.8351 13.2154L22 7.5M6.8 20.5H17.2C18.8802 20.5 19.7202 20.5 20.362 20.173C20.9265 19.8854 21.3854 19.4265 21.673 18.862C22 18.2202 22 17.3802 22 15.7V9.3C22 7.61984 22 6.77976 21.673 6.13803C21.3854 5.57354 20.9265 5.1146 20.362 4.82698C19.7202 4.5 18.8802 4.5 17.2 4.5H6.8C5.11984 4.5 4.27976 4.5 3.63803 4.82698C3.07354 5.1146 2.6146 5.57354 2.32698 6.13803C2 6.77976 2 7.61984 2 9.3V15.7C2 17.3802 2 18.2202 2.32698 18.862C2.6146 19.4265 3.07354 19.8854 3.63803 20.173C4.27976 20.5 5.11984 20.5 6.8 20.5Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const AnnotationX = () => {
  return (
    <path
      d="M9.5 8L14.5 13M14.5 8L9.5 13M9.9 19.2L11.36 21.1467C11.5771 21.4362 11.6857 21.5809 11.8188 21.6327C11.9353 21.678 12.0647 21.678 12.1812 21.6327C12.3143 21.5809 12.4229 21.4362 12.64 21.1467L14.1 19.2C14.3931 18.8091 14.5397 18.6137 14.7185 18.4645C14.9569 18.2656 15.2383 18.1248 15.5405 18.0535C15.7671 18 16.0114 18 16.5 18C17.8978 18 18.5967 18 19.1481 17.7716C19.8831 17.4672 20.4672 16.8831 20.7716 16.1481C21 15.5967 21 14.8978 21 13.5V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V13.5C3 14.8978 3 15.5967 3.22836 16.1481C3.53284 16.8831 4.11687 17.4672 4.85195 17.7716C5.40326 18 6.10218 18 7.5 18C7.98858 18 8.23287 18 8.45951 18.0535C8.76169 18.1248 9.04312 18.2656 9.2815 18.4645C9.46028 18.6137 9.60685 18.8091 9.9 19.2Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  )
}

export const ExpandIcon = () => {
  return (
    <>
      <path
        d="M8.75 5.25L12.25 1.75M12.25 1.75H8.75M12.25 1.75V5.25M5.25 5.25L1.75 1.75M1.75 1.75L1.75 5.25M1.75 1.75L5.25 1.75M5.25 8.75L1.75 12.25M1.75 12.25H5.25M1.75 12.25L1.75 8.75M8.75 8.75L12.25 12.25M12.25 12.25V8.75M12.25 12.25H8.75"
        stroke="#A2A8AE"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="currentColor"
      />
    </>
  )
}

export const Camera = () => {
  return (
    <>
      <path
        d="M2 8.37722C2 8.0269 2 7.85174 2.01462 7.70421C2.1556 6.28127 3.28127 5.1556 4.70421 5.01462C4.85174 5 5.03636 5 5.40558 5C5.54785 5 5.61899 5 5.67939 4.99634C6.45061 4.94963 7.12595 4.46288 7.41414 3.746C7.43671 3.68986 7.45781 3.62657 7.5 3.5C7.54219 3.37343 7.56329 3.31014 7.58586 3.254C7.87405 2.53712 8.54939 2.05037 9.32061 2.00366C9.38101 2 9.44772 2 9.58114 2H14.4189C14.5523 2 14.619 2 14.6794 2.00366C15.4506 2.05037 16.126 2.53712 16.4141 3.254C16.4367 3.31014 16.4578 3.37343 16.5 3.5C16.5422 3.62657 16.5633 3.68986 16.5859 3.746C16.874 4.46288 17.5494 4.94963 18.3206 4.99634C18.381 5 18.4521 5 18.5944 5C18.9636 5 19.1483 5 19.2958 5.01462C20.7187 5.1556 21.8444 6.28127 21.9854 7.70421C22 7.85174 22 8.0269 22 8.37722V16.2C22 17.8802 22 18.7202 21.673 19.362C21.3854 19.9265 20.9265 20.3854 20.362 20.673C19.7202 21 18.8802 21 17.2 21H6.8C5.11984 21 4.27976 21 3.63803 20.673C3.07354 20.3854 2.6146 19.9265 2.32698 19.362C2 18.7202 2 17.8802 2 16.2V8.37722Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 16.5C14.2091 16.5 16 14.7091 16 12.5C16 10.2909 14.2091 8.5 12 8.5C9.79086 8.5 8 10.2909 8 12.5C8 14.7091 9.79086 16.5 12 16.5Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const CodeBrowser = () => {
  return (
    <>
      <path
        d="M22 9H2M14 17.5L16.5 15L14 12.5M10 12.5L7.5 15L10 17.5M2 7.8L2 16.2C2 17.8802 2 18.7202 2.32698 19.362C2.6146 19.9265 3.07354 20.3854 3.63803 20.673C4.27976 21 5.11984 21 6.8 21H17.2C18.8802 21 19.7202 21 20.362 20.673C20.9265 20.3854 21.3854 19.9265 21.673 19.362C22 18.7202 22 17.8802 22 16.2V7.8C22 6.11984 22 5.27977 21.673 4.63803C21.3854 4.07354 20.9265 3.6146 20.362 3.32698C19.7202 3 18.8802 3 17.2 3L6.8 3C5.11984 3 4.27976 3 3.63803 3.32698C3.07354 3.6146 2.6146 4.07354 2.32698 4.63803C2 5.27976 2 6.11984 2 7.8Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const Code = () => {
  return (
    <>
      <path
        d="M17 17L22 12L17 7M7 7L2 12L7 17M14 3L10 21"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const FilterLines = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 12C5 11.4477 5.44772 11 6 11H18C18.5523 11 19 11.4477 19 12C19 12.5523 18.5523 13 18 13H6C5.44772 13 5 12.5523 5 12Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 6C2 5.44772 2.44772 5 3 5H21C21.5523 5 22 5.44772 22 6C22 6.55228 21.5523 7 21 7H3C2.44772 7 2 6.55228 2 6Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 18C8 17.4477 8.44772 17 9 17H15C15.5523 17 16 17.4477 16 18C16 18.5523 15.5523 19 15 19H9C8.44772 19 8 18.5523 8 18Z"
        fill="currentColor"
      />
    </>
  )
}

export const ShareOutline = () => {
  return (
    <>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8.59 13.51L15.42 17.49M15.41 6.51L8.59 10.49M21 5C21 6.65685 19.6569 8 18 8C16.3431 8 15 6.65685 15 5C15 3.34315 16.3431 2 18 2C19.6569 2 21 3.34315 21 5ZM9 12C9 13.6569 7.65685 15 6 15C4.34315 15 3 13.6569 3 12C3 10.3431 4.34315 9 6 9C7.65685 9 9 10.3431 9 12ZM21 19C21 20.6569 19.6569 22 18 22C16.3431 22 15 20.6569 15 19C15 17.3431 16.3431 16 18 16C19.6569 16 21 17.3431 21 19Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  )
}

export const CalendarFilled = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 1C16.5523 1 17 1.44772 17 2V3.00163C17.4755 3.00489 17.891 3.01472 18.2518 3.04419C18.8139 3.09012 19.3306 3.18868 19.816 3.43597C20.5686 3.81947 21.1805 4.43139 21.564 5.18404C21.8113 5.66937 21.9099 6.18608 21.9558 6.74817C22 7.28936 22 7.95372 22 8.75868V17.2413C22 18.0463 22 18.7106 21.9558 19.2518C21.9099 19.8139 21.8113 20.3306 21.564 20.816C21.1805 21.5686 20.5686 22.1805 19.816 22.564C19.3306 22.8113 18.8139 22.9099 18.2518 22.9558C17.7106 23 17.0463 23 16.2413 23H7.75868C6.95372 23 6.28937 23 5.74818 22.9558C5.18608 22.9099 4.66937 22.8113 4.18404 22.564C3.43139 22.1805 2.81947 21.5686 2.43598 20.816C2.18868 20.3306 2.09012 19.8139 2.04419 19.2518C1.99998 18.7106 1.99999 18.0463 2 17.2413V8.7587C1.99999 7.95374 1.99998 7.28937 2.04419 6.74817C2.09012 6.18608 2.18868 5.66937 2.43598 5.18404C2.81947 4.43139 3.43139 3.81947 4.18404 3.43597C4.66937 3.18868 5.18608 3.09012 5.74818 3.04419C6.10898 3.01472 6.52454 3.00489 7 3.00163V2C7 1.44772 7.44772 1 8 1C8.55229 1 9 1.44772 9 2V3H15V2C15 1.44772 15.4477 1 16 1ZM7 5.00176V6C7 6.55228 7.44772 7 8 7C8.55229 7 9 6.55228 9 6V5H15V6C15 6.55228 15.4477 7 16 7C16.5523 7 17 6.55228 17 6V5.00176C17.4455 5.00489 17.7954 5.01357 18.089 5.03755C18.5274 5.07337 18.7516 5.1383 18.908 5.21799C19.2843 5.40973 19.5903 5.7157 19.782 6.09202C19.8617 6.24842 19.9266 6.47262 19.9624 6.91104C19.9992 7.36113 20 7.94342 20 8.8V9H4V8.8C4 7.94342 4.00078 7.36113 4.03755 6.91104C4.07337 6.47262 4.1383 6.24842 4.21799 6.09202C4.40973 5.7157 4.7157 5.40973 5.09202 5.21799C5.24842 5.1383 5.47262 5.07337 5.91104 5.03755C6.20463 5.01357 6.55447 5.00489 7 5.00176Z"
        fill="currentColor"
      />
    </>
  )
}

export const Calendar = () => {
  return (
    <>
      <path
        d="M14 7.16732H2M10.6667 1.83398V4.50065M5.33333 1.83398V4.50065M5.2 15.1673H10.8C11.9201 15.1673 12.4802 15.1673 12.908 14.9493C13.2843 14.7576 13.5903 14.4516 13.782 14.0753C14 13.6475 14 13.0874 14 11.9673V6.36732C14 5.24721 14 4.68716 13.782 4.25934C13.5903 3.88301 13.2843 3.57705 12.908 3.3853C12.4802 3.16732 11.9201 3.16732 10.8 3.16732H5.2C4.0799 3.16732 3.51984 3.16732 3.09202 3.3853C2.71569 3.57705 2.40973 3.88301 2.21799 4.25934C2 4.68716 2 5.24721 2 6.36732V11.9673C2 13.0874 2 13.6475 2.21799 14.0753C2.40973 14.4516 2.71569 14.7576 3.09202 14.9493C3.51984 15.1673 4.0799 15.1673 5.2 15.1673Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const Circle = () => {
  return (
    <>
      <path
        d="M7.9987 15.1673C11.6806 15.1673 14.6654 12.1825 14.6654 8.50065C14.6654 4.81875 11.6806 1.83398 7.9987 1.83398C4.3168 1.83398 1.33203 4.81875 1.33203 8.50065C1.33203 12.1825 4.3168 15.1673 7.9987 15.1673Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const ReportBarChart = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.2413 1H8.7587C7.95374 0.999988 7.28937 0.999978 6.74818 1.04419C6.18608 1.09012 5.66937 1.18868 5.18404 1.43598C4.43139 1.81947 3.81947 2.43139 3.43598 3.18404C3.18868 3.66937 3.09012 4.18608 3.04419 4.74818C2.99998 5.28937 2.99999 5.95372 3 6.75869V17.2413C2.99999 18.0463 2.99998 18.7106 3.04419 19.2518C3.09012 19.8139 3.18868 20.3306 3.43598 20.816C3.81947 21.5686 4.43139 22.1805 5.18404 22.564C5.66937 22.8113 6.18608 22.9099 6.74818 22.9558C7.28937 23 7.95372 23 8.75868 23H15.2413C16.0463 23 16.7106 23 17.2518 22.9558C17.8139 22.9099 18.3306 22.8113 18.816 22.564C19.5686 22.1805 20.1805 21.5686 20.564 20.816C20.8113 20.3306 20.9099 19.8139 20.9558 19.2518C21 18.7106 21 18.0463 21 17.2413V6.75868C21 5.95372 21 5.28937 20.9558 4.74818C20.9099 4.18608 20.8113 3.66937 20.564 3.18404C20.1805 2.43139 19.5686 1.81947 18.816 1.43598C18.3306 1.18868 17.8139 1.09012 17.2518 1.04419C16.7106 0.999978 16.0463 0.999988 15.2413 1ZM13 8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8V18C11 18.5523 11.4477 19 12 19C12.5523 19 13 18.5523 13 18V8ZM16 11C16.5523 11 17 11.4477 17 12V18C17 18.5523 16.5523 19 16 19C15.4477 19 15 18.5523 15 18V12C15 11.4477 15.4477 11 16 11ZM8 13C8.55229 13 9 13.4477 9 14V18C9 18.5523 8.55229 19 8 19C7.44772 19 7 18.5523 7 18V14C7 13.4477 7.44772 13 8 13Z"
        fill="currentColor"
      />
    </>
  )
}

export const PackageBox = () => {
  return (
    <>
      <path
        d="M12.4033 1.18505C12.1375 1.13038 11.8633 1.13038 11.5975 1.18505C11.2902 1.24824 11.0156 1.40207 10.7972 1.52436L10.7377 1.55761C10.0837 1.92097 9.26177 2.37768 8.40075 2.85619L17.3636 7.83555L19.6927 6.52544C20.1001 6.29625 20.3038 6.18166 20.3713 6.03136C20.4301 5.90033 20.4297 5.75034 20.3702 5.61961C20.302 5.46965 20.0979 5.35619 19.6897 5.12926C18.0083 4.19466 15.026 2.53701 13.263 1.55761L13.2035 1.52436C12.9852 1.40207 12.7105 1.24824 12.4033 1.18505Z"
        fill="currentColor"
      />
      <path
        d="M15.3173 8.98661L6.34205 4.00039C5.58232 4.42265 4.87382 4.81647 4.31106 5.12928C3.90282 5.3562 3.69869 5.46967 3.63048 5.61962C3.57102 5.75035 3.57064 5.90034 3.62944 6.03137C3.69689 6.18167 3.90061 6.29627 4.30805 6.52545L11.6081 10.6318C11.7512 10.7122 11.8227 10.7525 11.8986 10.7683C11.9657 10.7822 12.035 10.7822 12.1021 10.7683C12.1779 10.7525 12.2495 10.7122 12.3925 10.6318L15.3173 8.98661Z"
        fill="currentColor"
      />
      <path
        d="M21.9963 8.89013C21.9959 8.4418 21.9957 8.21764 21.9012 8.08675C21.8187 7.97256 21.6919 7.89845 21.5519 7.88267C21.3914 7.86457 21.1957 7.97469 20.8041 8.19493L13.4082 12.3552C13.2597 12.4387 13.1855 12.4805 13.1314 12.5395C13.0836 12.5918 13.0475 12.6536 13.0254 12.7209C13.0004 12.7969 13.0004 12.8821 13.0004 13.0524V21.2277C13.0004 21.6749 13.0004 21.8985 13.0944 22.0293C13.1764 22.1434 13.3027 22.2177 13.4423 22.234C13.6023 22.2527 13.7971 22.1445 14.1869 21.9281C15.8532 21.0028 18.8819 19.321 20.663 18.3314L20.7262 18.2966C20.9573 18.1693 21.2479 18.0092 21.4711 17.767C21.6641 17.5576 21.8101 17.3095 21.8994 17.0391C22.0027 16.7264 22.0015 16.3946 22.0005 16.1308L22.0004 16.0586C22.0004 14.0956 21.9978 10.7563 21.9963 8.89013Z"
        fill="currentColor"
      />
      <path
        d="M10.5584 22.234C10.3985 22.2527 10.2036 22.1445 9.81387 21.9281C8.14752 21.0028 5.11889 19.321 3.3377 18.3314L3.27452 18.2966C3.0434 18.1692 2.7528 18.0092 2.52964 17.767C2.33668 17.5576 2.19066 17.3095 2.10134 17.0391C1.99802 16.7264 1.99923 16.3946 2.00019 16.1308L2.00037 16.0586C2.00037 14.0956 2.00291 10.7563 2.00447 8.89017C2.00484 8.44183 2.00503 8.21766 2.09957 8.08677C2.18205 7.97259 2.30889 7.89848 2.44886 7.88269C2.6093 7.8646 2.80507 7.97472 3.1966 8.19496L10.5926 12.3552C10.741 12.4387 10.8153 12.4805 10.8693 12.5396C10.9171 12.5918 10.9533 12.6536 10.9754 12.7209C11.0004 12.797 11.0004 12.8821 11.0004 13.0525V21.2277C11.0004 21.6749 11.0004 21.8985 10.9063 22.0293C10.8243 22.1434 10.698 22.2177 10.5584 22.234Z"
        fill="currentColor"
      />
    </>
  )
}

export const PackageBoxOutline = () => {
  return (
    <>
      <path
        d="M20.5 7.27783L12 12.0001M12 12.0001L3.49997 7.27783M12 12.0001L12 21.5001M21 16.0586V7.94153C21 7.59889 21 7.42757 20.9495 7.27477C20.9049 7.13959 20.8318 7.01551 20.7354 6.91082C20.6263 6.79248 20.4766 6.70928 20.177 6.54288L12.777 2.43177C12.4934 2.27421 12.3516 2.19543 12.2015 2.16454C12.0685 2.13721 11.9315 2.13721 11.7986 2.16454C11.6484 2.19543 11.5066 2.27421 11.223 2.43177L3.82297 6.54288C3.52345 6.70928 3.37369 6.79248 3.26463 6.91082C3.16816 7.01551 3.09515 7.13959 3.05048 7.27477C3 7.42757 3 7.59889 3 7.94153V16.0586C3 16.4013 3 16.5726 3.05048 16.7254C3.09515 16.8606 3.16816 16.9847 3.26463 17.0893C3.37369 17.2077 3.52345 17.2909 3.82297 17.4573L11.223 21.5684C11.5066 21.726 11.6484 21.8047 11.7986 21.8356C11.9315 21.863 12.0685 21.863 12.2015 21.8356C12.3516 21.8047 12.4934 21.726 12.777 21.5684L20.177 17.4573C20.4766 17.2909 20.6263 17.2077 20.7354 17.0893C20.8318 16.9847 20.9049 16.8606 20.9495 16.7254C21 16.5726 21 16.4013 21 16.0586Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 9.5L7.5 4.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const Tiles = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.56811 13C5.85605 13.0002 7.1465 13.0002 8.4319 13C8.68429 13 8.93008 12.9999 9.13824 13.017C9.36683 13.0356 9.63656 13.0797 9.90799 13.218C10.2843 13.4097 10.5903 13.7157 10.782 14.092C10.9203 14.3634 10.9644 14.6332 10.9831 14.8618C11.0001 15.0699 11 15.3157 11 15.5681V19.4319C11 19.6843 11.0001 19.9301 10.9831 20.1382C10.9644 20.3668 10.9203 20.6366 10.782 20.908C10.5903 21.2843 10.2843 21.5903 9.90799 21.782C9.63656 21.9203 9.36683 21.9644 9.13824 21.9831C8.93007 22.0001 8.68427 22 8.43189 22H4.56812C4.31574 22 4.06994 22.0001 3.86178 21.9831C3.63318 21.9644 3.36345 21.9203 3.09202 21.782C2.7157 21.5903 2.40974 21.2843 2.21799 20.908C2.07969 20.6366 2.03563 20.3668 2.01695 20.1382C1.99994 19.9301 1.99997 19.6843 2 19.4319C2 19.4213 2.00001 19.4106 2.00001 19.4V15.6C2.00001 15.5894 2 15.5787 2 15.5681C1.99997 15.3157 1.99994 15.0699 2.01695 14.8618C2.03563 14.6332 2.07969 14.3634 2.21799 14.092C2.40974 13.7157 2.7157 13.4097 3.09202 13.218C3.36345 13.0797 3.63318 13.0356 3.86178 13.017C4.06993 12.9999 4.31572 13 4.56811 13Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5681 2C16.856 2.00016 18.1465 2.00016 19.4319 2C19.6843 1.99997 19.9301 1.99994 20.1382 2.01695C20.3668 2.03563 20.6366 2.07969 20.908 2.21799C21.2843 2.40974 21.5903 2.7157 21.782 3.09202C21.9203 3.36345 21.9644 3.63318 21.9831 3.86178C22.0001 4.06994 22 4.31574 22 4.56813V8.43189C22 8.68427 22.0001 8.93007 21.9831 9.13824C21.9644 9.36683 21.9203 9.63656 21.782 9.90799C21.5903 10.2843 21.2843 10.5903 20.908 10.782C20.6366 10.9203 20.3668 10.9644 20.1382 10.9831C19.9301 11.0001 19.6843 11 19.4319 11H15.5681C15.3157 11 15.0699 11.0001 14.8618 10.9831C14.6332 10.9644 14.3634 10.9203 14.092 10.782C13.7157 10.5903 13.4097 10.2843 13.218 9.90799C13.0797 9.63656 13.0356 9.36683 13.017 9.13824C12.9999 8.93008 13 8.68429 13 8.4319C13 8.42128 13 8.41065 13 8.40001V4.60001C13 4.58936 13 4.57873 13 4.56811C13 4.31572 12.9999 4.06993 13.017 3.86178C13.0356 3.63318 13.0797 3.36345 13.218 3.09202C13.4097 2.7157 13.7157 2.40974 14.092 2.21799C14.3634 2.07969 14.6332 2.03563 14.8618 2.01695C15.0699 1.99994 15.3157 1.99997 15.5681 2Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.05449 4C7.08484 4.00013 8.1172 4.00013 9.14552 4C9.34743 3.99998 9.54406 3.99995 9.71059 4.01356C9.89346 4.0285 10.1092 4.06376 10.3264 4.17439C10.6274 4.32779 10.8722 4.57256 11.0256 4.87362C11.1362 5.09076 11.1715 5.30655 11.1864 5.48942C11.2001 5.65595 11.2 5.85259 11.2 6.0545V9.14551C11.2 9.34742 11.2001 9.54405 11.1864 9.71059C11.1715 9.89346 11.1362 10.1092 11.0256 10.3264C10.8722 10.6274 10.6274 10.8722 10.3264 11.0256C10.1092 11.1362 9.89346 11.1715 9.71059 11.1864C9.54405 11.2001 9.34742 11.2 9.14551 11.2H6.0545C5.85259 11.2 5.65595 11.2001 5.48942 11.1864C5.30655 11.1715 5.09076 11.1362 4.87362 11.0256C4.57256 10.8722 4.32779 10.6274 4.17439 10.3264C4.06376 10.1092 4.0285 9.89346 4.01356 9.71059C3.99995 9.54406 3.99998 9.34743 4 9.14552C4 9.13702 4 9.12852 4 9.12V6.08C4 6.07149 4 6.06298 4 6.05448C3.99998 5.85258 3.99995 5.65595 4.01356 5.48942C4.0285 5.30655 4.06376 5.09076 4.17439 4.87362C4.32779 4.57256 4.57256 4.32779 4.87362 4.17439C5.09076 4.06376 5.30655 4.0285 5.48942 4.01356C5.65595 3.99995 5.85258 3.99998 6.05449 4Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.8545 12.8C15.8848 12.8001 16.9172 12.8001 17.9455 12.8C18.1474 12.8 18.3441 12.7999 18.5106 12.8136C18.6935 12.8285 18.9092 12.8638 19.1264 12.9744C19.4274 13.1278 19.6722 13.3726 19.8256 13.6736C19.9362 13.8908 19.9715 14.1065 19.9864 14.2894C20 14.4559 20 14.6526 20 14.8545V17.9455C20 18.1474 20 18.3441 19.9864 18.5106C19.9715 18.6935 19.9362 18.9092 19.8256 19.1264C19.6722 19.4274 19.4274 19.6722 19.1264 19.8256C18.9092 19.9362 18.6935 19.9715 18.5106 19.9864C18.3441 20 18.1474 20 17.9455 20H14.8545C14.6526 20 14.4559 20 14.2894 19.9864C14.1065 19.9715 13.8908 19.9362 13.6736 19.8256C13.3726 19.6722 13.1278 19.4274 12.9744 19.1264C12.8638 18.9092 12.8285 18.6935 12.8136 18.5106C12.7999 18.3441 12.8 18.1474 12.8 17.9455C12.8 17.937 12.8 17.9285 12.8 17.92V14.88C12.8 14.8715 12.8 14.863 12.8 14.8545C12.8 14.6526 12.7999 14.4559 12.8136 14.2894C12.8285 14.1065 12.8638 13.8908 12.9744 13.6736C13.1278 13.3726 13.3726 13.1278 13.6736 12.9744C13.8908 12.8638 14.1065 12.8285 14.2894 12.8136C14.4559 12.7999 14.6526 12.8 14.8545 12.8Z"
        fill="currentColor"
      />
    </>
  )
}

export const Globe = () => {
  return (
    <>
      <path
        d="M13.8939 12.5808L16.5342 13.7124C16.6642 13.768 16.8143 13.8323 16.9397 13.8995C17.0808 13.9751 17.2866 14.1025 17.4539 14.3273C17.6655 14.6116 17.7696 14.9617 17.7477 15.3155C17.7304 15.5951 17.6276 15.8143 17.5506 15.9547C17.4823 16.0795 17.3917 16.2153 17.3132 16.3329C16.8225 17.0692 16.381 18.0866 15.6848 18.6588C15.5325 18.784 15.357 18.878 15.1683 18.9353C14.2961 19.2002 12.7076 19.2484 11.8114 18.8959C11.5777 18.804 11.3708 18.6549 11.2097 18.4623C10.6052 17.7393 10.4447 16.4969 10.1561 15.6306L10.1484 15.6079C10.12 15.5246 10.0614 15.3527 10.0454 15.1674C10.0318 15.0106 10.0431 14.8526 10.0787 14.6993C10.2262 14.0637 10.6368 13.4001 10.9664 12.8503C11.0351 12.7356 11.1415 12.581 11.3119 12.4437C11.5359 12.2631 11.8071 12.1507 12.0932 12.12C12.3108 12.0967 12.4953 12.1308 12.625 12.1633C13.051 12.2699 13.4916 12.4084 13.8939 12.5808Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM3.50553 9.01869C3.17808 9.95174 3 10.9551 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 8.1675 18.6045 4.89451 15.2291 3.59664C15.1462 4.84217 15.5812 6.80831 14.5371 7.76943C13.4421 8.77736 11.4822 9.2136 10.1439 9.8083L9.25538 10.993C9.18549 11.0863 9.10167 11.1981 9.01972 11.2908C8.92445 11.3984 8.77813 11.544 8.56315 11.6514C8.284 11.7907 7.96834 11.8396 7.66013 11.7911C7.42276 11.7538 7.23928 11.6592 7.11593 11.5854C7.00979 11.5218 6.89611 11.4406 6.80129 11.3728L3.50553 9.01869Z"
        fill="currentColor"
      />
    </>
  )
}

export const WorkFlow = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 9.87398C8.72523 9.42994 10 7.86384 10 6C10 3.79086 8.20914 2 6 2C3.79086 2 2 3.79086 2 6C2 7.86384 3.27477 9.42994 5 9.87398V21C5 21.5523 5.44772 22 6 22C6.55228 22 7 21.5523 7 21V9.87398Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 18C14 16.1362 15.2748 14.5701 17 14.126V8C17 7.73478 16.8946 7.48043 16.7071 7.29289C16.5196 7.10536 16.2652 7 16 7H13C12.4477 7 12 6.55228 12 6C12 5.44772 12.4477 5 13 5H16C16.7956 5 17.5587 5.31607 18.1213 5.87868C18.6839 6.44129 19 7.20435 19 8V14.126C20.7252 14.5701 22 16.1362 22 18C22 20.2091 20.2091 22 18 22C15.7909 22 14 20.2091 14 18Z"
        fill="currentColor"
      />
    </>
  )
}

export const Building3Icon = () => (
  <path
    d="M7.5 7H10.25M7.5 11H10.25M7.5 15H10.25M13.75 7H16.5M13.75 11H16.5M13.75 15H16.5M20 21V6.2C20 5.0799 20 4.51984 19.782 4.09202C19.5903 3.71569 19.2843 3.40973 18.908 3.21799C18.4802 3 17.9201 3 16.8 3H7.2C6.07989 3 5.51984 3 5.09202 3.21799C4.71569 3.40973 4.40973 3.71569 4.21799 4.09202C4 4.51984 4 5.0799 4 6.2V21M22 21H2"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
)

export const CreateClusterIcon = () => {
  return (
    <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="50" height="50" rx="28" fill="url(#paint0_linear_3199_33799)" />
      <path
        d="M25 19V30.2C25 31.8802 25 32.7202 25.327 33.362C25.6146 33.9265 26.0735 34.3854 26.638 34.673C27.2798 35 28.1198 35 29.8 35H30M30 35C30 36.1046 30.8954 37 32 37C33.1046 37 34 36.1046 34 35C34 33.8954 33.1046 33 32 33C30.8954 33 30 33.8954 30 35ZM20 19L30 19M20 19C20 20.1046 19.1046 21 18 21C16.8954 21 16 20.1046 16 19C16 17.8954 16.8954 17 18 17C19.1046 17 20 17.8954 20 19ZM30 19C30 20.1046 30.8954 21 32 21C33.1046 21 34 20.1046 34 19C34 17.8954 33.1046 17 32 17C30.8954 17 30 17.8954 30 19ZM25 27H30M30 27C30 28.1046 30.8954 29 32 29C33.1046 29 34 28.1046 34 27C34 25.8954 33.1046 27 32 27C30.8954 27 30 27.8954 30 27Z"
        stroke="white"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.7"
        d="M17.625 32.601C17.7642 32.2389 18.1121 32 18.5 32C18.8879 32 19.2358 32.2389 19.375 32.601L20.48 35.4738C20.7616 36.2061 20.8501 36.4171 20.9711 36.5873C21.0926 36.7581 21.2419 36.9074 21.4127 37.0289C21.5829 37.1499 21.7939 37.2384 22.5262 37.52L25.399 38.625C25.7611 38.7642 26 39.1121 26 39.5C26 39.8879 25.7611 40.2358 25.399 40.375L22.5262 41.48C21.7939 41.7616 21.5829 41.8501 21.4127 41.9711C21.2419 42.0926 21.0926 42.2419 20.9711 42.4127C20.8501 42.5829 20.7616 42.7939 20.48 43.5261L19.375 46.399C19.2358 46.7611 18.8879 47 18.5 47C18.1121 47 17.7642 46.7611 17.625 46.399L16.52 43.5261C16.2384 42.7939 16.1499 42.5829 16.0289 42.4127C15.9074 42.2419 15.7581 42.0926 15.5873 41.9711C15.4171 41.8501 15.2061 41.7616 14.4738 41.48L11.601 40.375C11.2389 40.2358 11 39.8879 11 39.5C11 39.1121 11.2389 38.7642 11.601 38.625L14.4739 37.52C15.2061 37.2384 15.4171 37.1499 15.5873 37.0289C15.7581 36.9074 15.9074 36.7581 16.0289 36.5873C16.1499 36.4171 16.2384 36.2061 16.52 35.4738L17.625 32.601Z"
        fill="url(#paint1_linear_3199_33799)"
      />
      <path
        opacity="0.7"
        d="M43.0917 14.2804C43.1566 14.1115 43.319 14 43.5 14C43.681 14 43.8434 14.1115 43.9083 14.2804L44.424 15.6211C44.5554 15.9628 44.5967 16.0613 44.6532 16.1408C44.7099 16.2205 44.7795 16.2901 44.8592 16.3468C44.9387 16.4033 45.0372 16.4446 45.3789 16.576L46.7196 17.0917C46.8885 17.1566 47 17.319 47 17.5C47 17.681 46.8885 17.8434 46.7196 17.9083L45.3789 18.424C45.0372 18.5554 44.9387 18.5967 44.8592 18.6532C44.7795 18.7099 44.7099 18.7795 44.6532 18.8592C44.5967 18.9387 44.5554 19.0372 44.424 19.3789L43.9083 20.7196C43.8434 20.8885 43.681 21 43.5 21C43.319 21 43.1566 20.8885 43.0917 20.7196L42.576 19.3789C42.4446 19.0372 42.4033 18.9387 42.3468 18.8592C42.2901 18.7795 42.2205 18.7099 42.1408 18.6532C42.0613 18.5967 41.9628 18.5554 41.6211 18.424L40.2804 17.9083C40.1115 17.8434 40 17.681 40 17.5C40 17.319 40.1115 17.1566 40.2804 17.0917L41.6211 16.576C41.9628 16.4446 42.0613 16.4033 42.1408 16.3468C42.2205 16.2901 42.2901 16.2205 42.3468 16.1408C42.4033 16.0613 42.4446 15.9628 42.576 15.6211L43.0917 14.2804Z"
        fill="url(#paint2_linear_3199_33799)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3199_33799"
          x1="32.2"
          y1="18.9"
          x2="6.3"
          y2="48.3"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#372FAD" />
          <stop offset="1" stopColor="#090369" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3199_33799"
          x1="20.6429"
          y1="33.0714"
          x2="15.2857"
          y2="43.7857"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0.5" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3199_33799"
          x1="44.5"
          y1="14.5"
          x2="42"
          y2="19.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0.5" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export const StarsOutline = () => {
  return (
    <>
      <path
        d="M6.5 13L7.28446 14.5689C7.54995 15.0999 7.68269 15.3654 7.86003 15.5954C8.01739 15.7996 8.20041 15.9826 8.40455 16.14C8.63462 16.3173 8.9001 16.4501 9.43108 16.7155L11 17.5L9.43108 18.2845C8.9001 18.5499 8.63462 18.6827 8.40455 18.86C8.20041 19.0174 8.01739 19.2004 7.86003 19.4046C7.68269 19.6346 7.54995 19.9001 7.28446 20.4311L6.5 22L5.71554 20.4311C5.45005 19.9001 5.31731 19.6346 5.13997 19.4046C4.98261 19.2004 4.79959 19.0174 4.59545 18.86C4.36538 18.6827 4.0999 18.5499 3.56892 18.2845L2 17.5L3.56892 16.7155C4.0999 16.4501 4.36538 16.3173 4.59545 16.14C4.79959 15.9826 4.98261 15.7996 5.13997 15.5954C5.31731 15.3654 5.45005 15.0999 5.71554 14.5689L6.5 13Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 2L16.1786 5.06442C16.4606 5.79765 16.6016 6.16426 16.8209 6.47264C17.0153 6.74595 17.254 6.98475 17.5274 7.17909C17.8357 7.39836 18.2024 7.53937 18.9356 7.82138L22 9L18.9356 10.1786C18.2024 10.4606 17.8357 10.6016 17.5274 10.8209C17.254 11.0153 17.0153 11.254 16.8209 11.5274C16.6016 11.8357 16.4606 12.2024 16.1786 12.9356L15 16L13.8214 12.9356C13.5394 12.2024 13.3984 11.8357 13.1791 11.5274C12.9847 11.254 12.746 11.0153 12.4726 10.8209C12.1643 10.6016 11.7976 10.4606 11.0644 10.1786L8 9L11.0644 7.82138C11.7976 7.53937 12.1643 7.39836 12.4726 7.17909C12.746 6.98475 12.9847 6.74595 13.1791 6.47264C13.3984 6.16426 13.5394 5.79765 13.8214 5.06442L15 2Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const Stars01Icon = () => {
  return (
    <>
      <path
        d="M15.9333 1.64102C15.7848 1.25483 15.4138 1 15 1C14.5862 1 14.2152 1.25483 14.0667 1.64102L12.888 4.70544C12.5876 5.48648 12.4932 5.71155 12.3641 5.89315C12.2345 6.07535 12.0754 6.23455 11.8931 6.36411C11.7116 6.49323 11.4865 6.58763 10.7054 6.88803L7.64102 8.06665C7.25483 8.21519 7 8.58623 7 9C7 9.41377 7.25483 9.78481 7.64102 9.93335L10.7054 11.112C11.4865 11.4124 11.7116 11.5068 11.8931 11.6359C12.0754 11.7655 12.2345 11.9246 12.3641 12.1069C12.4932 12.2884 12.5876 12.5135 12.888 13.2946L14.0667 16.359C14.2152 16.7452 14.5862 17 15 17C15.4138 17 15.7848 16.7452 15.9333 16.359L17.112 13.2946C17.4124 12.5135 17.5068 12.2884 17.6359 12.1069C17.7655 11.9246 17.9246 11.7655 18.1069 11.6359C18.2884 11.5068 18.5135 11.4124 19.2946 11.112L22.359 9.93335C22.7452 9.78481 23 9.41377 23 9C23 8.58623 22.7452 8.21519 22.359 8.06665L19.2946 6.88803C18.5135 6.58763 18.2884 6.49323 18.1069 6.36411C17.9246 6.23455 17.7654 6.07536 17.6359 5.89315C17.5068 5.71155 17.4124 5.48648 17.112 4.70544L15.9333 1.64102Z"
        fill="currentColor"
      />
      <path
        d="M7.39443 12.5528C7.22503 12.214 6.87877 12 6.5 12C6.12123 12 5.77496 12.214 5.60557 12.5528L4.82111 14.1217C4.53863 14.6867 4.45255 14.8493 4.34796 14.9849C4.24305 15.121 4.12104 15.243 3.98494 15.348C3.84925 15.4525 3.68667 15.5386 3.1217 15.8211L1.55279 16.6056C1.214 16.775 1 17.1212 1 17.5C1 17.8788 1.214 18.225 1.55279 18.3944L3.1217 19.1789C3.68667 19.4614 3.84925 19.5475 3.98494 19.652C4.12104 19.757 4.24305 19.879 4.34796 20.0151C4.45255 20.1507 4.53863 20.3133 4.82111 20.8783L5.60557 22.4472C5.77497 22.786 6.12123 23 6.5 23C6.87877 23 7.22504 22.786 7.39443 22.4472L8.17889 20.8783C8.46137 20.3133 8.54745 20.1507 8.65204 20.0151C8.75695 19.879 8.87896 19.757 9.01506 19.652C9.15075 19.5475 9.31333 19.4614 9.8783 19.1789L11.4472 18.3944C11.786 18.225 12 17.8788 12 17.5C12 17.1212 11.786 16.775 11.4472 16.6056L9.8783 15.8211C9.31333 15.5386 9.15075 15.4525 9.01506 15.348C8.87896 15.243 8.75695 15.121 8.65204 14.9849C8.54745 14.8493 8.46137 14.6867 8.17889 14.1217L7.39443 12.5528Z"
        fill="currentColor"
      />
    </>
  )
}

export const Stars = () => {
  return (
    <>
      <path
        d="M5.5 2C5.5 1.44772 5.05228 1 4.5 1C3.94772 1 3.5 1.44772 3.5 2V3.5H2C1.44772 3.5 1 3.94772 1 4.5C1 5.05228 1.44772 5.5 2 5.5H3.5V7C3.5 7.55228 3.94772 8 4.5 8C5.05228 8 5.5 7.55228 5.5 7V5.5H7C7.55228 5.5 8 5.05228 8 4.5C8 3.94772 7.55228 3.5 7 3.5H5.5V2Z"
        fill="currentColor"
      />
      <path
        d="M5.5 17C5.5 16.4477 5.05228 16 4.5 16C3.94772 16 3.5 16.4477 3.5 17V18.5H2C1.44772 18.5 1 18.9477 1 19.5C1 20.0523 1.44772 20.5 2 20.5H3.5V22C3.5 22.5523 3.94772 23 4.5 23C5.05228 23 5.5 22.5523 5.5 22V20.5H7C7.55228 20.5 8 20.0523 8 19.5C8 18.9477 7.55228 18.5 7 18.5H5.5V17Z"
        fill="currentColor"
      />
      <path
        d="M13.9333 2.64102C13.7848 2.25483 13.4138 2 13 2C12.5862 2 12.2152 2.25483 12.0667 2.64102L10.3325 7.14988C10.0321 7.93093 9.93768 8.156 9.80855 8.33759C9.67899 8.5198 9.5198 8.67899 9.33759 8.80855C9.156 8.93768 8.93093 9.03207 8.14988 9.33248L3.64102 11.0667C3.25483 11.2152 3 11.5862 3 12C3 12.4138 3.25483 12.7848 3.64102 12.9333L8.14988 14.6675C8.93093 14.9679 9.156 15.0623 9.33759 15.1914C9.5198 15.321 9.67899 15.4802 9.80855 15.6624C9.93768 15.844 10.0321 16.0691 10.3325 16.8501L12.0667 21.359C12.2152 21.7452 12.5862 22 13 22C13.4138 22 13.7848 21.7452 13.9333 21.359L15.6675 16.8501C15.9679 16.0691 16.0623 15.844 16.1914 15.6624C16.321 15.4802 16.4802 15.321 16.6624 15.1914C16.844 15.0623 17.0691 14.9679 17.8501 14.6675L22.359 12.9333C22.7452 12.7848 23 12.4138 23 12C23 11.5862 22.7452 11.2152 22.359 11.0667L17.8501 9.33248C17.0691 9.03207 16.844 8.93768 16.6624 8.80855C16.4802 8.67899 16.321 8.5198 16.1914 8.33759C16.0623 8.156 15.9679 7.93093 15.6675 7.14988L13.9333 2.64102Z"
        fill="currentColor"
      />
    </>
  )
}

export const Star = () => {
  return (
    <>
      <path
        d="M8.40156 1.8778C8.59363 1.48869 8.68967 1.29413 8.82004 1.23197C8.93347 1.17789 9.06525 1.17789 9.17869 1.23197C9.30906 1.29413 9.4051 1.48869 9.59717 1.8778L11.4194 5.56944C11.4761 5.68432 11.5045 5.74176 11.5459 5.78635C11.5826 5.82584 11.6266 5.85783 11.6754 5.88056C11.7306 5.90623 11.794 5.91549 11.9208 5.93402L15.9968 6.5298C16.4261 6.59253 16.6407 6.6239 16.74 6.72874C16.8264 6.81995 16.8671 6.94529 16.8506 7.06985C16.8317 7.21302 16.6763 7.36436 16.3656 7.66702L13.4172 10.5387C13.3253 10.6282 13.2794 10.673 13.2497 10.7263C13.2235 10.7734 13.2066 10.8252 13.2001 10.8788C13.1928 10.9393 13.2036 11.0025 13.2253 11.129L13.921 15.1851C13.9944 15.6129 14.031 15.8269 13.9621 15.9538C13.9021 16.0642 13.7955 16.1417 13.6719 16.1646C13.5299 16.1909 13.3378 16.0899 12.9536 15.8879L9.30966 13.9716C9.19613 13.9119 9.13936 13.882 9.07955 13.8703C9.0266 13.8599 8.97213 13.8599 8.91918 13.8703C8.85937 13.882 8.8026 13.9119 8.68906 13.9716L5.04512 15.8879C4.66095 16.0899 4.46886 16.1909 4.32683 16.1646C4.20325 16.1417 4.09662 16.0642 4.03663 15.9538C3.96768 15.8269 4.00437 15.6129 4.07774 15.1851L4.77342 11.129C4.79511 11.0025 4.80595 10.9393 4.79862 10.8788C4.79212 10.8252 4.77528 10.7734 4.74902 10.7263C4.71937 10.673 4.67341 10.6282 4.5815 10.5387L1.63315 7.66702C1.3224 7.36436 1.16703 7.21302 1.14812 7.06985C1.13167 6.94529 1.17231 6.81995 1.25872 6.72874C1.35804 6.6239 1.57266 6.59253 2.00189 6.5298L6.07794 5.93402C6.2047 5.91549 6.26808 5.90623 6.32328 5.88056C6.37215 5.85783 6.41615 5.82584 6.45284 5.78635C6.49427 5.74176 6.52262 5.68432 6.57933 5.56944L8.40156 1.8778Z"
        stroke="#838B93"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const StarFilled = () => {
  return (
    <>
      <path
        d="M9.53864 0.481063C9.19834 0.318812 8.803 0.318812 8.4627 0.481063C8.16852 0.621325 8.00633 0.864857 7.92453 0.998458C7.83997 1.13657 7.75317 1.31251 7.66856 1.484L5.87212 5.12341L1.85374 5.71075C1.66458 5.73836 1.47049 5.76669 1.31306 5.80455C1.16076 5.84117 0.879172 5.92038 0.65508 6.15691C0.395837 6.43055 0.273918 6.80656 0.323269 7.18026C0.365928 7.50329 0.547465 7.73266 0.649298 7.85168C0.754563 7.97472 0.895105 8.11155 1.03207 8.2449L3.93857 11.0758L3.25277 15.0744C3.22039 15.2629 3.18718 15.4563 3.17439 15.6178C3.16203 15.774 3.15007 16.0664 3.30566 16.3528C3.48562 16.6842 3.80552 16.9166 4.17624 16.9853C4.49675 17.0447 4.77115 16.9429 4.91585 16.8829C5.06547 16.8208 5.23915 16.7294 5.40845 16.6403L9.00067 14.7512L12.5929 16.6404C12.7622 16.7294 12.9359 16.8208 13.0855 16.8829C13.2302 16.9429 13.5046 17.0447 13.8251 16.9853C14.1958 16.9166 14.5157 16.6842 14.6957 16.3528C14.8513 16.0664 14.8393 15.774 14.827 15.6178C14.8142 15.4563 14.781 15.2629 14.7486 15.0744L14.0628 11.0758L16.9693 8.24487C17.1063 8.11153 17.2468 7.97471 17.352 7.85168C17.4539 7.73266 17.6354 7.50329 17.6781 7.18026C17.7274 6.80656 17.6055 6.43055 17.3463 6.15691C17.1222 5.92038 16.8406 5.84117 16.6883 5.80455C16.5308 5.76669 16.3368 5.73836 16.1476 5.71075L12.1292 5.12341L10.3328 1.48407C10.2482 1.31256 10.1614 1.13658 10.0768 0.998458C9.99502 0.864856 9.83282 0.621325 9.53864 0.481063Z"
        fill="#EF9A00"
      />
    </>
  )
}
export const TagFilled = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.10582 2.69812C1.3455 2.22771 1.72796 1.84526 2.19836 1.60558C2.51368 1.44492 2.84136 1.38548 3.17081 1.35857C3.48295 1.33306 3.86193 1.33308 4.30122 1.33309L8.13153 1.33305C8.47061 1.33273 8.76956 1.33246 9.05993 1.40217C9.31502 1.46341 9.55888 1.56442 9.78256 1.70149C10.0372 1.85752 10.2484 2.06911 10.4879 2.3091L16.9518 8.77306C17.4262 9.2474 17.8177 9.63887 18.1105 9.98383C18.4147 10.3421 18.6611 10.7047 18.8013 11.1364C19.0188 11.8058 19.0188 12.527 18.8013 13.1965C18.6611 13.6282 18.4147 13.9907 18.1105 14.349C17.8177 14.694 17.4262 15.0854 16.9518 15.5598L15.06 17.4516C14.5857 17.9259 14.1942 18.3174 13.8493 18.6103C13.491 18.9144 13.1284 19.1608 12.6967 19.3011C12.0272 19.5186 11.3061 19.5186 10.6366 19.3011C10.2049 19.1608 9.84236 18.9144 9.48408 18.6103C9.13912 18.3174 8.74765 17.9259 8.27332 17.4516L1.80934 10.9877C1.56936 10.7481 1.35777 10.5369 1.20174 10.2823C1.06466 10.0586 0.963654 9.81477 0.902412 9.55968C0.8327 9.26931 0.832978 8.97035 0.833294 8.63127L0.833336 4.80097C0.833321 4.36168 0.833309 3.98271 0.858812 3.67057C0.885729 3.34111 0.945159 3.01343 1.10582 2.69812ZM6.66669 5.49967C5.74621 5.49967 5.00002 6.24587 5.00002 7.16634C5.00002 8.08682 5.74621 8.83301 6.66669 8.83301C7.58716 8.83301 8.33335 8.08682 8.33335 7.16634C8.33335 6.24587 7.58716 5.49967 6.66669 5.49967Z"
        fill="currentColor"
      />
    </>
  )
}
export const TagOutline = () => {
  return (
    <>
      <path
        d="M8 8H8.01M2 5.2L2 9.67451C2 10.1637 2 10.4083 2.05526 10.6385C2.10425 10.8425 2.18506 11.0376 2.29472 11.2166C2.4184 11.4184 2.59135 11.5914 2.93726 11.9373L10.6059 19.6059C11.7939 20.7939 12.388 21.388 13.0729 21.6105C13.6755 21.8063 14.3245 21.8063 14.927 21.6105C15.612 21.388 16.2061 20.7939 17.3941 19.6059L19.6059 17.3941C20.7939 16.2061 21.388 15.612 21.6105 14.927C21.8063 14.3245 21.8063 13.6755 21.6105 13.0729C21.388 12.388 20.7939 11.7939 19.6059 10.6059L11.9373 2.93726C11.5914 2.59135 11.4184 2.4184 11.2166 2.29472C11.0376 2.18506 10.8425 2.10425 10.6385 2.05526C10.4083 2 10.1637 2 9.67452 2L5.2 2C4.0799 2 3.51984 2 3.09202 2.21799C2.7157 2.40973 2.40973 2.71569 2.21799 3.09202C2 3.51984 2 4.07989 2 5.2ZM8.5 8C8.5 8.27614 8.27614 8.5 8 8.5C7.72386 8.5 7.5 8.27614 7.5 8C7.5 7.72386 7.72386 7.5 8 7.5C8.27614 7.5 8.5 7.72386 8.5 8Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const Archive = () => {
  return (
    <>
      <path
        d="M3.33268 5.66383C3.19601 5.6603 3.09676 5.65239 3.00753 5.63464C2.34638 5.50313 1.82955 4.9863 1.69804 4.32515C1.66602 4.16415 1.66602 3.97055 1.66602 3.58333C1.66602 3.19612 1.66602 3.00251 1.69804 2.84152C1.82955 2.18037 2.34638 1.66354 3.00753 1.53202C3.16853 1.5 3.36214 1.5 3.74935 1.5H16.2493C16.6366 1.5 16.8302 1.5 16.9912 1.53202C17.6523 1.66354 18.1691 2.18037 18.3007 2.84152C18.3327 3.00251 18.3327 3.19612 18.3327 3.58333C18.3327 3.97055 18.3327 4.16415 18.3007 4.32515C18.1691 4.9863 17.6523 5.50313 16.9912 5.63464C16.9019 5.65239 16.8027 5.6603 16.666 5.66383M8.33268 9.83333H11.666M3.33268 5.66667H16.666V12.5C16.666 13.9001 16.666 14.6002 16.3935 15.135C16.1538 15.6054 15.7714 15.9878 15.301 16.2275C14.7662 16.5 14.0661 16.5 12.666 16.5H7.33268C5.93255 16.5 5.23249 16.5 4.69771 16.2275C4.2273 15.9878 3.84485 15.6054 3.60517 15.135C3.33268 14.6002 3.33268 13.9001 3.33268 12.5V5.66667Z"
        stroke="#838B93"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const ArchiveFilled = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.833984 3.16797C0.833984 1.78726 1.95327 0.667969 3.33398 0.667969H16.6673C18.048 0.667969 19.1673 1.78726 19.1673 3.16797C19.1673 4.54868 18.048 5.66797 16.6673 5.66797H3.33398C1.95327 5.66797 0.833984 4.54868 0.833984 3.16797Z"
        fill="#838B93"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.33398 7.33464C2.87375 7.33464 2.50065 7.70773 2.50065 8.16797V12.5357C2.50064 13.2065 2.50063 13.7602 2.53748 14.2112C2.57575 14.6796 2.65789 15.1102 2.86396 15.5146C3.18354 16.1418 3.69348 16.6517 4.32068 16.9713C4.72513 17.1774 5.15571 17.2595 5.62413 17.2978C6.07512 17.3347 6.62875 17.3346 7.29955 17.3346H12.7018C13.3726 17.3346 13.9262 17.3347 14.3772 17.2978C14.8456 17.2595 15.2762 17.1774 15.6806 16.9713C16.3078 16.6517 16.8178 16.1418 17.1373 15.5146C17.3434 15.1102 17.4256 14.6796 17.4638 14.2112C17.5007 13.7602 17.5007 13.2065 17.5006 12.5357V8.16797C17.5006 7.70773 17.1276 7.33464 16.6673 7.33464H3.33398ZM8.33398 9.83464C7.87375 9.83464 7.50065 10.2077 7.50065 10.668C7.50065 11.1282 7.87375 11.5013 8.33398 11.5013H11.6673C12.1276 11.5013 12.5007 11.1282 12.5007 10.668C12.5007 10.2077 12.1276 9.83464 11.6673 9.83464H8.33398Z"
        fill="#838B93"
      />
    </>
  )
}

export const User = () => {
  return (
    <>
      <path
        d="M20 21.5C20 20.1044 20 19.4067 19.8278 18.8389C19.44 17.5605 18.4395 16.56 17.1611 16.1722C16.5933 16 15.8956 16 14.5 16H9.5C8.10444 16 7.40665 16 6.83886 16.1722C5.56045 16.56 4.56004 17.5605 4.17224 18.8389C4 19.4067 4 20.1044 4 21.5M16.5 8C16.5 10.4853 14.4853 12.5 12 12.5C9.51472 12.5 7.5 10.4853 7.5 8C7.5 5.51472 9.51472 3.5 12 3.5C14.4853 3.5 16.5 5.51472 16.5 8Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const Users = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.1063 15.388C17.3542 14.8945 17.9552 14.6954 18.4487 14.9433C20.0832 15.7644 21.4648 17.0715 22.4647 18.6822C22.6162 18.9262 22.8367 19.2521 22.9051 19.6937C22.9784 20.1665 22.8501 20.6186 22.6589 20.9624C22.4676 21.3061 22.1512 21.6536 21.7108 21.8407C21.2922 22.0186 20.8368 22 20.4998 22C19.9476 22 19.4998 21.5523 19.4998 21C19.4998 20.4477 19.9476 20 20.4998 20C20.715 20 20.8282 19.9994 20.9089 19.9939L20.911 19.9902C20.9302 19.9558 20.7849 19.7683 20.7655 19.737C19.9432 18.4124 18.8283 17.3722 17.551 16.7305C17.0574 16.4826 16.8583 15.8815 17.1063 15.388Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.1043 3.02273C15.3501 2.52815 15.9503 2.32646 16.4449 2.57225C18.2534 3.47103 19.4998 5.33904 19.4998 7.5C19.4998 9.66096 18.2534 11.529 16.4449 12.4278C15.9503 12.6735 15.3501 12.4719 15.1043 11.9773C14.8585 11.4827 15.0602 10.8825 15.5548 10.6367C16.7097 10.0628 17.4998 8.87276 17.4998 7.5C17.4998 6.12724 16.7097 4.9372 15.5548 4.36327C15.0602 4.11749 14.8585 3.51731 15.1043 3.02273Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.99985 7.5C3.99985 4.46243 6.46228 2 9.49985 2C12.5374 2 14.9998 4.46243 14.9998 7.5C14.9998 10.5376 12.5374 13 9.49985 13C6.46228 13 3.99985 10.5376 3.99985 7.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.49985 14C12.6961 14 15.5534 15.8041 17.297 18.4201C17.4506 18.6506 17.6144 18.8964 17.7289 19.13C17.8668 19.4111 17.9658 19.7341 17.9426 20.1198C17.9242 20.4275 17.8221 20.7129 17.7008 20.9395C17.5794 21.1661 17.3984 21.4093 17.1526 21.5952C16.8233 21.8442 16.4684 21.9315 16.1547 21.968C15.8785 22.0001 15.5513 22.0001 15.2218 22C11.4086 21.9993 7.59254 21.9993 3.77792 22C3.44837 22.0001 3.12123 22.0001 2.84499 21.968C2.53129 21.9315 2.1764 21.8442 1.84709 21.5952C1.60126 21.4093 1.42028 21.1661 1.29894 20.9395C1.1776 20.7129 1.07554 20.4275 1.05708 20.1198C1.03392 19.7341 1.13292 19.4111 1.27077 19.13C1.3853 18.8964 1.54911 18.6506 1.70272 18.4201C3.4463 15.8041 6.30361 14 9.49985 14Z"
        fill="currentColor"
      />
    </>
  )
}

export const UserCircle = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 9.5C7 6.73858 9.23858 4.5 12 4.5C14.7614 4.5 17 6.73858 17 9.5C17 12.2614 14.7614 14.5 12 14.5C9.23858 14.5 7 12.2614 7 9.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 14.2211 20.1954 16.2543 18.8618 17.824C17.9457 16.7114 16.5564 16 15 16H9.00005C7.44368 16 6.05439 16.7114 5.13825 17.8241C3.8046 16.2543 3 14.2211 3 12Z"
        fill="currentColor"
      />
    </>
  )
}

export const UserCheck = () => {
  return (
    <>
      <path
        d="M12 15.5H7.5C6.10444 15.5 5.40665 15.5 4.83886 15.6722C3.56045 16.06 2.56004 17.0605 2.17224 18.3389C2 18.9067 2 19.6044 2 21M16 18L18 20L22 16M14.5 7.5C14.5 9.98528 12.4853 12 10 12C7.51472 12 5.5 9.98528 5.5 7.5C5.5 5.01472 7.51472 3 10 3C12.4853 3 14.5 5.01472 14.5 7.5Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const UsersUp = () => {
  return (
    <>
      <path
        d="M19.7074 14.2929C19.5198 14.1054 19.2655 14 19.0002 14C18.735 14 18.4807 14.1054 18.2931 14.2929L15.2931 17.2929C14.9026 17.6834 14.9026 18.3166 15.2931 18.7071C15.6837 19.0976 16.3168 19.0976 16.7074 18.7071L18.0002 17.4142V21C18.0002 21.5523 18.448 22 19.0002 22C19.5525 22 20.0002 21.5523 20.0002 21V17.4142L21.2931 18.7071C21.6837 19.0976 22.3168 19.0976 22.7073 18.7071C23.0979 18.3166 23.0979 17.6834 22.7073 17.2929L19.7074 14.2929Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1812 14.1635C12.4635 14.3073 12.693 14.5368 12.8368 14.819C12.9898 15.1194 13.0004 15.4476 13.0003 15.7769C13.0003 15.7847 13.0003 15.7924 13.0003 15.8C13.0003 17.2744 12.9997 18.7488 13.0003 20.2231C13.0003 20.3422 13.0004 20.4845 12.9901 20.6098C12.9783 20.755 12.9478 20.963 12.8368 21.181C12.693 21.4632 12.4635 21.6927 12.1812 21.8365C11.9633 21.9476 11.7553 21.978 11.6101 21.9899C11.4848 22.0001 11.3425 22.0001 11.2234 22C8.40795 21.999 5.5925 21.999 2.77706 22C2.6578 22.0001 2.51523 22.0001 2.3896 21.9898C2.24388 21.9778 2.03547 21.9472 1.81719 21.8356C1.53459 21.6911 1.30452 21.46 1.16133 21.1767C1.05103 20.9585 1.02112 20.7506 1.00975 20.6046C0.999981 20.4791 1.00069 20.3369 1.00127 20.2185C1.00643 19.1792 0.975447 18.0653 1.38085 17.0866C1.88832 15.8614 2.86169 14.8881 4.08683 14.3806C4.59653 14.1695 5.13481 14.0819 5.74356 14.0404C6.33557 14 7.06298 14 7.96474 14C9.05095 14 10.1372 14.0004 11.2234 14C11.5527 13.9999 11.8808 14.0104 12.1812 14.1635Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5733 2.91554C14.7805 2.40361 15.3635 2.1566 15.8755 2.36382C17.706 3.10481 19.0003 4.90006 19.0003 7C19.0003 9.09994 17.706 10.8952 15.8755 11.6362C15.3635 11.8434 14.7805 11.5964 14.5733 11.0845C14.3661 10.5725 14.6131 9.98953 15.125 9.7823C16.2263 9.33652 17.0003 8.25744 17.0003 7C17.0003 5.74256 16.2263 4.66348 15.125 4.2177C14.6131 4.01047 14.3661 3.42748 14.5733 2.91554Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.50025 7C4.50025 4.23858 6.73883 2 9.50025 2C12.2617 2 14.5003 4.23858 14.5003 7C14.5003 9.76142 12.2617 12 9.50025 12C6.73883 12 4.50025 9.76142 4.50025 7Z"
        fill="currentColor"
      />
    </>
  )
}
export const UserUpFilled = () => {
  return (
    <>
      <path
        d="M19.7069 2.29289C19.5193 2.10536 19.265 2 18.9998 2C18.7345 2 18.4802 2.10536 18.2926 2.29289L15.2926 5.29289C14.9021 5.68342 14.9021 6.31658 15.2926 6.70711C15.6832 7.09763 16.3163 7.09763 16.7069 6.70711L17.9998 5.41421V9C17.9998 9.55228 18.4475 10 18.9998 10C19.552 10 19.9998 9.55228 19.9998 9V5.41421L21.2926 6.70711C21.6832 7.09763 22.3163 7.09763 22.7069 6.70711C23.0974 6.31658 23.0974 5.68342 22.7069 5.29289L19.7069 2.29289Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.7584 14H11.241C12.046 14 12.7103 14 13.2515 14.0442C13.8136 14.0901 14.3303 14.1887 14.8157 14.436C15.5683 14.8195 16.1802 15.4314 16.5637 16.184C16.811 16.6694 16.9096 17.1861 16.9555 17.7482C16.9997 18.2894 16.9997 18.9537 16.9997 19.7587C16.9997 20.0414 17.0126 20.3278 16.9896 20.6098C16.9777 20.755 16.9473 20.963 16.8362 21.181C16.6924 21.4632 16.4629 21.6927 16.1807 21.8365C15.9627 21.9476 15.7547 21.978 15.6095 21.9899C15.4842 22.0001 15.342 22.0001 15.2228 22C11.0741 21.9985 6.92532 21.9985 2.77656 22C2.65744 22.0001 2.51519 22.0001 2.38987 21.9899C2.24465 21.978 2.03666 21.9476 1.81871 21.8365C1.53647 21.6927 1.307 21.4632 1.16319 21.181C1.05214 20.963 1.0217 20.755 1.00983 20.6098C0.986791 20.3278 0.999697 20.0413 0.999697 19.7587C0.999684 18.9537 0.999674 18.2894 1.04389 17.7482C1.08982 17.1861 1.18838 16.6694 1.43567 16.184C1.81916 15.4314 2.43109 14.8195 3.18374 14.436C3.66907 14.1887 4.18577 14.0901 4.74787 14.0442C5.28907 14 5.95343 14 6.7584 14Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.4997 7.5C4.4997 5.01472 6.51442 3 8.9997 3C11.485 3 13.4997 5.01472 13.4997 7.5C13.4997 9.98528 11.485 12 8.9997 12C6.51442 12 4.4997 9.98528 4.4997 7.5Z"
        fill="currentColor"
      />
    </>
  )
}
export const UsersDownFilled = () => {
  return (
    <>
      <path
        d="M19.0002 14C19.5525 14 20.0002 14.4477 20.0002 15V18.5858L21.2931 17.2929C21.6837 16.9024 22.3168 16.9024 22.7073 17.2929C23.0979 17.6834 23.0979 18.3166 22.7073 18.7071L19.7073 21.7071C19.5198 21.8946 19.2655 22 19.0002 22C18.735 22 18.4807 21.8946 18.2931 21.7071L15.2931 18.7071C14.9026 18.3166 14.9026 17.6834 15.2931 17.2929C15.6837 16.9024 16.3168 16.9024 16.7074 17.2929L18.0002 18.5858V15C18.0002 14.4477 18.448 14 19.0002 14Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1812 14.1635C12.4635 14.3073 12.693 14.5368 12.8368 14.819C12.9898 15.1194 13.0004 15.4476 13.0003 15.7769C13.0003 15.7847 13.0003 15.7924 13.0003 15.8C13.0003 17.2744 12.9997 18.7488 13.0003 20.2231C13.0003 20.3422 13.0004 20.4845 12.9901 20.6098C12.9783 20.755 12.9478 20.963 12.8368 21.181C12.693 21.4632 12.4635 21.6927 12.1812 21.8365C11.9633 21.9476 11.7553 21.978 11.6101 21.9899C11.4848 22.0001 11.3425 22.0001 11.2234 22C8.40795 21.999 5.5925 21.999 2.77706 22C2.6578 22.0001 2.51523 22.0001 2.3896 21.9898C2.24388 21.9778 2.03547 21.9472 1.81719 21.8356C1.53459 21.6911 1.30452 21.46 1.16133 21.1767C1.05103 20.9585 1.02112 20.7506 1.00975 20.6046C0.999981 20.4791 1.00069 20.3369 1.00127 20.2185C1.00643 19.1792 0.975447 18.0653 1.38085 17.0866C1.88832 15.8614 2.86169 14.8881 4.08683 14.3806C4.59653 14.1695 5.13481 14.0819 5.74356 14.0404C6.33557 14 7.06298 14 7.96474 14C9.05095 14 10.1372 14.0004 11.2234 14C11.5527 13.9999 11.8808 14.0104 12.1812 14.1635Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5733 2.91554C14.7805 2.40361 15.3635 2.1566 15.8755 2.36382C17.706 3.10481 19.0003 4.90006 19.0003 7C19.0003 9.09994 17.706 10.8952 15.8755 11.6362C15.3635 11.8434 14.7805 11.5964 14.5733 11.0845C14.3661 10.5725 14.6131 9.98953 15.125 9.7823C16.2263 9.33652 17.0003 8.25744 17.0003 7C17.0003 5.74256 16.2263 4.66348 15.125 4.2177C14.6131 4.01047 14.3661 3.42748 14.5733 2.91554Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.50025 7C4.50025 4.23858 6.73883 2 9.50025 2C12.2617 2 14.5003 4.23858 14.5003 7C14.5003 9.76142 12.2617 12 9.50025 12C6.73883 12 4.50025 9.76142 4.50025 7Z"
        fill="currentColor"
      />
    </>
  )
}

export const UserRight = () => {
  return (
    <>
      <path
        d="M19 21L22 18M22 18L19 15M22 18H16M12 15.5H7.5C6.10444 15.5 5.40665 15.5 4.83886 15.6722C3.56045 16.06 2.56004 17.0605 2.17224 18.3389C2 18.9067 2 19.6044 2 21M14.5 7.5C14.5 9.98528 12.4853 12 10 12C7.51472 12 5.5 9.98528 5.5 7.5C5.5 5.01472 7.51472 3 10 3C12.4853 3 14.5 5.01472 14.5 7.5Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const Minus = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 12C4 11.4477 4.44772 11 5 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H5C4.44772 13 4 12.5523 4 12Z"
        fill="currentColor"
      />
    </>
  )
}

export const Pin = () => {
  return (
    <>
      <path
        d="M8.3767 15.6164L2.71985 21.2733M11.6944 6.64194L10.1335 8.20282C10.0062 8.33015 9.94252 8.39381 9.86999 8.4444C9.80561 8.4893 9.73616 8.52646 9.66309 8.55512C9.58077 8.58741 9.49249 8.60507 9.31592 8.64038L5.65145 9.37327C4.69915 9.56373 4.223 9.65897 4.00024 9.91002C3.80617 10.1287 3.71755 10.4214 3.75771 10.711C3.8038 11.0435 4.14715 11.3869 4.83387 12.0736L11.9196 19.1593C12.6063 19.846 12.9497 20.1894 13.2821 20.2355C13.5718 20.2756 13.8645 20.187 14.0832 19.9929C14.3342 19.7702 14.4294 19.294 14.6199 18.3417L15.3528 14.6773C15.3881 14.5007 15.4058 14.4124 15.4381 14.3301C15.4667 14.257 15.5039 14.1876 15.5488 14.1232C15.5994 14.0507 15.663 13.987 15.7904 13.8597L17.3512 12.2988C17.4326 12.2174 17.4734 12.1767 17.5181 12.1411C17.5578 12.1096 17.5999 12.0811 17.644 12.0559C17.6936 12.0276 17.7465 12.0049 17.8523 11.9595L20.3467 10.8905C21.0744 10.5786 21.4383 10.4227 21.6035 10.1707C21.7481 9.95037 21.7998 9.68187 21.7474 9.4236C21.6875 9.12826 21.4076 8.84834 20.8478 8.28852L15.7047 3.14538C15.1448 2.58555 14.8649 2.30564 14.5696 2.24577C14.3113 2.19341 14.0428 2.24512 13.8225 2.38965C13.5705 2.55493 13.4145 2.91878 13.1027 3.64648L12.0337 6.14084C11.9883 6.24665 11.9656 6.29956 11.9373 6.34917C11.9121 6.39325 11.8836 6.43534 11.852 6.47509C11.8165 6.51983 11.7758 6.56053 11.6944 6.64194Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const PinFilled = () => {
  return (
    <>
      <path
        d="M8.3767 15.6164L2.71985 21.2733M11.6944 6.64194L10.1335 8.20282C10.0062 8.33015 9.94252 8.39381 9.86999 8.4444C9.80561 8.4893 9.73616 8.52646 9.66309 8.55512C9.58077 8.58741 9.49249 8.60507 9.31592 8.64038L5.65145 9.37327C4.69915 9.56373 4.223 9.65897 4.00024 9.91002C3.80617 10.1287 3.71755 10.4214 3.75771 10.711C3.8038 11.0435 4.14715 11.3869 4.83387 12.0736L11.9196 19.1593C12.6063 19.846 12.9497 20.1894 13.2821 20.2355C13.5718 20.2756 13.8645 20.187 14.0832 19.9929C14.3342 19.7702 14.4294 19.294 14.6199 18.3417L15.3528 14.6773C15.3881 14.5007 15.4058 14.4124 15.4381 14.3301C15.4667 14.257 15.5039 14.1876 15.5488 14.1232C15.5994 14.0507 15.663 13.987 15.7904 13.8597L17.3512 12.2988C17.4326 12.2174 17.4734 12.1767 17.5181 12.1411C17.5578 12.1096 17.5999 12.0811 17.644 12.0559C17.6936 12.0276 17.7465 12.0049 17.8523 11.9595L20.3467 10.8905C21.0744 10.5786 21.4383 10.4227 21.6035 10.1707C21.7481 9.95037 21.7998 9.68187 21.7474 9.4236C21.6875 9.12826 21.4076 8.84834 20.8478 8.28852L15.7047 3.14538C15.1448 2.58555 14.8649 2.30564 14.5696 2.24577C14.3113 2.19341 14.0428 2.24512 13.8225 2.38965C13.5705 2.55493 13.4145 2.91878 13.1027 3.64648L12.0337 6.14084C11.9883 6.24665 11.9656 6.29956 11.9373 6.34917C11.9121 6.39325 11.8836 6.43534 11.852 6.47509C11.8165 6.51983 11.7758 6.56053 11.6944 6.64194Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const UserMinus = () => {
  return (
    <path
      d="M16 18H22M12 15.5H7.5C6.10444 15.5 5.40665 15.5 4.83886 15.6722C3.56045 16.06 2.56004 17.0605 2.17224 18.3389C2 18.9067 2 19.6044 2 21M14.5 7.5C14.5 9.98528 12.4853 12 10 12C7.51472 12 5.5 9.98528 5.5 7.5C5.5 5.01472 7.51472 3 10 3C12.4853 3 14.5 5.01472 14.5 7.5Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  )
}

export const Server = () => {
  return (
    <>
      <path
        d="M7.19903 1.5H16.8009C17.5184 1.49999 18.1136 1.49998 18.6024 1.53773C19.1122 1.5771 19.582 1.66155 20.0334 1.87072C20.7383 2.19735 21.3328 2.72216 21.7443 3.38106C22.0078 3.80303 22.1499 4.25869 22.2522 4.75975C22.3315 5.14782 21.87 5.42662 21.5194 5.24237C20.6172 4.76827 19.5899 4.5 18.5 4.5H5.5C4.41006 4.5 3.38277 4.76827 2.48057 5.24238C2.12995 5.42663 1.66851 5.14783 1.74775 4.75975C1.85006 4.25869 1.99213 3.80303 2.25568 3.38106C2.66721 2.72216 3.2617 2.19735 3.96656 1.87072C4.41796 1.66155 4.88772 1.5771 5.3976 1.53773C5.88636 1.49998 6.48153 1.49999 7.19903 1.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.01264 10.6602C1.00426 10.7724 1 10.8857 1 11C1 12.4136 1.65183 13.675 2.67134 14.5C1.65183 15.325 1 16.5864 1 18C1 20.4853 3.01472 22.5 5.5 22.5H18.5C20.9853 22.5 23 20.4853 23 18C23 16.5864 22.3482 15.325 21.3287 14.5C22.3482 13.675 23 12.4136 23 11C23 10.8856 22.9957 10.7723 22.9874 10.6601C22.8136 8.33357 20.8709 6.5 18.5 6.5H5.5C3.12903 6.5 1.18633 8.33365 1.01264 10.6602ZM11 11C11 10.4477 11.4477 10 12 10H18C18.5523 10 19 10.4477 19 11C19 11.5523 18.5523 12 18 12H12C11.4477 12 11 11.5523 11 11ZM11 18C11 17.4477 11.4477 17 12 17H18C18.5523 17 19 17.4477 19 18C19 18.5523 18.5523 19 18 19H12C11.4477 19 11 18.5523 11 18ZM6 9.75C5.30964 9.75 4.75 10.3096 4.75 11C4.75 11.6904 5.30964 12.25 6 12.25C6.69036 12.25 7.25 11.6904 7.25 11C7.25 10.3096 6.69036 9.75 6 9.75ZM4.75 18C4.75 17.3096 5.30964 16.75 6 16.75C6.69036 16.75 7.25 17.3096 7.25 18C7.25 18.6904 6.69036 19.25 6 19.25C5.30964 19.25 4.75 18.6904 4.75 18Z"
        fill="currentColor"
      />
    </>
  )
}

export const Funnel = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.02211 1.33399C3.0321 1.33399 3.04213 1.33399 3.05219 1.33399L12.9775 1.33399C13.3299 1.33397 13.6387 1.33395 13.881 1.35574C14.1135 1.37664 14.4325 1.42572 14.691 1.63917C15.0121 1.90428 15.1909 2.30417 15.1744 2.72023C15.1611 3.05521 14.9849 3.32569 14.8455 3.5129C14.7001 3.708 14.4942 3.93812 14.2593 4.20067L10.4351 8.4748C10.3812 8.535 10.3545 8.56501 10.336 8.58759L10.3346 8.58926L10.3345 8.59142C10.3333 8.6206 10.3332 8.66075 10.3332 8.74152V12.3062C10.3332 12.3135 10.3333 12.322 10.3334 12.3316C10.3343 12.4233 10.3364 12.6135 10.2701 12.7912C10.2143 12.9406 10.1237 13.0745 10.0057 13.1817C9.86534 13.3092 9.68794 13.378 9.60247 13.4112C9.59354 13.4146 9.58561 13.4177 9.57883 13.4204L7.29354 14.3345C7.18763 14.3769 7.07054 14.4238 6.96725 14.4546C6.85613 14.4878 6.67359 14.5311 6.46304 14.4874C6.20503 14.4338 5.97861 14.2805 5.833 14.0608C5.71419 13.8816 5.68665 13.696 5.67616 13.5805C5.66642 13.4732 5.66646 13.347 5.66649 13.2329L5.6665 8.74152C5.6665 8.66075 5.66636 8.6206 5.66511 8.59142L5.66502 8.58926L5.66365 8.58759C5.64512 8.56501 5.61845 8.535 5.56459 8.4748L1.76044 4.2231C1.75373 4.2156 1.74704 4.20813 1.74038 4.20068C1.50544 3.93813 1.29952 3.708 1.15418 3.5129C1.01473 3.32569 0.838574 3.05521 0.825271 2.72023C0.808749 2.30417 0.987543 1.90428 1.30862 1.63917C1.56714 1.42572 1.88617 1.37664 2.11867 1.35574C2.36098 1.33395 2.66979 1.33397 3.02211 1.33399Z"
        fill="currentColor"
      />
    </>
  )
}

export const ToggleSwitcher = () => {
  return (
    <>
      <path
        d="M14.126 9L3 9C2.44772 9 2 8.55228 2 8C2 7.44772 2.44772 7 3 7L14.126 7C14.5701 5.27477 16.1362 4 18 4C20.2091 4 22 5.79086 22 8C22 10.2091 20.2091 12 18 12C16.1362 12 14.5701 10.7252 14.126 9Z"
        fill="currentColor"
      />
      <path
        d="M6 12C3.79086 12 2 13.7909 2 16C2 18.2091 3.79086 20 6 20C7.86384 20 9.42994 18.7252 9.87398 17L21 17C21.5523 17 22 16.5523 22 16C22 15.4477 21.5523 15 21 15L9.87398 15C9.42994 13.2748 7.86384 12 6 12Z"
        fill="currentColor"
      />
    </>
  )
}
export const ToggleSwitcherFilled = () => {
  return (
    <>
      <path
        d="M2 5.33398L10 5.33399M10 5.33399C10 6.43855 10.8954 7.33398 12 7.33398C13.1046 7.33398 14 6.43855 14 5.33398C14 4.22941 13.1046 3.33398 12 3.33398C10.8954 3.33398 10 4.22942 10 5.33399ZM6 10.6673L14 10.6673M6 10.6673C6 11.7719 5.10457 12.6673 4 12.6673C2.89543 12.6673 2 11.7719 2 10.6673C2 9.56275 2.89543 8.66732 4 8.66732C5.10457 8.66732 6 9.56275 6 10.6673Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const QuestionCircle = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99967 0.833252C4.93706 0.833252 0.833008 4.93731 0.833008 9.99992C0.833008 15.0625 4.93706 19.1666 9.99967 19.1666C15.0623 19.1666 19.1663 15.0625 19.1663 9.99992C19.1663 4.93731 15.0623 0.833252 9.99967 0.833252ZM9.08853 6.89261C9.42787 6.69318 9.82683 6.62028 10.2148 6.68682C10.6027 6.75336 10.9546 6.95505 11.208 7.25616C11.4615 7.55727 11.6003 7.93838 11.5997 8.33198L11.5997 8.33322C11.5997 8.72416 11.2954 9.13173 10.7208 9.51484C10.4588 9.68949 10.1909 9.82404 9.98518 9.91546C9.88351 9.96064 9.79995 9.99401 9.74376 10.0154C9.71883 10.0249 9.69378 10.0341 9.66861 10.0429C9.23255 10.1888 8.99699 10.6604 9.14243 11.0967C9.28797 11.5334 9.75991 11.7693 10.1965 11.6238L10.3371 11.5729C10.4176 11.5422 10.5294 11.4975 10.6621 11.4385C10.9251 11.3216 11.2822 11.1436 11.6453 10.9016C12.3205 10.4515 13.266 9.60927 13.2663 8.33398C13.2674 7.54695 12.9899 6.78493 12.4831 6.18283C11.9761 5.5806 11.2724 5.17722 10.4965 5.04414C9.72066 4.91106 8.92273 5.05686 8.24406 5.45572C7.56539 5.85458 7.04978 6.48076 6.78856 7.22335C6.63583 7.65751 6.86398 8.13327 7.29813 8.286C7.73229 8.43872 8.20805 8.21058 8.36078 7.77642C8.49139 7.40513 8.7492 7.09204 9.08853 6.89261ZM9.99967 13.3332C9.53943 13.3332 9.16634 13.7063 9.16634 14.1666C9.16634 14.6268 9.53943 14.9999 9.99967 14.9999H10.008C10.4682 14.9999 10.8413 14.6268 10.8413 14.1666C10.8413 13.7063 10.4682 13.3332 10.008 13.3332H9.99967Z"
        fill="currentColor"
      />
    </>
  )
}
export const QuestionCircleFilled = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99935 0.666016C3.94926 0.666016 0.666016 3.94926 0.666016 7.99935C0.666016 12.0494 3.94926 15.3327 7.99935 15.3327C12.0494 15.3327 15.3327 12.0494 15.3327 7.99935C15.3327 3.94926 12.0494 0.666016 7.99935 0.666016ZM7.27044 5.5135C7.5419 5.35396 7.86108 5.29564 8.17142 5.34887C8.48177 5.4021 8.76326 5.56345 8.96605 5.80434C9.16883 6.04523 9.27981 6.35012 9.27935 6.665L9.27934 6.66599C9.27934 6.97875 9.03594 7.3048 8.57621 7.61129C8.36663 7.75101 8.15231 7.85865 7.98775 7.93178C7.90642 7.96793 7.83957 7.99462 7.79462 8.01175C7.77467 8.01935 7.75464 8.0267 7.7345 8.03377C7.38565 8.15047 7.1972 8.52774 7.31356 8.87681C7.42999 9.2261 7.80753 9.41488 8.15683 9.29844L8.26928 9.25773C8.3337 9.23319 8.4231 9.19738 8.52927 9.1502C8.73971 9.05667 9.02539 8.9143 9.31581 8.72069C9.85597 8.36058 10.6124 7.68683 10.6127 6.6666C10.6135 6.03698 10.3916 5.42736 9.98608 4.94567C9.58051 4.46389 9.01753 4.14119 8.39683 4.03473C7.77614 3.92826 7.13779 4.0449 6.59486 4.36399C6.05192 4.68308 5.63944 5.18402 5.43046 5.77809C5.30827 6.12542 5.49079 6.50603 5.83812 6.62821C6.18544 6.75039 6.56605 6.56788 6.68823 6.22055C6.79273 5.92352 6.99897 5.67304 7.27044 5.5135ZM7.99934 10.666C7.63115 10.666 7.33268 10.9645 7.33268 11.3327C7.33268 11.7008 7.63115 11.9993 7.99934 11.9993H8.00601C8.3742 11.9993 8.67268 11.7008 8.67268 11.3327C8.67268 10.9645 8.3742 10.666 8.00601 10.666H7.99934Z"
        fill="currentColor"
      />
    </>
  )
}

export const QuestionCircleOutline = () => {
  return (
    <>
      <path
        d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M9.09 9C9.3251 8.33167 9.789 7.76811 10.4005 7.40913C11.012 7.05016 11.7479 6.91894 12.4713 7.03871C13.1947 7.15849 13.8596 7.52152 14.3564 8.06353C14.8532 8.60553 15.1467 9.29152 15.19 10C15.19 12 12.19 13 12.19 13"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M12 17H12.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </>
  )
}

export const SettingCog = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.11886 17.9617L7.5751 16.7568C7.38136 16.3267 7.05416 15.9684 6.64057 15.7332C6.22675 15.498 5.74802 15.3978 5.27289 15.447L3.94243 15.5865C3.54642 15.6275 3.14683 15.5546 2.79201 15.3765C2.43719 15.1985 2.14233 14.9229 1.94312 14.5833C1.74385 14.2436 1.64891 13.8542 1.66983 13.4625C1.69075 13.0707 1.82663 12.6933 2.06097 12.3761L2.8487 11.3097C3.12963 10.9291 3.28091 10.4705 3.28082 9.99992C3.28091 9.52929 3.12963 9.07074 2.8487 8.6901L2.06097 7.62371C1.82663 7.30653 1.69075 6.92915 1.66983 6.53737C1.64891 6.14559 1.74385 5.75625 1.94312 5.41658C2.14214 5.07672 2.43695 4.80103 2.79183 4.62296C3.1467 4.44489 3.54639 4.37207 3.94243 4.41334L5.27703 4.55288C5.75215 4.60204 6.23088 4.50186 6.64471 4.26668C7.05675 4.03082 7.38244 3.6725 7.5751 3.24307L8.11886 2.03816C8.28051 1.67949 8.54431 1.37474 8.87828 1.16087C9.21224 0.946994 9.60201 0.833188 10.0003 0.833252C10.3986 0.833188 10.7884 0.946994 11.1224 1.16087C11.4563 1.37474 11.7201 1.67949 11.8818 2.03816L12.4297 3.24307C12.6223 3.6725 12.948 4.03082 13.3601 4.26668C13.7739 4.50186 14.2526 4.60204 14.7278 4.55288L16.0582 4.41334C16.4543 4.37207 16.8539 4.44489 17.2088 4.62296C17.5637 4.80103 17.8585 5.07672 18.0575 5.41658C18.2568 5.75625 18.3517 6.14559 18.3308 6.53737C18.3099 6.92915 18.174 7.30653 17.9397 7.62371L17.1519 8.6901C16.871 9.07074 16.7197 9.52929 16.7198 9.99992C16.7174 10.4718 16.8673 10.9323 17.1478 11.3148L17.9355 12.3812C18.1699 12.6984 18.3058 13.0758 18.3267 13.4676C18.3476 13.8593 18.2527 14.2487 18.0534 14.5883C17.8544 14.9282 17.5596 15.2039 17.2047 15.382C16.8498 15.56 16.4501 15.6329 16.0541 15.5916L14.7236 15.452C14.2485 15.4029 13.7698 15.5031 13.3559 15.7383C12.9447 15.9728 12.6191 16.3292 12.4256 16.7568L11.8818 17.9617C11.7201 18.3203 11.4563 18.6251 11.1224 18.839C10.7884 19.0528 10.3986 19.1666 10.0003 19.1666C9.60201 19.1666 9.21224 19.0528 8.87828 18.839C8.54431 18.6251 8.28051 18.3203 8.11886 17.9617ZM12.5003 9.99992C12.5003 11.3806 11.381 12.4999 10.0003 12.4999C8.61961 12.4999 7.50033 11.3806 7.50033 9.99992C7.50033 8.61921 8.61961 7.49992 10.0003 7.49992C11.381 7.49992 12.5003 8.61921 12.5003 9.99992Z"
        fill="currentColor"
      />
    </>
  )
}

export const CheckVerified2 = () => {
  return (
    <>
      <path
        d="M9 12L11 14L15.5 9.5M17.9012 4.99851C18.1071 5.49653 18.5024 5.8924 19.0001 6.09907L20.7452 6.82198C21.2433 7.02828 21.639 7.42399 21.8453 7.92206C22.0516 8.42012 22.0516 8.97974 21.8453 9.47781L21.1229 11.2218C20.9165 11.7201 20.9162 12.2803 21.1236 12.7783L21.8447 14.5218C21.9469 14.7685 21.9996 15.0329 21.9996 15.2999C21.9997 15.567 21.9471 15.8314 21.8449 16.0781C21.7427 16.3249 21.5929 16.549 21.4041 16.7378C21.2152 16.9266 20.991 17.0764 20.7443 17.1785L19.0004 17.9009C18.5023 18.1068 18.1065 18.5021 17.8998 18.9998L17.1769 20.745C16.9706 21.2431 16.575 21.6388 16.0769 21.8451C15.5789 22.0514 15.0193 22.0514 14.5212 21.8451L12.7773 21.1227C12.2792 20.9169 11.7198 20.9173 11.2221 21.1239L9.47689 21.8458C8.97912 22.0516 8.42001 22.0514 7.92237 21.8453C7.42473 21.6391 7.02925 21.2439 6.82281 20.7464L6.09972 19.0006C5.8938 18.5026 5.49854 18.1067 5.00085 17.9L3.25566 17.1771C2.75783 16.9709 2.36226 16.5754 2.15588 16.0777C1.94951 15.5799 1.94923 15.0205 2.1551 14.5225L2.87746 12.7786C3.08325 12.2805 3.08283 11.7211 2.8763 11.2233L2.15497 9.47678C2.0527 9.2301 2.00004 8.96568 2 8.69863C1.99996 8.43159 2.05253 8.16715 2.15472 7.92043C2.25691 7.67372 2.40671 7.44955 2.59557 7.26075C2.78442 7.07195 3.00862 6.92222 3.25537 6.8201L4.9993 6.09772C5.49687 5.89197 5.89248 5.4972 6.0993 5.00006L6.82218 3.25481C7.02848 2.75674 7.42418 2.36103 7.92222 2.15473C8.42027 1.94842 8.97987 1.94842 9.47792 2.15473L11.2218 2.87712C11.7199 3.08291 12.2793 3.08249 12.7771 2.87595L14.523 2.15585C15.021 1.94966 15.5804 1.9497 16.0784 2.15597C16.5763 2.36223 16.972 2.75783 17.1783 3.25576L17.9014 5.00153L17.9012 4.99851Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const DotsHorizontal = () => {
  return (
    <>
      <path
        d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const DotsVertical = () => {
  return (
    <>
      <path
        d="M10.0003 10.8333C10.4606 10.8333 10.8337 10.4602 10.8337 9.99992C10.8337 9.53968 10.4606 9.16658 10.0003 9.16658C9.54009 9.16658 9.16699 9.53968 9.16699 9.99992C9.16699 10.4602 9.54009 10.8333 10.0003 10.8333Z"
        fill="currentColor"
      />
      <path
        d="M10.0003 4.99992C10.4606 4.99992 10.8337 4.62682 10.8337 4.16659C10.8337 3.70635 10.4606 3.33325 10.0003 3.33325C9.54009 3.33325 9.16699 3.70635 9.16699 4.16659C9.16699 4.62682 9.54009 4.99992 10.0003 4.99992Z"
        fill="currentColor"
      />
      <path
        d="M10.0003 16.6666C10.4606 16.6666 10.8337 16.2935 10.8337 15.8333C10.8337 15.373 10.4606 14.9999 10.0003 14.9999C9.54009 14.9999 9.16699 15.373 9.16699 15.8333C9.16699 16.2935 9.54009 16.6666 10.0003 16.6666Z"
        fill="currentColor"
      />
      <path
        d="M10.0003 10.8333C10.4606 10.8333 10.8337 10.4602 10.8337 9.99992C10.8337 9.53968 10.4606 9.16658 10.0003 9.16658C9.54009 9.16658 9.16699 9.53968 9.16699 9.99992C9.16699 10.4602 9.54009 10.8333 10.0003 10.8333Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0003 4.99992C10.4606 4.99992 10.8337 4.62682 10.8337 4.16659C10.8337 3.70635 10.4606 3.33325 10.0003 3.33325C9.54009 3.33325 9.16699 3.70635 9.16699 4.16659C9.16699 4.62682 9.54009 4.99992 10.0003 4.99992Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0003 16.6666C10.4606 16.6666 10.8337 16.2935 10.8337 15.8333C10.8337 15.373 10.4606 14.9999 10.0003 14.9999C9.54009 14.9999 9.16699 15.373 9.16699 15.8333C9.16699 16.2935 9.54009 16.6666 10.0003 16.6666Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const Internet = () => {
  return (
    <>
      <path
        fill="none"
        d="M13.5368 6.46249C15.4895 8.41511 15.4895 11.5809 13.5368 13.5336M6.46577 13.5335C4.51315 11.5809 4.51315 8.41508 6.46577 6.46246M4.10875 15.8906C0.854376 12.6362 0.854376 7.35984 4.10875 4.10547M15.8939 4.10551C19.1482 7.35988 19.1482 12.6363 15.8939 15.8906M11.668 9.99803C11.668 10.9185 10.9218 11.6647 10.0013 11.6647C9.08083 11.6647 8.33464 10.9185 8.33464 9.99803C8.33464 9.07755 9.08083 8.33136 10.0013 8.33136C10.9218 8.33136 11.668 9.07755 11.668 9.99803Z"
        stroke="#0E049D"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const Alert = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8282 1.33203H5.17318C4.63654 1.33202 4.19363 1.33202 3.83283 1.36149C3.4581 1.39211 3.11363 1.45782 2.79007 1.62268C2.28831 1.87834 1.88036 2.28629 1.6247 2.78806C1.45984 3.11161 1.39413 3.45608 1.36351 3.83081C1.33403 4.19161 1.33404 4.63452 1.33405 5.17117L1.33402 9.42375C1.33373 9.95401 1.33352 10.3478 1.42491 10.6889C1.67149 11.6091 2.39029 12.3279 3.31053 12.5745C3.51551 12.6294 3.73951 12.6513 4.00072 12.6599L4.00071 13.5793C4.00068 13.7362 4.00065 13.896 4.01255 14.027C4.02393 14.1523 4.05407 14.3888 4.21917 14.5957C4.40916 14.8337 4.69725 14.9722 5.00179 14.9718C5.26645 14.9715 5.46994 14.8473 5.5749 14.7779C5.68463 14.7054 5.80945 14.6055 5.9319 14.5075L7.54065 13.2205C7.88638 12.9439 7.98902 12.8658 8.09567 12.8113C8.20266 12.7567 8.31654 12.7167 8.43422 12.6926C8.55155 12.6685 8.68047 12.6654 9.12321 12.6654H10.8283C11.3649 12.6654 11.8078 12.6654 12.1686 12.6359C12.5433 12.6053 12.8878 12.5396 13.2114 12.3747C13.7131 12.1191 14.1211 11.7111 14.3767 11.2093C14.5416 10.8858 14.6073 10.5413 14.6379 10.1666C14.6674 9.80579 14.6674 9.36289 14.6674 8.82625V5.17115C14.6674 4.63451 14.6674 4.19161 14.6379 3.83081C14.6073 3.45608 14.5416 3.11161 14.3767 2.78806C14.1211 2.28629 13.7131 1.87834 13.2114 1.62268C12.8878 1.45782 12.5433 1.39211 12.1686 1.36149C11.8078 1.33202 11.3649 1.33202 10.8282 1.33203ZM8.66732 4.66536C8.66732 4.29718 8.36884 3.9987 8.00065 3.9987C7.63246 3.9987 7.33398 4.29718 7.33398 4.66536V6.9987C7.33398 7.36689 7.63246 7.66536 8.00065 7.66536C8.36884 7.66536 8.66732 7.36689 8.66732 6.9987V4.66536ZM8.00065 8.66536C7.63246 8.66536 7.33398 8.96384 7.33398 9.33203C7.33398 9.70022 7.63246 9.9987 8.00065 9.9987H8.00732C8.37551 9.9987 8.67398 9.70022 8.67398 9.33203C8.67398 8.96384 8.37551 8.66536 8.00732 8.66536H8.00065Z"
        fill="#838B93"
      />
    </>
  )
}

export const DoubleArrows = () => {
  return (
    <>
      <path
        d="M5.83333 16.6693V3.33594M5.83333 3.33594L2.5 6.66927M5.83333 3.33594L9.16667 6.66927M14.1667 16.6693V7.5026M14.1667 7.5026L10.8333 10.8359M14.1667 7.5026L17.5 10.8359"
        stroke="#0E049D"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const ArrowsUpDown = () => {
  return (
    <path
      d="M17 4V20M17 20L13 16M17 20L21 16M7 20V4M7 4L3 8M7 4L11 8"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  )
}

export const ChatIcon = () => {
  return (
    <>
      <path
        d="M10 8.75V5.83333M10 11.6667H10.0083M8.25 16L9.46667 17.6222C9.6476 17.8635 9.73807 17.9841 9.84897 18.0272C9.94611 18.065 10.0539 18.065 10.151 18.0272C10.2619 17.9841 10.3524 17.8635 10.5333 17.6222L11.75 16C11.9943 15.6743 12.1164 15.5114 12.2654 15.3871C12.4641 15.2213 12.6986 15.104 12.9504 15.0446C13.1393 15 13.3429 15 13.75 15C14.9149 15 15.4973 15 15.9567 14.8097C16.5693 14.556 17.056 14.0693 17.3097 13.4567C17.5 12.9973 17.5 12.4149 17.5 11.25V6.5C17.5 5.09987 17.5 4.3998 17.2275 3.86502C16.9878 3.39462 16.6054 3.01217 16.135 2.77248C15.6002 2.5 14.9001 2.5 13.5 2.5H6.5C5.09987 2.5 4.3998 2.5 3.86502 2.77248C3.39462 3.01217 3.01217 3.39462 2.77248 3.86502C2.5 4.3998 2.5 5.09987 2.5 6.5V11.25C2.5 12.4149 2.5 12.9973 2.6903 13.4567C2.94404 14.0693 3.43072 14.556 4.04329 14.8097C4.50272 15 5.08515 15 6.25 15C6.65715 15 6.86072 15 7.04959 15.0446C7.30141 15.104 7.53593 15.2213 7.73458 15.3871C7.88357 15.5114 8.00571 15.6743 8.25 16Z"
        stroke="#0E049D"
        strokeWidth="1.25"
        strokeLinecap="round"
        fill="none"
        strokeLinejoin="round"
      />
    </>
  )
}

export const Hand = () => {
  return (
    <>
      <path
        d="M6.9 11.4444V14.2222M6.9 11.4444V4.77778C6.9 3.8573 7.66112 3.11111 8.6 3.11111C9.53888 3.11111 10.3 3.8573 10.3 4.77778M6.9 11.4444C6.9 10.524 6.13888 9.77778 5.2 9.77778C4.26112 9.77778 3.5 10.524 3.5 11.4444V13.6667C3.5 18.269 7.30558 22 12 22C16.6944 22 20.5 18.269 20.5 13.6667V8.11111C20.5 7.19064 19.7389 6.44444 18.8 6.44444C17.8611 6.44444 17.1 7.19064 17.1 8.11111M10.3 4.77778V10.8889M10.3 4.77778V3.66667C10.3 2.74619 11.0611 2 12 2C12.9389 2 13.7 2.74619 13.7 3.66667V4.77778M13.7 4.77778V10.8889M13.7 4.77778C13.7 3.8573 14.4611 3.11111 15.4 3.11111C16.3389 3.11111 17.1 3.8573 17.1 4.77778V8.11111M17.1 8.11111V10.8889"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const ChatNotificationFilled = () => {
  return (
    <>
      <path
        d="M21.1213 2.87868C22.2929 4.05025 22.2929 5.94975 21.1213 7.12132C19.9497 8.29289 18.0503 8.29289 16.8787 7.12132C15.7071 5.94975 15.7071 4.05025 16.8787 2.87868C18.0503 1.70711 19.9497 1.70711 21.1213 2.87868Z"
        fill="currentColor"
      />
      <path
        d="M21.9249 10.2994C21.8819 9.95813 21.8603 9.78753 21.7753 9.67885C21.6962 9.57774 21.6015 9.51995 21.4753 9.49587C21.3398 9.46998 21.1323 9.5457 20.7173 9.69712C18.947 10.343 16.8848 9.95584 15.4645 8.53553C14.0442 7.11523 13.657 5.05305 14.3029 3.28277C14.4543 2.86775 14.53 2.66024 14.5041 2.52469C14.48 2.39858 14.4222 2.30385 14.3211 2.22472C14.2125 2.13968 14.0418 2.11817 13.7006 2.07514C13.3074 2.02555 12.9067 2 12.5 2C7.25334 2 3.00005 6.25329 3.00005 11.5C3.00005 12.56 3.17404 13.5814 3.4958 14.536C3.55239 14.7039 3.58571 14.8033 3.60736 14.8766L3.61444 14.9012L3.61069 14.909C3.58499 14.962 3.54679 15.0332 3.47533 15.1655L1.82345 18.223C1.72107 18.4124 1.61425 18.6101 1.54078 18.7819C1.46776 18.9527 1.34948 19.2661 1.40768 19.6376C1.4759 20.073 1.73218 20.4564 2.10846 20.6859C2.42947 20.8818 2.76426 20.8923 2.95 20.8901C3.13688 20.8879 3.3603 20.8648 3.57447 20.8426L8.72943 20.3097C8.81199 20.3012 8.85515 20.2968 8.88677 20.2944L8.89084 20.2941L8.90321 20.2984C8.94206 20.3124 8.99475 20.3326 9.0857 20.3677C10.1466 20.7764 11.2984 21 12.5 21C17.7468 21 22 16.7467 22 11.5C22 11.0933 21.9745 10.6926 21.9249 10.2994Z"
        fill="currentColor"
      />
    </>
  )
}

export const Rocket = () => {
  return (
    <path
      d="M12.9996 10.9999L3.49964 20.4999M14.0181 3.53838C15.2361 4.34658 16.4068 5.29941 17.5008 6.3934C18.6042 7.49683 19.564 8.67831 20.3767 9.90766M9.2546 7.89605L6.37973 6.93776C6.04865 6.8274 5.68398 6.89763 5.41756 7.12306L2.56041 9.54065C1.97548 10.0356 2.14166 10.9775 2.86064 11.2424L5.56784 12.2398M11.6807 18.3524L12.6781 21.0596C12.943 21.7786 13.8849 21.9448 14.3798 21.3599L16.7974 18.5027C17.0228 18.2363 17.0931 17.8716 16.9827 17.5405L16.0244 14.6657M19.3482 2.27063L14.4418 3.08838C13.9119 3.17668 13.426 3.43709 13.0591 3.82932L6.446 10.8985C4.73185 12.7308 4.77953 15.5924 6.55378 17.3667C8.32803 19.1409 11.1896 19.1886 13.022 17.4744L20.0911 10.8614C20.4834 10.4944 20.7438 10.0085 20.8321 9.47869L21.6498 4.57222C21.8754 3.21858 20.7019 2.04503 19.3482 2.27063Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  )
}

export const SecondChatIcon = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8282 1.33398H5.17318C4.63654 1.33398 4.19363 1.33397 3.83283 1.36345C3.4581 1.39406 3.11363 1.45977 2.79007 1.62463C2.28831 1.8803 1.88036 2.28825 1.6247 2.79001C1.45984 3.11357 1.39413 3.45804 1.36351 3.83277C1.33403 4.19356 1.33404 4.63647 1.33405 5.17312L1.33402 9.4257C1.33373 9.95596 1.33352 10.3497 1.42491 10.6908C1.67149 11.6111 2.39029 12.3299 3.31053 12.5765C3.51551 12.6314 3.73951 12.6532 4.00072 12.6618L4.00071 13.5813C4.00068 13.7381 4.00065 13.898 4.01255 14.029C4.02393 14.1543 4.05407 14.3908 4.21917 14.5976C4.40916 14.8356 4.69725 14.9741 5.00179 14.9738C5.26645 14.9735 5.46994 14.8493 5.5749 14.7799C5.68463 14.7074 5.80945 14.6075 5.9319 14.5095L7.54065 13.2225C7.88638 12.9459 7.98902 12.8678 8.09567 12.8133C8.20266 12.7586 8.31654 12.7187 8.43422 12.6945C8.55155 12.6705 8.68047 12.6673 9.12321 12.6673H10.8283C11.3649 12.6673 11.8078 12.6673 12.1686 12.6379C12.5433 12.6072 12.8878 12.5415 13.2114 12.3767C13.7131 12.121 14.1211 11.7131 14.3767 11.2113C14.5416 10.8877 14.6073 10.5433 14.6379 10.1685C14.6674 9.80774 14.6674 9.36484 14.6674 8.8282V5.1731C14.6674 4.63646 14.6674 4.19356 14.6379 3.83277C14.6073 3.45804 14.5416 3.11357 14.3767 2.79001C14.1211 2.28824 13.7131 1.8803 13.2114 1.62463C12.8878 1.45977 12.5433 1.39406 12.1686 1.36345C11.8078 1.33397 11.3649 1.33398 10.8282 1.33398ZM8.66732 4.66732C8.66732 4.29913 8.36884 4.00065 8.00065 4.00065C7.63246 4.00065 7.33398 4.29913 7.33398 4.66732V7.00065C7.33398 7.36884 7.63246 7.66732 8.00065 7.66732C8.36884 7.66732 8.66732 7.36884 8.66732 7.00065V4.66732ZM8.00065 8.66732C7.63246 8.66732 7.33398 8.96579 7.33398 9.33398C7.33398 9.70218 7.63246 10.0007 8.00065 10.0007H8.00732C8.37551 10.0007 8.67398 9.70218 8.67398 9.33398C8.67398 8.96579 8.37551 8.66732 8.00732 8.66732H8.00065Z"
        fill="currentColor"
      />
    </>
  )
}

export const StatsIcon = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99935 0.666016C3.94926 0.666016 0.666016 3.94926 0.666016 7.99935C0.666016 12.0494 3.94926 15.3327 7.99935 15.3327C12.0494 15.3327 15.3327 12.0494 15.3327 7.99935C15.3327 3.94926 12.0494 0.666016 7.99935 0.666016ZM10.4109 5.3856C10.3026 5.34699 10.1398 5.40127 9.81408 5.50984L6.83899 6.50153C6.74623 6.53245 6.69985 6.54791 6.66134 6.57426C6.62722 6.59759 6.59775 6.62707 6.57441 6.66118C6.54806 6.6997 6.5326 6.74608 6.50168 6.83884L5.50999 9.81393C5.40142 10.1396 5.34714 10.3025 5.38576 10.4108C5.41936 10.505 5.49352 10.5792 5.58776 10.6128C5.69606 10.6514 5.85891 10.5971 6.18461 10.4885L9.1597 9.49685C9.25246 9.46593 9.29883 9.45047 9.33735 9.42413C9.37147 9.40079 9.40094 9.37131 9.42428 9.3372C9.45063 9.29868 9.46609 9.2523 9.49701 9.15954L10.4887 6.18445C10.5973 5.85876 10.6516 5.69591 10.6129 5.58761C10.5793 5.49337 10.5052 5.41921 10.4109 5.3856Z"
        fill="currentColor"
      />
    </>
  )
}

export const Search = () => {
  return (
    <>
      <path
        d="M14 14L11.1 11.1M12.6667 7.33333C12.6667 10.2789 10.2789 12.6667 7.33333 12.6667C4.38781 12.6667 2 10.2789 2 7.33333C2 4.38781 4.38781 2 7.33333 2C10.2789 2 12.6667 4.38781 12.6667 7.33333Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

// for 24 24
export const Search2 = () => {
  return (
    <>
      <path
        d="M21 21L16.65 16.65M11 6C13.7614 6 16 8.23858 16 11M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const Signal = () => {
  return (
    <path
      d="M10.8284 3.17157C12.3905 4.73367 12.3905 7.26632 10.8284 8.82842M5.17158 8.8284C3.60949 7.2663 3.60949 4.73364 5.17158 3.17154M3.28597 10.714C0.68247 8.11055 0.68247 3.88945 3.28597 1.28595M12.7141 1.28598C15.3176 3.88948 15.3176 8.11058 12.7141 10.7141M9.33334 6C9.33334 6.73637 8.73639 7.33333 8.00001 7.33333C7.26363 7.33333 6.66668 6.73637 6.66668 6C6.66668 5.26362 7.26363 4.66666 8.00001 4.66666C8.73639 4.66666 9.33334 5.26362 9.33334 6Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  )
}

export const ArrowsUp = () => {
  return (
    <>
      <path
        d="M5.06666 13.3333V2.66666M5.06666 2.66666L2.39999 5.33332M5.06666 2.66666L7.73333 5.33332M11.7333 13.3333V5.99999M11.7333 5.99999L9.06666 8.66666M11.7333 5.99999L14.4 8.66666"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const ArrowRight = () => {
  return (
    <>
      <path
        d="M2.66602 8H13.3327M13.3327 8L9.33268 4M13.3327 8L9.33268 12"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}
export const ArrowLeft = () => {
  return (
    <>
      <path
        d="M13.3327 8H2.66602M2.66602 8L6.66602 12M2.66602 8L6.66602 4"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}
export const ArrowLeftLine = () => {
  return (
    <>
      <path
        d="M1.73438 1.73438V10.2656M10.2656 6H3.63021M3.63021 6L6.94792 9.31771M3.63021 6L6.94792 2.68229"
        stroke="currentColor"
        strokeWidth="1.21875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const ArrowRightThick = () => {
  return (
    <>
      <path
        d="M1.33398 6.00065H10.6673M10.6673 6.00065L6.00065 1.33398M10.6673 6.00065L6.00065 10.6673"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const MessageExclamation = () => {
  return (
    <>
      <path
        d="M8.79999 7V4.66667M8.79999 9.33333H8.80665M7.39999 12.8L8.37332 14.0978C8.51807 14.2908 8.59044 14.3873 8.67916 14.4218C8.75688 14.452 8.8431 14.452 8.92081 14.4218C9.00954 14.3873 9.08191 14.2908 9.22665 14.0978L10.2 12.8C10.3954 12.5394 10.4931 12.4091 10.6123 12.3097C10.7712 12.177 10.9589 12.0832 11.1603 12.0357C11.3114 12 11.4743 12 11.8 12C12.7319 12 13.1978 12 13.5654 11.8478C14.0554 11.6448 14.4448 11.2554 14.6477 10.7654C14.8 10.3978 14.8 9.93188 14.8 9V5.2C14.8 4.07989 14.8 3.51984 14.582 3.09202C14.3903 2.71569 14.0843 2.40973 13.708 2.21799C13.2801 2 12.7201 2 11.6 2H5.99999C4.87988 2 4.31983 2 3.89201 2.21799C3.51568 2.40973 3.20972 2.71569 3.01797 3.09202C2.79999 3.51984 2.79999 4.07989 2.79999 5.2V9C2.79999 9.93188 2.79999 10.3978 2.95223 10.7654C3.15522 11.2554 3.54456 11.6448 4.03462 11.8478C4.40216 12 4.8681 12 5.79999 12C6.12571 12 6.28857 12 6.43966 12.0357C6.64111 12.0832 6.82873 12.177 6.98765 12.3097C7.10684 12.4091 7.20456 12.5394 7.39999 12.8Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}
export const MessageExclamationFilled = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8273 1.33301H5.17221C4.63556 1.333 4.19265 1.33299 3.83185 1.36247C3.45712 1.39309 3.11265 1.4588 2.7891 1.62366C2.28733 1.87932 1.87938 2.28727 1.62372 2.78903C1.45886 3.11259 1.39315 3.45706 1.36253 3.83179C1.33306 4.19259 1.33306 4.6355 1.33307 5.17214L1.33304 9.42473C1.33275 9.95498 1.33254 10.3488 1.42394 10.6899C1.67052 11.6101 2.38931 12.3289 3.30955 12.5755C3.51453 12.6304 3.73853 12.6522 3.99974 12.6609L3.99974 13.5803C3.99971 13.7371 3.99967 13.897 4.01157 14.028C4.02296 14.1533 4.05309 14.3898 4.2182 14.5967C4.40818 14.8347 4.69628 14.9731 5.00082 14.9728C5.26547 14.9725 5.46897 14.8483 5.57392 14.7789C5.68366 14.7064 5.80847 14.6065 5.93093 14.5085L7.53968 13.2215C7.8854 12.9449 7.98804 12.8668 8.0947 12.8123C8.20168 12.7577 8.31556 12.7177 8.43324 12.6936C8.55057 12.6695 8.6795 12.6663 9.12224 12.6663H10.8273C11.3639 12.6664 11.8068 12.6664 12.1676 12.6369C12.5424 12.6063 12.8868 12.5406 13.2104 12.3757C13.7121 12.12 14.1201 11.7121 14.3758 11.2103C14.5406 10.8868 14.6063 10.5423 14.6369 10.1676C14.6664 9.80677 14.6664 9.36386 14.6664 8.82722V5.17213C14.6664 4.63549 14.6664 4.19258 14.6369 3.83179C14.6063 3.45706 14.5406 3.11259 14.3758 2.78903C14.1201 2.28727 13.7121 1.87932 13.2104 1.62366C12.8868 1.4588 12.5424 1.39309 12.1676 1.36247C11.8068 1.33299 11.3639 1.333 10.8273 1.33301ZM8.66634 4.66634C8.66634 4.29815 8.36786 3.99967 7.99967 3.99967C7.63148 3.99967 7.33301 4.29815 7.33301 4.66634V6.99967C7.33301 7.36786 7.63148 7.66634 7.99967 7.66634C8.36786 7.66634 8.66634 7.36786 8.66634 6.99967V4.66634ZM7.99967 8.66634C7.63148 8.66634 7.33301 8.96482 7.33301 9.33301C7.33301 9.7012 7.63148 9.99967 7.99967 9.99967H8.00634C8.37453 9.99967 8.67301 9.7012 8.67301 9.33301C8.67301 8.96482 8.37453 8.66634 8.00634 8.66634H7.99967Z"
        fill="currentColor"
      />
    </>
  )
}

export const AlarmClock = () => {
  return (
    <path
      d="M5 3L2 6M22 6L19 3M6 19L4 21M18 19L20 21M12 9V13L14 15M12 21C14.1217 21 16.1566 20.1571 17.6569 18.6569C19.1571 17.1566 20 15.1217 20 13C20 10.8783 19.1571 8.84344 17.6569 7.34315C16.1566 5.84285 14.1217 5 12 5C9.87827 5 7.84344 5.84285 6.34315 7.34315C4.84285 8.84344 4 10.8783 4 13C4 15.1217 4.84285 17.1566 6.34315 18.6569C7.84344 20.1571 9.87827 21 12 21Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  )
}

export const AlarmClockCheck = () => {
  return (
    <>
      <path
        d="M3.53329 2L1.53329 4M14.8666 4L12.8666 2M4.19996 12.6667L2.86663 14M12.2 12.6667L13.5333 14M6.19996 9L7.53329 10.3333L10.5333 7.33333M8.19996 14C9.61445 14 10.971 13.4381 11.9712 12.4379C12.9714 11.4377 13.5333 10.0812 13.5333 8.66667C13.5333 7.25218 12.9714 5.89562 11.9712 4.89543C10.971 3.89524 9.61445 3.33333 8.19996 3.33333C6.78547 3.33333 5.42892 3.89524 4.42873 4.89543C3.42853 5.89562 2.86663 7.25218 2.86663 8.66667C2.86663 10.0812 3.42853 11.4377 4.42873 12.4379C5.42892 13.4381 6.78547 14 8.19996 14Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const ClockRewind = () => {
  return (
    <>
      <path
        d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C15.7912 20 18.9664 17.3629 19.7914 13.8229L19.407 14.2072C19.0164 14.5977 18.3832 14.5976 17.9927 14.207C17.6023 13.8164 17.6024 13.1833 17.9929 12.7928L19.9935 10.7928C20.1811 10.6053 20.4355 10.5 20.7007 10.5C20.9659 10.5 21.2202 10.6054 21.4078 10.793L23.4072 12.793C23.7976 13.1836 23.7975 13.8167 23.407 14.2072C23.0164 14.5977 22.3832 14.5976 21.9927 14.207L21.7976 14.0118C20.8665 18.5704 16.8338 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C15.67 2 18.8771 3.97759 20.6155 6.92048C20.8964 7.39599 20.7386 8.00919 20.2631 8.29009C19.7876 8.57098 19.1744 8.41322 18.8935 7.9377C17.5 5.57869 14.9338 4 12 4Z"
        fill="currentColor"
      />
      <path
        d="M13 7C13 6.44772 12.5523 6 12 6C11.4477 6 11 6.44772 11 7V12C11 12.3344 11.1671 12.6466 11.4453 12.8321L14.4453 14.8321C14.9048 15.1384 15.5257 15.0142 15.8321 14.5547C16.1384 14.0952 16.0142 13.4743 15.5547 13.1679L13 11.4648V7Z"
        fill="currentColor"
      />
    </>
  )
}

export const Clock = () => {
  return (
    <>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        stroke="currentColor"
        fill="none"
        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </>
  )
}

export const ClockFilled = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM13 6C13 5.44772 12.5523 5 12 5C11.4477 5 11 5.44772 11 6V12C11 12.3788 11.214 12.725 11.5528 12.8944L15.5528 14.8944C16.0468 15.1414 16.6474 14.9412 16.8944 14.4472C17.1414 13.9532 16.9412 13.3526 16.4472 13.1056L13 11.382V6Z"
        fill="currentColor"
      />
    </>
  )
}

export const Etiquette = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.884071 1.76006C1.07582 1.38373 1.38178 1.07777 1.7581 0.886024C2.01036 0.757495 2.2725 0.70995 2.53607 0.688416C2.78578 0.668014 3.08896 0.668024 3.44039 0.668036L6.50464 0.668002C6.7759 0.66775 7.01506 0.667528 7.24735 0.723297C7.45143 0.77229 7.64652 0.853099 7.82546 0.962756C8.02915 1.08758 8.19811 1.25685 8.38975 1.44884L13.5609 6.62001C13.9403 6.99948 14.2535 7.31266 14.4878 7.58863C14.7311 7.87525 14.9283 8.16529 15.0405 8.51066C15.2145 9.04624 15.2145 9.62317 15.0405 10.1587C14.9283 10.5041 14.7311 10.7942 14.4878 11.0808C14.2535 11.3567 13.9404 11.6699 13.5609 12.0494L12.0474 13.5628C11.668 13.9423 11.3548 14.2555 11.0788 14.4898C10.7922 14.7331 10.5022 14.9302 10.1568 15.0424C9.62121 15.2164 9.04429 15.2164 8.5087 15.0424C8.16334 14.9302 7.8733 14.7331 7.58668 14.4898C7.31071 14.2555 6.99753 13.9423 6.61807 13.5628L1.44689 8.3917C1.2549 8.20007 1.08563 8.03111 0.960803 7.82741C0.851146 7.64847 0.770337 7.45338 0.721343 7.24931C0.665574 7.01701 0.665797 6.77784 0.666049 6.50658L0.666083 3.44234C0.666071 3.09091 0.666061 2.78773 0.686463 2.53802C0.707998 2.27445 0.755541 2.01231 0.884071 1.76006ZM5.33276 4.0013C4.59638 4.0013 3.99943 4.59826 3.99943 5.33464C3.99943 6.07101 4.59638 6.66797 5.33276 6.66797C6.06914 6.66797 6.6661 6.07101 6.6661 5.33464C6.6661 4.59826 6.06914 4.0013 5.33276 4.0013Z"
        fill="#838B93"
      />
    </>
  )
}

export const BookmarkX = () => {
  return (
    <path
      d="M9.5 7.5L14.5 12.5M14.5 7.5L9.5 12.5M19 21V7.8C19 6.11984 19 5.27976 18.673 4.63803C18.3854 4.07354 17.9265 3.6146 17.362 3.32698C16.7202 3 15.8802 3 14.2 3H9.8C8.11984 3 7.27976 3 6.63803 3.32698C6.07354 3.6146 5.6146 4.07354 5.32698 4.63803C5 5.27976 5 6.11984 5 7.8V21L12 17L19 21Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  )
}

export const LighningBolt = () => {
  return (
    <>
      <path
        d="M9.26665 1.33334L3.32896 8.45858C3.09642 8.73763 2.98015 8.87715 2.97837 8.99498C2.97683 9.09742 3.02247 9.19488 3.10216 9.25927C3.19382 9.33334 3.37544 9.33334 3.73867 9.33334H8.59999L7.93332 14.6667L13.871 7.54144C14.1036 7.2624 14.2198 7.12287 14.2216 7.00504C14.2231 6.9026 14.1775 6.80514 14.0978 6.74075C14.0062 6.66668 13.8245 6.66668 13.4613 6.66668H8.59999L9.26665 1.33334Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const InformationCircle = () => {
  return (
    <>
      <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M11 15V11M11 7H11.01M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  )
}

export const Invalid = () => {
  return (
    <>
      <path
        d="M10.0028 17.3709C14.0732 17.3709 17.3728 14.0712 17.3728 10.0009C17.3728 5.93052 14.0732 2.63086 10.0028 2.63086C5.93247 2.63086 2.63281 5.93052 2.63281 10.0009C2.63281 14.0712 5.93247 17.3709 10.0028 17.3709Z"
        stroke="#FF4F28"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 14.7995V8.51953"
        stroke="#FF4F28"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 6.59922V5.94922"
        stroke="#FF4F28"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const Check = () => {
  return (
    <>
      <path
        d="M13.3327 4L5.99935 11.3333L2.66602 8"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const Check2 = () => {
  return (
    <>
      <path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </>
  )
}

export const CheckCircle = () => {
  return (
    <>
      <path
        d="M22 11.0857V12.0057C21.9988 14.1621 21.3005 16.2604 20.0093 17.9875C18.7182 19.7147 16.9033 20.9782 14.8354 21.5896C12.7674 22.201 10.5573 22.1276 8.53447 21.3803C6.51168 20.633 4.78465 19.2518 3.61096 17.4428C2.43727 15.6338 1.87979 13.4938 2.02168 11.342C2.16356 9.19029 2.99721 7.14205 4.39828 5.5028C5.79935 3.86354 7.69279 2.72111 9.79619 2.24587C11.8996 1.77063 14.1003 1.98806 16.07 2.86572M22 4L12 14.01L9 11.01"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}
export const XCircle = () => {
  return (
    <>
      <path
        d="M15 9L9 15M9 9L15 15M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const Warning = () => {
  return (
    <>
      <path
        d="M14.8007 11.7557L9.33504 2.26379C9.19846 2.03124 9.00348 1.83843 8.76942 1.70445C8.53537 1.57048 8.27036 1.5 8.00067 1.5C7.73098 1.5 7.46597 1.57048 7.23191 1.70445C6.99786 1.83843 6.80288 2.03124 6.6663 2.26379L1.20067 11.7557C1.06926 11.9806 1 12.2364 1 12.4969C1 12.7574 1.06926 13.0132 1.20067 13.2382C1.3355 13.4721 1.53015 13.666 1.76465 13.7999C1.99914 13.9338 2.26504 14.0028 2.53505 14H13.4663C13.7361 14.0026 14.0017 13.9334 14.236 13.7996C14.4702 13.6657 14.6647 13.4719 14.7994 13.2382C14.931 13.0134 15.0005 12.7576 15.0007 12.4971C15.0009 12.2366 14.9319 11.9807 14.8007 11.7557ZM7.50067 6.50004C7.50067 6.36743 7.55335 6.24026 7.64712 6.14649C7.74088 6.05272 7.86806 6.00004 8.00067 6.00004C8.13328 6.00004 8.26046 6.05272 8.35422 6.14649C8.44799 6.24026 8.50067 6.36743 8.50067 6.50004V9.00004C8.50067 9.13265 8.44799 9.25983 8.35422 9.35359C8.26046 9.44736 8.13328 9.50004 8.00067 9.50004C7.86806 9.50004 7.74088 9.44736 7.64712 9.35359C7.55335 9.25983 7.50067 9.13265 7.50067 9.00004V6.50004ZM8.00067 12C7.85233 12 7.70733 11.9561 7.58399 11.8736C7.46066 11.7912 7.36453 11.6741 7.30776 11.5371C7.25099 11.4 7.23614 11.2492 7.26508 11.1037C7.29402 10.9582 7.36545 10.8246 7.47034 10.7197C7.57523 10.6148 7.70887 10.5434 7.85435 10.5145C7.99984 10.4855 8.15064 10.5004 8.28768 10.5571C8.42473 10.6139 8.54186 10.71 8.62427 10.8334C8.70668 10.9567 8.75067 11.1017 8.75067 11.25C8.75067 11.449 8.67165 11.6397 8.531 11.7804C8.39035 11.921 8.19958 12 8.00067 12Z"
        fill="currentColor"
      />
    </>
  )
}

export const WarningOutline = () => {
  return (
    <>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M11.9998 8.99999V13M11.9998 17H12.0098M10.6151 3.89171L2.39019 18.0983C1.93398 18.8863 1.70588 19.2803 1.73959 19.6037C1.769 19.8857 1.91677 20.142 2.14613 20.3088C2.40908 20.5 2.86435 20.5 3.77487 20.5H20.2246C21.1352 20.5 21.5904 20.5 21.8534 20.3088C22.0827 20.142 22.2305 19.8857 22.2599 19.6037C22.2936 19.2803 22.0655 18.8863 21.6093 18.0983L13.3844 3.89171C12.9299 3.10654 12.7026 2.71396 12.4061 2.58211C12.1474 2.4671 11.8521 2.4671 11.5935 2.58211C11.2969 2.71396 11.0696 3.10655 10.6151 3.89171Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  )
}

export const FlagOutline = () => {
  return (
    <>
      <path
        d="M9.90838 4.48079H13.9279C14.2261 4.48079 14.3752 4.48079 14.4624 4.54349C14.5385 4.59819 14.588 4.68239 14.5989 4.77546C14.6113 4.88213 14.5389 5.01246 14.3941 5.27314L13.4144 7.0366C13.3619 7.13113 13.3356 7.1784 13.3253 7.22846C13.3162 7.27276 13.3162 7.31846 13.3253 7.36276C13.3356 7.41282 13.3619 7.46008 13.4144 7.55462L14.3941 9.31808C14.5389 9.57875 14.6113 9.70909 14.5989 9.81576C14.588 9.90883 14.5385 9.99303 14.4624 10.0477C14.3752 10.1104 14.2261 10.1104 13.9279 10.1104H8.86393C8.49056 10.1104 8.30388 10.1104 8.16127 10.0378C8.03583 9.97385 7.93384 9.87186 7.86993 9.74642C7.79727 9.60381 7.79727 9.41713 7.79727 9.04376V7.29561M5.33431 14.3328L2.51949 3.07357M3.57508 7.29565H8.84171C9.21508 7.29565 9.40177 7.29565 9.54437 7.22298C9.66982 7.15907 9.7718 7.05708 9.83572 6.93164C9.90838 6.78903 9.90838 6.60235 9.90838 6.22898V2.73268C9.90838 2.35931 9.90838 2.17263 9.83572 2.03002C9.7718 1.90458 9.66982 1.80259 9.54437 1.73868C9.40177 1.66602 9.21508 1.66602 8.84171 1.66602H3.53379C3.06811 1.66602 2.83527 1.66602 2.67601 1.76251C2.53643 1.84708 2.43272 1.97991 2.38453 2.13583C2.32955 2.31373 2.38603 2.53962 2.49897 2.9914L3.57508 7.29565Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

// for 24 24
export const FlagOutline2 = () => {
  return (
    <>
      <path
        d="M14.1112 6.72217H20.1404C20.5877 6.72217 20.8114 6.72217 20.9422 6.81621C21.0563 6.89826 21.1306 7.02456 21.1469 7.16416C21.1656 7.32417 21.057 7.51967 20.8398 7.91068L19.3702 10.5559C19.2914 10.6977 19.252 10.7686 19.2366 10.8437C19.2229 10.9101 19.2229 10.9787 19.2366 11.0451C19.252 11.1202 19.2914 11.1911 19.3702 11.3329L20.8398 13.9781C21.057 14.3691 21.1656 14.5646 21.1469 14.7246C21.1306 14.8642 21.0563 14.9905 20.9422 15.0726C20.8114 15.1666 20.5877 15.1666 20.1404 15.1666H12.5445C11.9844 15.1666 11.7044 15.1666 11.4905 15.0576C11.3023 14.9617 11.1494 14.8088 11.0535 14.6206C10.9445 14.4067 10.9445 14.1267 10.9445 13.5666V10.9444M7.25006 21.5002L3.02784 4.61133M4.61121 10.9444H12.5112C13.0712 10.9444 13.3512 10.9444 13.5652 10.8355C13.7533 10.7396 13.9063 10.5866 14.0022 10.3984C14.1112 10.1845 14.1112 9.9045 14.1112 9.34445V4.1C14.1112 3.53995 14.1112 3.25992 14.0022 3.04601C13.9063 2.85785 13.7533 2.70487 13.5652 2.60899C13.3512 2.5 13.0712 2.5 12.5112 2.5H4.54928C3.85076 2.5 3.5015 2.5 3.26262 2.64474C3.05325 2.77159 2.89768 2.97084 2.8254 3.20472C2.74292 3.47158 2.82764 3.81041 2.99706 4.48807L4.61121 10.9444Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const Flag = () => {
  return (
    <>
      <path
        d="M21.0047 2.29095C20.7137 2.07731 20.3975 2.03304 20.2152 2.01632C20.0363 1.9999 19.8221 1.99996 19.6201 2.00001L4.00473 2.00001C4.00315 2 4.00158 2 4 2C3.44772 2 3 2.44772 3 3V21C3 21.5523 3.44772 22 4 22C4.55229 22 5 21.5523 5 21L5 14L19.6201 14C19.8221 14.0001 20.0363 14.0001 20.2152 13.9837C20.3975 13.967 20.7137 13.9227 21.0047 13.7091C21.3502 13.4554 21.5706 13.066 21.6104 12.6392C21.6439 12.2798 21.5192 11.9859 21.4397 11.8209C21.3618 11.6591 21.2515 11.4754 21.1476 11.3023L19.1662 8.00001L21.1475 4.69782C21.2515 4.52463 21.3618 4.34093 21.4397 4.17907C21.5192 4.01415 21.6439 3.7202 21.6104 3.36079C21.5706 2.93401 21.3502 2.54464 21.0047 2.29095Z"
        fill="currentColor"
      />
    </>
  )
}

export const ArrowTrendUp = () => {
  return (
    <>
      <path
        d="M12.8333 4.58333L8.24329 9.17336C8.01228 9.40437 7.89677 9.51988 7.76358 9.56315C7.64642 9.60122 7.52022 9.60122 7.40306 9.56315C7.26987 9.51988 7.15437 9.40437 6.92336 9.17336L5.32662 7.57663C5.09561 7.34562 4.98011 7.23011 4.84692 7.18684C4.72976 7.14877 4.60356 7.14877 4.4864 7.18684C4.3532 7.23011 4.2377 7.34562 4.00669 7.57663L1.16666 10.4167M12.8333 4.58333H8.74999M12.8333 4.58333V8.66666"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const ArrowTrendDown = () => {
  return (
    <>
      <g transform="translate(0, -4.79167)">
        <path
          transform="scale(1, -1)"
          d="M12.8333 15.4167L8.24329 10.8266C8.01228 10.5956 7.89677 10.4801 7.76358 10.4368C7.64642 10.3988 7.52022 10.3988 7.40306 10.4368C7.26987 10.4801 7.15437 10.5956 6.92336 10.8266L5.32662 12.4234C5.09561 12.6544 4.98011 12.7699 4.84692 12.8132C4.72976 12.8512 4.60356 12.8512 4.4864 12.8132C4.3532 12.7699 4.2377 12.6544 4.00669 12.4234L1.16666 9.58333M12.8333 15.4167H8.74999M12.8333 15.4167V11.3333"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </>
  )
}

export const Cluster = () => {
  return (
    <>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.82929 3C7.41746 1.83481 6.30622 1 5 1C3.34315 1 2 2.34315 2 4C2 5.65685 3.34315 7 5 7C6.30622 7 7.41746 6.16519 7.82929 5L11 5L11 15.2413C11 16.0462 11 16.7106 11.0442 17.2518C11.0901 17.8139 11.1887 18.3306 11.436 18.816C11.8195 19.5686 12.4314 20.1805 13.184 20.564C13.6694 20.8113 14.1861 20.9099 14.7482 20.9558C15.1515 20.9888 15.6232 20.9971 16.1705 20.9993C16.5821 22.1648 17.6935 23 19 23C20.6569 23 22 21.6569 22 20C22 18.3431 20.6569 17 19 17C17.6941 17 16.5831 17.8344 16.171 18.9992C15.6425 18.997 15.2412 18.9894 14.911 18.9624C14.4726 18.9266 14.2484 18.8617 14.092 18.782C13.7157 18.5903 13.4097 18.2843 13.218 17.908C13.1383 17.7516 13.0734 17.5274 13.0376 17.089C13.0008 16.6389 13 16.0566 13 15.2V13L16.1707 13C16.5825 14.1652 17.6938 15 19 15C20.6569 15 22 13.6569 22 12C22 10.3431 20.6569 9 19 9C17.6938 9 16.5825 9.83481 16.1707 11L13 11V5L16.1707 5C16.5825 6.16519 17.6938 7 19 7C20.6569 7 22 5.65685 22 4C22 2.34315 20.6569 1 19 1C17.6938 1 16.5825 1.83481 16.1707 3L7.82929 3Z"
          fill="currentColor"
        />
      </svg>
    </>
  )
}

export const StatsBarChartFilled = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.892 1.33301H4.10731C3.75589 1.333 3.4527 1.33299 3.20299 1.35339C2.93943 1.37492 2.67728 1.42247 2.42503 1.551C2.0487 1.74274 1.74274 2.0487 1.551 2.42503C1.42247 2.67728 1.37492 2.93943 1.35339 3.20299C1.33299 3.4527 1.333 3.75587 1.33301 4.10729V11.892C1.333 12.2435 1.33299 12.5467 1.35339 12.7964C1.37492 13.0599 1.42247 13.3221 1.551 13.5743C1.74274 13.9506 2.0487 14.2566 2.42503 14.4484C2.67728 14.5769 2.93943 14.6244 3.20299 14.646C3.4527 14.6664 3.75587 14.6664 4.1073 14.6663H11.8921C12.2435 14.6664 12.5466 14.6664 12.7964 14.646C13.0599 14.6244 13.3221 14.5769 13.5743 14.4484C13.9506 14.2566 14.2566 13.9506 14.4484 13.5743C14.5769 13.3221 14.6244 13.0599 14.646 12.7964C14.6664 12.5466 14.6664 12.2435 14.6663 11.8921V4.1073C14.6664 3.75587 14.6664 3.4527 14.646 3.20299C14.6244 2.93943 14.5769 2.67728 14.4484 2.42503C14.2566 2.0487 13.9506 1.74274 13.5743 1.551C13.3221 1.42247 13.0599 1.37492 12.7964 1.35339C12.5467 1.33299 12.2435 1.333 11.892 1.33301ZM11.333 4.66634C11.333 4.29815 11.0345 3.99968 10.6663 3.99968C10.2982 3.99968 9.99968 4.29815 9.99968 4.66634V11.333C9.99968 11.7012 10.2982 11.9997 10.6663 11.9997C11.0345 11.9997 11.333 11.7012 11.333 11.333V4.66634ZM7.99968 6.66634C8.36787 6.66634 8.66634 6.96482 8.66634 7.33301V11.333C8.66634 11.7012 8.36787 11.9997 7.99968 11.9997C7.63148 11.9997 7.33301 11.7012 7.33301 11.333V7.33301C7.33301 6.96482 7.63148 6.66634 7.99968 6.66634ZM5.33301 9.33301C5.7012 9.33301 5.99968 9.63148 5.99968 9.99968V11.333C5.99968 11.7012 5.7012 11.9997 5.33301 11.9997C4.96482 11.9997 4.66634 11.7012 4.66634 11.333V9.99968C4.66634 9.63148 4.96482 9.33301 5.33301 9.33301Z"
        fill="currentColor"
      />
    </>
  )
}
export const CompassFilled = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00033 0.666992C3.95024 0.666992 0.666992 3.95024 0.666992 8.00033C0.666992 12.0504 3.95024 15.3337 8.00033 15.3337C12.0504 15.3337 15.3337 12.0504 15.3337 8.00033C15.3337 3.95024 12.0504 0.666992 8.00033 0.666992ZM10.4119 5.38658C10.3036 5.34796 10.1408 5.40225 9.81506 5.51081L6.83997 6.50251C6.74721 6.53343 6.70083 6.54889 6.66231 6.57523C6.6282 6.59857 6.59872 6.62805 6.57539 6.66216C6.54904 6.70068 6.53358 6.74706 6.50266 6.83982L5.51096 9.81491C5.4024 10.1406 5.34812 10.3035 5.38673 10.4117C5.42034 10.506 5.4945 10.5802 5.58874 10.6138C5.69704 10.6524 5.85989 10.5981 6.18558 10.4895L9.16067 9.49783C9.25343 9.46691 9.29981 9.45145 9.33833 9.4251C9.37244 9.40177 9.40192 9.37229 9.42525 9.33818C9.4516 9.29966 9.46706 9.25328 9.49798 9.16052L10.4897 6.18543C10.5982 5.85973 10.6525 5.69688 10.6139 5.58859C10.5803 5.49435 10.5061 5.42019 10.4119 5.38658Z"
        fill="currentColor"
      />
    </>
  )
}
export const BagFilled = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.58461 1.33301H10.4148C10.9119 1.333 11.3235 1.333 11.6607 1.35956C12.0119 1.38723 12.3353 1.44659 12.6438 1.5942C13.1245 1.82421 13.5252 2.19296 13.7944 2.65288C13.9671 2.94806 14.0531 3.26538 14.1099 3.61312C14.1643 3.94692 14.1985 4.35713 14.2398 4.85245L14.711 10.5073C14.7591 11.0844 14.7987 11.559 14.7983 11.946C14.7979 12.3466 14.7563 12.7177 14.6019 13.0701C14.3636 13.6136 13.9509 14.0622 13.429 14.3448C13.0907 14.5279 12.7243 14.6002 12.3251 14.6338C11.9395 14.6664 11.4632 14.6663 10.8841 14.6663H5.11531C4.53623 14.6663 4.05999 14.6664 3.67435 14.6338C3.27519 14.6002 2.90877 14.5279 2.57047 14.3448C2.04855 14.0622 1.6358 13.6136 1.39758 13.0701C1.24316 12.7177 1.20157 12.3466 1.20117 11.946C1.20079 11.559 1.24035 11.0844 1.28845 10.5073L1.75968 4.85245C1.80095 4.35711 1.83513 3.94693 1.8896 3.61312C1.94634 3.26538 2.03235 2.94806 2.20508 2.65288C2.47421 2.19296 2.87496 1.82421 3.35565 1.5942C3.66416 1.44659 3.98752 1.38722 4.33878 1.35955C4.67595 1.33299 5.08756 1.333 5.58461 1.33301ZM5.99972 5.33301C5.99972 4.96482 5.70124 4.66634 5.33305 4.66634C4.96486 4.66634 4.66638 4.96482 4.66638 5.33301C4.66638 6.21706 5.01757 7.06491 5.64269 7.69003C6.26781 8.31515 7.11566 8.66634 7.99972 8.66634C8.88377 8.66634 9.73162 8.31515 10.3567 7.69003C10.9819 7.06491 11.333 6.21706 11.333 5.33301C11.333 4.96482 11.0346 4.66634 10.6664 4.66634C10.2982 4.66634 9.99972 4.96482 9.99972 5.33301C9.99972 5.86344 9.789 6.37215 9.41393 6.74722C9.03886 7.12229 8.53015 7.33301 7.99972 7.33301C7.46928 7.33301 6.96057 7.12229 6.5855 6.74722C6.21043 6.37215 5.99972 5.86344 5.99972 5.33301Z"
        fill="currentColor"
      />
    </>
  )
}
export const GlobePinFilled = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00033 0.666992C8.69338 0.666992 9.36496 0.763316 10.0019 0.943662C10.4098 0.765701 10.8602 0.666992 11.3337 0.666992C13.1746 0.666992 14.667 2.15938 14.667 4.00033C14.667 4.2607 14.6344 4.51063 14.576 4.75075C15.0612 5.73081 15.3337 6.8346 15.3337 8.00033C15.3337 12.0504 12.0504 15.3337 8.00033 15.3337C3.95024 15.3337 0.666992 12.0504 0.666992 8.00033C0.666992 7.72171 0.682529 7.44673 0.712785 7.1762C0.713513 7.16861 0.71437 7.16106 0.715354 7.15354C1.13516 3.50232 4.23663 0.666992 8.00033 0.666992ZM2.18971 6.49894C2.85625 3.9118 5.20506 2.00033 8.00033 2.00033C8.21712 2.00033 8.43108 2.0118 8.64168 2.03415C8.2384 2.58535 8.00033 3.26503 8.00033 4.00033C8.00033 4.94806 8.43155 5.75743 8.97214 6.45938C9.42184 7.04331 9.99742 7.61373 10.5528 8.16418C10.657 8.26742 10.7605 8.36995 10.8623 8.47173C11.1226 8.73208 11.5447 8.73208 11.8051 8.47173C11.9068 8.36995 12.0103 8.26742 12.1145 8.16419C12.6699 7.61373 13.2455 7.04331 13.6952 6.45938C13.7213 6.4255 13.7471 6.39136 13.7727 6.35697C13.9209 6.87886 14.0003 7.43001 14.0003 8.00033C14.0003 11.314 11.314 14.0003 8.00033 14.0003C7.88849 14.0003 7.77738 13.9973 7.66705 13.9912L7.66709 13.2468L9.24404 11.407C9.65261 10.9303 9.52601 10.1994 8.98092 9.88796L7.1558 8.84501L5.95965 6.74886C5.76585 6.40924 5.39188 6.21373 5.0024 6.24842L2.18971 6.49894ZM11.3337 3.00033C10.8734 3.00033 10.5003 3.37342 10.5003 3.83366C10.5003 4.2939 10.8734 4.66699 11.3337 4.66699C11.7939 4.66699 12.167 4.2939 12.167 3.83366C12.167 3.37342 11.7939 3.00033 11.3337 3.00033Z"
        fill="currentColor"
      />
    </>
  )
}

export const GlobePinOutline = () => {
  return (
    <>
      <path
        d="M9.9987 2.13919C9.36734 1.94089 8.6955 1.83398 7.9987 1.83398C4.3168 1.83398 1.33203 4.81875 1.33203 8.50065C1.33203 12.1826 4.3168 15.1673 7.9987 15.1673C11.6806 15.1673 14.6654 12.1826 14.6654 8.50065C14.6654 7.3571 14.3774 6.2808 13.8701 5.34028M11.332 4.33398H11.3354M6.99873 15.0928L6.99881 13.6239C6.99881 13.5444 7.02727 13.4674 7.07905 13.407L8.73624 11.4736C8.87243 11.3147 8.83023 11.0711 8.64853 10.9672L6.74439 9.87914C6.69265 9.84958 6.64979 9.80669 6.62026 9.75494L5.379 7.57974C5.3144 7.46653 5.18975 7.40136 5.05992 7.41293L1.37482 7.74115M13.9987 4.50065C13.9987 5.97341 12.6654 7.16732 11.332 8.50065C9.9987 7.16732 8.66536 5.97341 8.66536 4.50065C8.66536 3.02789 9.85927 1.83398 11.332 1.83398C12.8048 1.83398 13.9987 3.02789 13.9987 4.50065ZM11.4987 4.33398C11.4987 4.42603 11.4241 4.50065 11.332 4.50065C11.24 4.50065 11.1654 4.42603 11.1654 4.33398C11.1654 4.24194 11.24 4.16732 11.332 4.16732C11.4241 4.16732 11.4987 4.24194 11.4987 4.33398Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const Export = () => {
  return (
    <>
      <path
        d="M21 15V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V15M17 8L12 3M12 3L7 8M12 3V15"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const Merge = () => {
  return (
    <>
      <path
        d="m8 6 4-4 4 4"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M12 2v10.3a4 4 0 0 1-1.172 2.872L4 22"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="m20 22-5-5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </>
  )
}

export const Import = () => {
  return (
    <>
      <path
        d="M21 15V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V15M17 10L12 15M12 15L7 10M12 15V3"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const TrashOutline = () => {
  return (
    <>
      <svg width="23" height="23" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7 1H13M1 4H19M17 4L16.2987 14.5193C16.1935 16.0975 16.1409 16.8867 15.8 17.485C15.4999 18.0118 15.0472 18.4353 14.5017 18.6997C13.882 19 13.0911 19 11.5093 19H8.49065C6.90891 19 6.11803 19 5.49834 18.6997C4.95276 18.4353 4.50009 18.0118 4.19998 17.485C3.85911 16.8867 3.8065 16.0975 3.70129 14.5193L3 4M8 8.5V13.5M12 8.5V13.5"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  )
}

export const Trash = () => {
  return (
    <>
      <path
        d="M6.75 2.25H11.25M2.25 4.5H15.75M14.25 4.5L13.724 12.3895C13.6451 13.5732 13.6057 14.165 13.35 14.6138C13.1249 15.0088 12.7854 15.3265 12.3762 15.5248C11.9115 15.75 11.3183 15.75 10.132 15.75H7.86799C6.68168 15.75 6.08852 15.75 5.62375 15.5248C5.21457 15.3265 4.87507 15.0088 4.64999 14.6138C4.39433 14.165 4.35488 13.5732 4.27596 12.3895L3.75 4.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const TrashFilled = () => {
  return (
    <>
      <path
        d="M5.33325 2.0026C5.33325 1.63441 5.63173 1.33594 5.99992 1.33594H9.99992C10.3681 1.33594 10.6666 1.63441 10.6666 2.0026C10.6666 2.37079 10.3681 2.66927 9.99992 2.66927H5.99992C5.63173 2.66927 5.33325 2.37079 5.33325 2.0026Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.33325 4.0026C1.33325 3.63441 1.63173 3.33594 1.99992 3.33594H13.9999C14.3681 3.33594 14.6666 3.63441 14.6666 4.0026C14.6666 4.37079 14.3681 4.66927 13.9999 4.66927H13.2903L12.8625 11.0863C12.8289 11.5899 12.8012 12.0067 12.7514 12.3459C12.6995 12.6991 12.6172 13.0218 12.4459 13.3226C12.1791 13.7909 11.7767 14.1673 11.2918 14.4023C10.9803 14.5533 10.6527 14.6139 10.2969 14.6422C9.95508 14.6693 9.53739 14.6693 9.03265 14.6693H6.96723C6.46249 14.6693 6.04479 14.6693 5.703 14.6422C5.34714 14.6139 5.01962 14.5533 4.70809 14.4023C4.22313 14.1673 3.82076 13.7909 3.554 13.3226C3.38264 13.0218 3.30038 12.6991 3.24852 12.3459C3.19871 12.0066 3.17093 11.5899 3.13737 11.0863L2.70957 4.66927H1.99992C1.63173 4.66927 1.33325 4.37079 1.33325 4.0026ZM6.66659 6.33594C7.03478 6.33594 7.33325 6.63441 7.33325 7.0026V10.3359C7.33325 10.7041 7.03478 11.0026 6.66659 11.0026C6.2984 11.0026 5.99992 10.7041 5.99992 10.3359V7.0026C5.99992 6.63441 6.2984 6.33594 6.66659 6.33594ZM9.99992 7.0026C9.99992 6.63441 9.70144 6.33594 9.33325 6.33594C8.96506 6.33594 8.66659 6.63441 8.66659 7.0026V10.3359C8.66659 10.7041 8.96506 11.0026 9.33325 11.0026C9.70144 11.0026 9.99992 10.7041 9.99992 10.3359V7.0026Z"
        fill="currentColor"
      />
    </>
  )
}

export const ListDots = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.33398 7.99935C5.33398 7.63116 5.63246 7.33268 6.00065 7.33268L14.0007 7.33268C14.3688 7.33268 14.6673 7.63116 14.6673 7.99935C14.6673 8.36754 14.3688 8.66602 14.0007 8.66602L6.00065 8.66602C5.63246 8.66602 5.33398 8.36754 5.33398 7.99935Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.33398 3.99935C5.33398 3.63116 5.63246 3.33268 6.00065 3.33268L14.0007 3.33268C14.3688 3.33268 14.6673 3.63116 14.6673 3.99935C14.6673 4.36754 14.3688 4.66602 14.0007 4.66602L6.00065 4.66602C5.63246 4.66602 5.33398 4.36754 5.33398 3.99935Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.33398 11.9993C5.33398 11.6312 5.63246 11.3327 6.00065 11.3327L14.0007 11.3327C14.3688 11.3327 14.6673 11.6312 14.6673 11.9993C14.6673 12.3675 14.3688 12.666 14.0007 12.666L6.00065 12.666C5.63246 12.666 5.33398 12.3675 5.33398 11.9993Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.33398 7.99935C1.33398 7.26297 1.93094 6.66602 2.66732 6.66602C3.4037 6.66602 4.00065 7.26297 4.00065 7.99935C4.00065 8.73573 3.4037 9.33268 2.66732 9.33268C1.93094 9.33268 1.33398 8.73573 1.33398 7.99935Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.33398 3.99935C1.33398 3.26297 1.93094 2.66602 2.66732 2.66602C3.4037 2.66602 4.00065 3.26297 4.00065 3.99935C4.00065 4.73573 3.4037 5.33268 2.66732 5.33268C1.93094 5.33268 1.33398 4.73573 1.33398 3.99935Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.33398 11.9993C1.33398 11.263 1.93094 10.666 2.66732 10.666C3.4037 10.666 4.00065 11.263 4.00065 11.9993C4.00065 12.7357 3.4037 13.3327 2.66732 13.3327C1.93094 13.3327 1.33398 12.7357 1.33398 11.9993Z"
        fill="currentColor"
      />
    </>
  )
}
export const SmallGrid = () => {
  return (
    <>
      <path
        d="M7.33398 2.40065C7.33398 2.02728 7.33398 1.8406 7.26132 1.69799C7.19741 1.57255 7.09542 1.47056 6.96998 1.40665C6.82737 1.33398 6.64069 1.33398 6.26732 1.33398H4.10829C3.75687 1.33397 3.45368 1.33396 3.20397 1.35437C2.9404 1.3759 2.67826 1.42344 2.42601 1.55197C2.04968 1.74372 1.74372 2.04968 1.55197 2.42601C1.42344 2.67826 1.3759 2.9404 1.35437 3.20397C1.33396 3.45368 1.33397 3.75684 1.33398 4.10826C1.33398 4.31819 1.33398 4.42315 1.35742 4.50918C1.41949 4.73709 1.59754 4.91514 1.82545 4.97722C1.91149 5.00065 2.01645 5.00065 2.22637 5.00065H6.26732C6.64069 5.00065 6.82737 5.00065 6.96998 4.92799C7.09542 4.86407 7.19741 4.76209 7.26132 4.63664C7.33398 4.49404 7.33398 4.30735 7.33398 3.93398V2.40065Z"
        fill="currentColor"
      />
      <path
        d="M2.40065 6.33398C2.02728 6.33398 1.8406 6.33398 1.69799 6.40665C1.57255 6.47056 1.47056 6.57255 1.40665 6.69799C1.33398 6.8406 1.33398 7.02728 1.33398 7.40065L1.33398 8.60065C1.33398 8.97402 1.33398 9.1607 1.40665 9.30331C1.47056 9.42875 1.57255 9.53074 1.69799 9.59466C1.8406 9.66732 2.02728 9.66732 2.40065 9.66732H6.26732C6.64069 9.66732 6.82737 9.66732 6.96998 9.59466C7.09542 9.53074 7.19741 9.42875 7.26132 9.30331C7.33399 9.1607 7.33399 8.97402 7.33399 8.60065L7.33398 7.40065C7.33398 7.02728 7.33398 6.8406 7.26132 6.69799C7.19741 6.57255 7.09542 6.47056 6.96998 6.40665C6.82737 6.33398 6.64069 6.33398 6.26732 6.33398H2.40065Z"
        fill="currentColor"
      />
      <path
        d="M2.22635 11.0007C2.01645 11.0007 1.91149 11.0007 1.82547 11.0241C1.59754 11.0862 1.41949 11.2642 1.35741 11.4921C1.33398 11.5782 1.33398 11.6831 1.33398 11.893C1.33397 12.2444 1.33396 12.5476 1.35437 12.7973C1.3759 13.0609 1.42344 13.323 1.55197 13.5753C1.74372 13.9516 2.04968 14.2576 2.42601 14.4493C2.67826 14.5779 2.9404 14.6254 3.20397 14.6469C3.45368 14.6673 3.75685 14.6673 4.10827 14.6673H6.26732C6.64069 14.6673 6.82737 14.6673 6.96998 14.5947C7.09542 14.5307 7.19741 14.4288 7.26132 14.3033C7.33399 14.1607 7.33399 13.974 7.33399 13.6007V12.0673C7.33399 11.6939 7.33399 11.5073 7.26132 11.3647C7.19741 11.2392 7.09542 11.1372 6.96998 11.0733C6.82737 11.0007 6.64069 11.0007 6.26732 11.0007H2.22635Z"
        fill="currentColor"
      />
      <path
        d="M8.66732 13.6007C8.66732 13.974 8.66732 14.1607 8.73998 14.3033C8.8039 14.4288 8.90588 14.5307 9.03132 14.5947C9.17393 14.6673 9.36062 14.6673 9.73398 14.6673H11.893C12.2445 14.6673 12.5476 14.6673 12.7973 14.6469C13.0609 14.6254 13.323 14.5779 13.5753 14.4493C13.9516 14.2576 14.2576 13.9516 14.4493 13.5753C14.5779 13.323 14.6254 13.0609 14.6469 12.7973C14.6673 12.5476 14.6673 12.2445 14.6673 11.893C14.6673 11.6831 14.6673 11.5782 14.6439 11.4921C14.5818 11.2642 14.4038 11.0862 14.1758 11.0241C14.0898 11.0007 13.9849 11.0007 13.7749 11.0007H9.73398C9.36062 11.0007 9.17393 11.0007 9.03132 11.0733C8.90588 11.1372 8.8039 11.2392 8.73998 11.3647C8.66732 11.5073 8.66732 11.6939 8.66732 12.0673V13.6007Z"
        fill="currentColor"
      />
      <path
        d="M13.6007 9.66732C13.974 9.66732 14.1607 9.66732 14.3033 9.59466C14.4288 9.53074 14.5307 9.42875 14.5947 9.30331C14.6673 9.1607 14.6673 8.97402 14.6673 8.60065V7.40065C14.6673 7.02728 14.6673 6.8406 14.5947 6.69799C14.5307 6.57255 14.4288 6.47056 14.3033 6.40665C14.1607 6.33398 13.974 6.33398 13.6007 6.33398H9.73398C9.36062 6.33398 9.17393 6.33398 9.03132 6.40665C8.90588 6.47056 8.8039 6.57255 8.73998 6.69799C8.66732 6.8406 8.66732 7.02728 8.66732 7.40065L8.66732 8.60065C8.66732 8.97402 8.66732 9.1607 8.73998 9.30331C8.8039 9.42875 8.90588 9.53074 9.03132 9.59466C9.17393 9.66732 9.36062 9.66732 9.73398 9.66732H13.6007Z"
        fill="currentColor"
      />
      <path
        d="M14.6673 4.10827C14.6673 4.31819 14.6673 4.42315 14.6439 4.50917C14.5818 4.73709 14.4038 4.91515 14.1758 4.97722C14.0898 5.00065 13.9849 5.00065 13.7749 5.00065H9.73398C9.36062 5.00065 9.17393 5.00065 9.03132 4.92799C8.90588 4.86407 8.8039 4.76209 8.73998 4.63664C8.66732 4.49404 8.66732 4.30735 8.66732 3.93398V2.40065C8.66732 2.02728 8.66732 1.8406 8.73998 1.69799C8.8039 1.57255 8.90588 1.47056 9.03132 1.40665C9.17393 1.33398 9.36062 1.33398 9.73398 1.33398H11.893C12.2444 1.33397 12.5476 1.33396 12.7973 1.35437C13.0609 1.3759 13.323 1.42344 13.5753 1.55197C13.9516 1.74372 14.2576 2.04968 14.4493 2.42601C14.5779 2.67826 14.6254 2.9404 14.6469 3.20397C14.6673 3.45368 14.6673 3.75685 14.6673 4.10827Z"
        fill="currentColor"
      />
    </>
  )
}
export const LargeGrid = () => {
  return (
    <>
      <path
        d="M7.33398 2.40065C7.33398 2.02728 7.33398 1.8406 7.26132 1.69799C7.19741 1.57255 7.09542 1.47056 6.96998 1.40665C6.82737 1.33398 6.64069 1.33398 6.26732 1.33398H4.10829C3.75687 1.33397 3.45368 1.33396 3.20397 1.35437C2.9404 1.3759 2.67826 1.42344 2.42601 1.55197C2.04968 1.74372 1.74372 2.04968 1.55197 2.42601C1.42344 2.67826 1.3759 2.9404 1.35437 3.20397C1.33396 3.45368 1.33397 3.75684 1.33398 4.10826V6.26732C1.33398 6.64069 1.33398 6.82737 1.40665 6.96998C1.47056 7.09542 1.57255 7.19741 1.69799 7.26132C1.8406 7.33398 2.02728 7.33398 2.40065 7.33398H6.26732C6.64069 7.33398 6.82737 7.33398 6.96998 7.26132C7.09542 7.19741 7.19741 7.09542 7.26132 6.96998C7.33398 6.82737 7.33398 6.64069 7.33398 6.26732V2.40065Z"
        fill="currentColor"
      />
      <path
        d="M2.40065 8.66732C2.02728 8.66732 1.8406 8.66732 1.69799 8.73998C1.57255 8.8039 1.47056 8.90588 1.40665 9.03132C1.33398 9.17393 1.33398 9.36062 1.33398 9.73398V11.893C1.33397 12.2444 1.33396 12.5476 1.35437 12.7973C1.3759 13.0609 1.42344 13.323 1.55197 13.5753C1.74372 13.9516 2.04968 14.2576 2.42601 14.4493C2.67826 14.5779 2.9404 14.6254 3.20397 14.6469C3.45368 14.6673 3.75685 14.6673 4.10827 14.6673H6.26732C6.64069 14.6673 6.82737 14.6673 6.96998 14.5947C7.09542 14.5307 7.19741 14.4288 7.26132 14.3033C7.33399 14.1607 7.33399 13.974 7.33399 13.6007V9.73398C7.33399 9.36062 7.33399 9.17393 7.26132 9.03132C7.19741 8.90588 7.09542 8.8039 6.96998 8.73998C6.82737 8.66732 6.64069 8.66732 6.26732 8.66732H2.40065Z"
        fill="currentColor"
      />
      <path
        d="M8.66732 13.6007C8.66732 13.974 8.66732 14.1607 8.73998 14.3033C8.8039 14.4288 8.90588 14.5307 9.03132 14.5947C9.17393 14.6673 9.36062 14.6673 9.73398 14.6673H11.893C12.2445 14.6673 12.5476 14.6673 12.7973 14.6469C13.0609 14.6254 13.323 14.5779 13.5753 14.4493C13.9516 14.2576 14.2576 13.9516 14.4493 13.5753C14.5779 13.323 14.6254 13.0609 14.6469 12.7973C14.6673 12.5476 14.6673 12.2445 14.6673 11.893V9.73398C14.6673 9.36062 14.6673 9.17393 14.5947 9.03132C14.5307 8.90588 14.4288 8.8039 14.3033 8.73998C14.1607 8.66732 13.974 8.66732 13.6007 8.66732H9.73398C9.36062 8.66732 9.17393 8.66732 9.03132 8.73998C8.90588 8.8039 8.8039 8.90588 8.73998 9.03132C8.66732 9.17393 8.66732 9.36062 8.66732 9.73398V13.6007Z"
        fill="currentColor"
      />
      <path
        d="M14.6673 6.26732C14.6673 6.64069 14.6673 6.82737 14.5947 6.96998C14.5307 7.09542 14.4288 7.19741 14.3033 7.26132C14.1607 7.33398 13.974 7.33398 13.6007 7.33398H9.73398C9.36062 7.33398 9.17393 7.33398 9.03132 7.26132C8.90588 7.19741 8.8039 7.09542 8.73998 6.96998C8.66732 6.82737 8.66732 6.64069 8.66732 6.26732V2.40065C8.66732 2.02728 8.66732 1.8406 8.73998 1.69799C8.8039 1.57255 8.90588 1.47056 9.03132 1.40665C9.17393 1.33398 9.36062 1.33398 9.73398 1.33398H11.893C12.2444 1.33397 12.5476 1.33396 12.7973 1.35437C13.0609 1.3759 13.323 1.42344 13.5753 1.55197C13.9516 1.74372 14.2576 2.04968 14.4493 2.42601C14.5779 2.67826 14.6254 2.9404 14.6469 3.20397C14.6673 3.45368 14.6673 3.75685 14.6673 4.10827V6.26732Z"
        fill="currentColor"
      />
    </>
  )
}

export const Google = () => {
  return (
    <>
      <path
        d="M18.1706 8.36922H17.4993V8.33464H9.99935V11.668H14.7089C14.0219 13.6084 12.1756 15.0013 9.99935 15.0013C7.2381 15.0013 4.99935 12.7626 4.99935 10.0013C4.99935 7.24005 7.2381 5.0013 9.99935 5.0013C11.2739 5.0013 12.4335 5.48214 13.3164 6.26755L15.6735 3.91047C14.1852 2.52339 12.1943 1.66797 9.99935 1.66797C5.39727 1.66797 1.66602 5.39922 1.66602 10.0013C1.66602 14.6034 5.39727 18.3346 9.99935 18.3346C14.6014 18.3346 18.3327 14.6034 18.3327 10.0013C18.3327 9.44255 18.2752 8.89714 18.1706 8.36922Z"
        fill="#FFC107"
      />
      <path
        d="M2.62695 6.12255L5.36487 8.13047C6.1057 6.2963 7.89987 5.0013 9.99945 5.0013C11.274 5.0013 12.4336 5.48214 13.3165 6.26755L15.6736 3.91047C14.1853 2.52339 12.1945 1.66797 9.99945 1.66797C6.79862 1.66797 4.02279 3.47505 2.62695 6.12255Z"
        fill="#FF3D00"
      />
      <path
        d="M10.0008 18.3317C12.1533 18.3317 14.1091 17.5079 15.5879 16.1683L13.0087 13.9858C12.1439 14.6435 11.0872 14.9992 10.0008 14.9983C7.83328 14.9983 5.99286 13.6163 5.29953 11.6875L2.58203 13.7812C3.9612 16.48 6.76203 18.3317 10.0008 18.3317Z"
        fill="#4CAF50"
      />
      <path
        d="M18.1713 8.36661H17.5V8.33203H10V11.6654H14.7096C14.3809 12.5889 13.7889 13.3959 13.0067 13.9866L13.0079 13.9858L15.5871 16.1683C15.4046 16.3341 18.3333 14.1654 18.3333 9.9987C18.3333 9.43995 18.2758 8.89453 18.1713 8.36661Z"
        fill="#1976D2"
      />
    </>
  )
}

export const Salesforce = () => {
  return (
    <>
      <path
        d="M8.82423 4.5057C9.4686 3.8343 10.3657 3.41789 11.3578 3.41789C12.6768 3.41789 13.8275 4.15336 14.4402 5.24516C14.9884 5.00032 15.5821 4.87413 16.1824 4.87484C18.5613 4.87484 20.4898 6.82016 20.4898 9.21977C20.4898 11.6197 18.5613 13.5651 16.1824 13.5651C15.8975 13.5652 15.6133 13.5369 15.334 13.4805C14.7943 14.443 13.766 15.0934 12.5857 15.0934C12.1084 15.094 11.6372 14.9855 11.2082 14.7763C10.6612 16.063 9.38665 16.9653 7.90118 16.9653C6.35431 16.9653 5.03602 15.9865 4.52993 14.6137C4.30884 14.6608 4.0797 14.6852 3.84462 14.6852C2.0029 14.6852 0.509774 13.1768 0.509774 11.3157C0.508447 10.7259 0.661715 10.146 0.954304 9.63393C1.24689 9.12182 1.66858 8.69532 2.17735 8.39695C1.9661 7.91064 1.85738 7.386 1.85798 6.85578C1.85798 4.71547 3.59556 2.98047 5.73884 2.98047C6.99712 2.98047 8.11532 3.57875 8.82423 4.5057Z"
        fill="#00A1E0"
      />
      <path
        d="M3.40295 10.2324C3.39045 10.2652 3.40748 10.272 3.41154 10.2777C3.44904 10.305 3.48716 10.3246 3.5256 10.3465C3.72943 10.4547 3.92177 10.4863 4.12302 10.4863C4.53287 10.4863 4.78732 10.2684 4.78732 9.91734V9.91055C4.78732 9.58609 4.50013 9.4682 4.2306 9.3832L4.1956 9.37172C3.9924 9.3057 3.81709 9.24883 3.81709 9.115V9.10797C3.81709 8.99352 3.91951 8.90922 4.07834 8.90922C4.25482 8.90922 4.46427 8.96781 4.5992 9.04242C4.5992 9.04242 4.63873 9.06805 4.65326 9.02961C4.66123 9.00914 4.72951 8.82531 4.7367 8.80539C4.74435 8.78375 4.73068 8.76781 4.71677 8.7593C4.56279 8.66555 4.3499 8.60156 4.12959 8.60156L4.08857 8.60187C3.71349 8.60187 3.45162 8.82844 3.45162 9.1532V9.16C3.45162 9.50242 3.74052 9.61336 4.01115 9.69078L4.05474 9.70422C4.25193 9.76477 4.42193 9.81687 4.42193 9.95578V9.96258C4.42193 10.0895 4.31146 10.1841 4.13326 10.1841C4.06412 10.1841 3.84357 10.1827 3.60529 10.032C3.57654 10.0152 3.55974 10.003 3.53756 9.98969C3.52584 9.98227 3.49662 9.96937 3.48381 10.0081L3.40295 10.2324ZM9.40295 10.2324C9.39045 10.2652 9.40748 10.272 9.41154 10.2777C9.44904 10.305 9.48716 10.3246 9.5256 10.3465C9.72935 10.4547 9.92177 10.4863 10.123 10.4863C10.5329 10.4863 10.7873 10.2684 10.7873 9.91734V9.91055C10.7873 9.58609 10.5001 9.4682 10.2306 9.3832L10.1956 9.37172C9.9924 9.3057 9.81701 9.24883 9.81701 9.115V9.10797C9.81701 8.99352 9.91951 8.90922 10.0783 8.90922C10.2548 8.90922 10.4643 8.96781 10.5992 9.04242C10.5992 9.04242 10.6387 9.06805 10.6533 9.02961C10.6612 9.00914 10.7295 8.82531 10.7366 8.80539C10.7444 8.78375 10.7307 8.76781 10.7167 8.7593C10.5628 8.66555 10.3498 8.60156 10.1296 8.60156L10.0886 8.60187C9.71341 8.60187 9.45162 8.82844 9.45162 9.1532V9.16C9.45162 9.50242 9.74045 9.61336 10.0111 9.69078L10.0547 9.70422C10.2519 9.76477 10.4222 9.81687 10.4222 9.95578V9.96258C10.4222 10.0895 10.3114 10.1841 10.1333 10.1841C9.94628 10.1854 9.76292 10.1326 9.60529 10.032C9.57654 10.0152 9.55943 10.0036 9.53787 9.98969C9.53045 9.98484 9.49568 9.97141 9.48373 10.0081L9.40295 10.2324ZM13.499 9.545C13.499 9.74344 13.4619 9.89969 13.3891 10.0101C13.3171 10.1195 13.2081 10.1726 13.0561 10.1726C12.9038 10.1726 12.7954 10.1197 12.7245 10.0101C12.6528 9.89992 12.6164 9.74344 12.6164 9.545C12.6164 9.34695 12.6528 9.19094 12.7245 9.08172C12.7954 8.97352 12.9038 8.92086 13.0561 8.92086C13.2081 8.92086 13.317 8.97352 13.3894 9.08164C13.462 9.19102 13.499 9.34695 13.499 9.545ZM13.8411 9.17727C13.8075 9.06375 13.7551 8.96359 13.6854 8.88016C13.6156 8.79648 13.5274 8.72937 13.4226 8.68039C13.3182 8.63172 13.1947 8.60695 13.0561 8.60695C12.9172 8.60695 12.7936 8.63172 12.6892 8.68039C12.5845 8.7293 12.4962 8.79648 12.4262 8.88016C12.3568 8.96383 12.3044 9.06406 12.2705 9.17727C12.2372 9.29031 12.2205 9.41383 12.2205 9.545C12.2205 9.67625 12.2372 9.80008 12.2705 9.91273C12.3044 10.026 12.3565 10.1262 12.4265 10.2099C12.498 10.295 12.5878 10.3627 12.6892 10.408C12.7939 10.4555 12.9172 10.4797 13.0561 10.4797C13.1947 10.4797 13.3179 10.4555 13.4226 10.408C13.5241 10.3627 13.6139 10.295 13.6854 10.2099C13.7551 10.1265 13.8075 10.0263 13.8411 9.91273C13.8747 9.79977 13.8915 9.67602 13.8915 9.545C13.8915 9.41414 13.8747 9.29031 13.8411 9.17727ZM16.6504 10.1197C16.639 10.0864 16.6069 10.0989 16.6069 10.0989C16.5571 10.118 16.5041 10.1356 16.4478 10.1445C16.3857 10.1537 16.323 10.1581 16.2602 10.1578C16.0946 10.1578 15.963 10.1086 15.8688 10.0112C15.7744 9.91391 15.7214 9.75656 15.7219 9.54359C15.7226 9.34984 15.7693 9.20406 15.8532 9.09305C15.9366 8.98266 16.0635 8.92602 16.2329 8.92602C16.374 8.92602 16.4816 8.94219 16.5944 8.97781C16.5944 8.97781 16.6214 8.98953 16.6342 8.95414C16.664 8.87109 16.6863 8.81156 16.7182 8.72023C16.7272 8.6943 16.7051 8.6832 16.6971 8.68008C16.6527 8.66273 16.5479 8.63453 16.4688 8.62258C16.3948 8.61125 16.3083 8.60523 16.2121 8.60523C16.0683 8.60523 15.9403 8.62969 15.8307 8.67867C15.7214 8.72734 15.6286 8.79453 15.5552 8.8782C15.4818 8.9618 15.426 9.06203 15.3887 9.17531C15.3517 9.28828 15.3329 9.41242 15.3329 9.54359C15.3329 9.82734 15.4095 10.0568 15.5606 10.2247C15.712 10.3932 15.9395 10.4788 16.236 10.4788C16.4113 10.4788 16.5912 10.4433 16.7204 10.3923C16.7204 10.3923 16.7452 10.3804 16.7344 10.3516L16.6504 10.1197ZM17.249 9.355C17.2652 9.24484 17.2957 9.1532 17.3426 9.0818C17.4135 8.97336 17.5216 8.91383 17.6736 8.91383C17.8256 8.91383 17.9261 8.97359 17.9981 9.0818C18.0459 9.1532 18.0667 9.24883 18.0749 9.355H17.249ZM18.4008 9.11281C18.3718 9.0032 18.2997 8.8925 18.2526 8.84187C18.1779 8.76156 18.1051 8.70547 18.0328 8.67422C17.9278 8.62971 17.8149 8.60686 17.7009 8.60703C17.5564 8.60703 17.4251 8.63125 17.3187 8.68125C17.212 8.73141 17.1223 8.79969 17.052 8.88484C16.9817 8.96961 16.9288 9.0707 16.8952 9.18539C16.8613 9.29945 16.8443 9.42391 16.8443 9.55508C16.8443 9.68859 16.8619 9.81289 16.8969 9.92477C16.9322 10.0375 16.9886 10.1369 17.0649 10.2191C17.1408 10.3019 17.2387 10.3668 17.356 10.412C17.4724 10.457 17.6138 10.4804 17.7763 10.4801C18.1108 10.4789 18.287 10.4044 18.3595 10.3642C18.3723 10.3572 18.3846 10.3446 18.3692 10.3087L18.2935 10.0967C18.2822 10.0651 18.25 10.0768 18.25 10.0768C18.1672 10.1075 18.0494 10.1627 17.7747 10.1622C17.5951 10.1619 17.4619 10.1089 17.3785 10.0261C17.2928 9.94133 17.251 9.81672 17.2436 9.64078L18.4017 9.64188C18.4017 9.64188 18.4322 9.64133 18.4353 9.61172C18.4364 9.59922 18.4751 9.37375 18.4008 9.11281ZM7.97427 9.355C7.99076 9.24484 8.02091 9.1532 8.06795 9.0818C8.13881 8.97336 8.24693 8.91383 8.39888 8.91383C8.55091 8.91383 8.65138 8.97359 8.72365 9.0818C8.77123 9.1532 8.79201 9.24883 8.80021 9.355H7.97427ZM9.12584 9.11281C9.09677 9.0032 9.02505 8.8925 8.97779 8.84187C8.90326 8.76156 8.83037 8.70547 8.7581 8.67422C8.65313 8.62971 8.54025 8.60686 8.42623 8.60703C8.28193 8.60703 8.15045 8.63125 8.04404 8.68125C7.93724 8.73141 7.84763 8.79969 7.77732 8.88484C7.70701 8.96961 7.65412 9.0707 7.62052 9.18539C7.58693 9.29945 7.56959 9.42391 7.56959 9.55508C7.56959 9.68859 7.58716 9.81289 7.62224 9.92477C7.65748 10.0375 7.71388 10.1369 7.79013 10.2191C7.86615 10.3019 7.96404 10.3668 8.08131 10.412C8.19771 10.457 8.33912 10.4804 8.50162 10.4801C8.83607 10.4789 9.01224 10.4044 9.08482 10.3642C9.09763 10.3572 9.10982 10.3446 9.09451 10.3087L9.01912 10.0967C9.0074 10.0651 8.97529 10.0768 8.97529 10.0768C8.89248 10.1075 8.7749 10.1627 8.49966 10.1622C8.32037 10.1619 8.18716 10.1089 8.10381 10.0261C8.0181 9.94133 7.97623 9.81672 7.96888 9.64078L9.12693 9.64188C9.12693 9.64188 9.1574 9.64133 9.16052 9.61172C9.1617 9.59922 9.20037 9.37375 9.12584 9.11281ZM5.47107 10.1133C5.42576 10.0772 5.41951 10.068 5.4042 10.0447C5.38138 10.0091 5.36974 9.95844 5.36974 9.89414C5.36974 9.79227 5.40334 9.71914 5.47302 9.66992C5.47224 9.67016 5.57263 9.58305 5.80896 9.58617C5.97482 9.58852 6.1231 9.61297 6.1231 9.61297V10.1395H6.12341C6.12341 10.1395 5.97623 10.1711 5.8106 10.181C5.5749 10.1952 5.47021 10.113 5.47107 10.1133ZM5.93185 9.29961C5.8849 9.29617 5.82404 9.29414 5.75115 9.29414C5.65177 9.29414 5.55584 9.30664 5.46599 9.33086C5.37924 9.35336 5.29727 9.39137 5.22404 9.44305C5.15411 9.49293 5.09663 9.55827 5.05607 9.63398C5.01513 9.71031 4.99435 9.80023 4.99435 9.90094C4.99435 10.0034 5.01193 10.0925 5.04724 10.1654C5.08167 10.2374 5.13365 10.2997 5.19841 10.3464C5.26271 10.3934 5.34216 10.4278 5.43435 10.4486C5.52513 10.4694 5.6281 10.4798 5.74084 10.4798C5.85959 10.4798 5.97795 10.4702 6.09263 10.4505C6.19024 10.4337 6.2875 10.415 6.38435 10.3942C6.42279 10.3851 6.46552 10.3734 6.46552 10.3734C6.49427 10.3663 6.49193 10.3355 6.49193 10.3355L6.49138 9.27656C6.49138 9.0443 6.42935 8.87211 6.30724 8.76539C6.18576 8.65891 6.0067 8.60516 5.77529 8.60516C5.68857 8.60516 5.54873 8.61711 5.46513 8.63391C5.46513 8.63391 5.21201 8.68281 5.10787 8.76422C5.10787 8.76422 5.08513 8.77844 5.09763 8.81031L5.17966 9.03062C5.18982 9.05906 5.21748 9.04938 5.21748 9.04938C5.21748 9.04938 5.22631 9.04602 5.23654 9.04C5.45935 8.91875 5.74115 8.9225 5.74115 8.9225C5.86638 8.9225 5.96255 8.9475 6.02748 8.99734C6.09068 9.0457 6.12279 9.11883 6.12279 9.27313V9.32203C6.02318 9.30781 5.93185 9.29961 5.93185 9.29961ZM15.2725 8.70281C15.2741 8.69895 15.275 8.69479 15.275 8.69058C15.2751 8.68637 15.2742 8.6822 15.2726 8.67832C15.271 8.67444 15.2686 8.67093 15.2656 8.66799C15.2626 8.66506 15.259 8.66277 15.2551 8.66125C15.2354 8.65359 15.1369 8.63281 15.0609 8.62797C14.9155 8.61914 14.8347 8.64359 14.7624 8.67609C14.6907 8.70852 14.611 8.76086 14.5665 8.82039V8.67945C14.5665 8.65984 14.5526 8.64422 14.5333 8.64422H14.2364C14.2171 8.64422 14.2031 8.65984 14.2031 8.67945V10.4068C14.2031 10.4262 14.219 10.4421 14.2384 10.4421H14.5426C14.5472 10.4421 14.5518 10.4412 14.5561 10.4394C14.5603 10.4376 14.5642 10.435 14.5674 10.4317C14.5707 10.4284 14.5733 10.4245 14.575 10.4203C14.5768 10.416 14.5777 10.4114 14.5776 10.4068V9.54383C14.5776 9.42805 14.5904 9.31242 14.6161 9.23992C14.6411 9.16812 14.6753 9.1107 14.7174 9.06937C14.7576 9.02977 14.8067 9.00031 14.8606 8.98344C14.9144 8.96695 14.9739 8.96156 15.016 8.96156C15.0766 8.96156 15.1432 8.97719 15.1432 8.97719C15.1654 8.97977 15.1779 8.96609 15.1854 8.94594C15.2052 8.89297 15.2616 8.73437 15.2724 8.70281"
        fill="white"
      />
      <path
        d="M12.4181 7.90256C12.3805 7.8912 12.3423 7.88207 12.3037 7.87522C12.2517 7.8667 12.199 7.86272 12.1463 7.86334C11.9368 7.86334 11.7717 7.92249 11.6559 8.0392C11.5406 8.1553 11.4623 8.33209 11.4231 8.56459L11.4088 8.64288H11.1459C11.1459 8.64288 11.114 8.6417 11.1072 8.67647L11.0642 8.91756C11.0611 8.9403 11.071 8.95483 11.1017 8.95483H11.3577L11.098 10.404C11.0779 10.5208 11.0545 10.6167 11.0286 10.6895C11.0033 10.7612 10.9786 10.8151 10.9478 10.8544C10.9181 10.8919 10.8903 10.9198 10.8419 10.936C10.802 10.9494 10.7559 10.9557 10.7055 10.9557C10.6777 10.9557 10.6404 10.9511 10.6128 10.9455C10.5912 10.9412 10.5702 10.9344 10.5502 10.9251C10.5502 10.9251 10.5203 10.9138 10.5084 10.9437C10.499 10.9685 10.4306 11.156 10.4224 11.1791C10.4145 11.2022 10.4258 11.2201 10.4403 11.2255C10.4745 11.2374 10.4998 11.2454 10.5462 11.2565C10.6105 11.2716 10.6649 11.2724 10.7159 11.2724C10.8223 11.2724 10.9196 11.2573 11.0002 11.2283C11.081 11.199 11.1516 11.148 11.2142 11.0791C11.2816 11.0046 11.3241 10.9266 11.3645 10.8199C11.4046 10.7146 11.4391 10.5837 11.4663 10.4312L11.7273 8.95483H12.1088C12.1088 8.95483 12.1409 8.95592 12.1474 8.92092L12.1907 8.68014C12.1935 8.65709 12.1839 8.64288 12.1528 8.64288H11.7825C11.7845 8.63459 11.8013 8.50428 11.8438 8.38163C11.862 8.32952 11.8961 8.28709 11.9248 8.25811C11.9519 8.23054 11.9852 8.20984 12.022 8.19772C12.0587 8.18577 12.1005 8.18006 12.1463 8.18006C12.181 8.18006 12.2155 8.18405 12.2413 8.18944C12.2773 8.19717 12.2912 8.20116 12.3005 8.20397C12.3384 8.21538 12.3435 8.20428 12.3509 8.186L12.4395 7.94303C12.4486 7.91686 12.4261 7.90569 12.4181 7.90256ZM7.24453 10.4073C7.24453 10.4265 7.23055 10.4423 7.21125 10.4423H6.90414C6.88477 10.4423 6.87109 10.4266 6.87109 10.4073V7.93561C6.87109 7.91631 6.88477 7.90061 6.90414 7.90061H7.21117C7.23055 7.90061 7.24453 7.91624 7.24453 7.93561V10.4073Z"
        fill="white"
      />
    </>
  )
}

export const MusicStop = () => {
  return (
    <>
      <rect width="10" height="10" rx="2" fill="currentColor" />
    </>
  )
}
export const MusicPlay = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00625 2.80243C8.0182 2.8104 8.03019 2.81839 8.04222 2.82642L18.591 9.8589C18.8962 10.0623 19.1792 10.251 19.3965 10.4263C19.6234 10.6092 19.8908 10.8629 20.0447 11.234C20.2481 11.7245 20.2481 12.2758 20.0447 12.7663C19.8908 13.1374 19.6234 13.391 19.3965 13.574C19.1792 13.7493 18.8962 13.9379 18.591 14.1413L8.00628 21.1978C7.63319 21.4465 7.29772 21.6702 7.01305 21.8245C6.72818 21.9789 6.33717 22.1553 5.8808 22.128C5.29705 22.0932 4.75779 21.8046 4.40498 21.3382C4.12916 20.9736 4.05905 20.5504 4.02949 20.2278C3.99994 19.9053 3.99997 19.5021 4 19.0537L4 4.98975C4 4.97529 4 4.96087 4 4.9465C3.99997 4.49811 3.99994 4.09491 4.02949 3.77249C4.05905 3.44983 4.12916 3.02663 4.40498 2.66202C4.75779 2.19565 5.29705 1.90705 5.8808 1.87219C6.33717 1.84494 6.72818 2.02135 7.01305 2.17573C7.29771 2.33 7.63317 2.55368 8.00625 2.80243Z"
        fill="currentColor"
      />
    </>
  )
}

export const Plus = () => {
  return (
    <>
      <path
        d="M12 5V19M5 12H19"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const PackagePlus = () => {
  return (
    <>
      <path
        d="M20.5 7.27783L12 12.0001M12 12.0001L3.49997 7.27783M12 12.0001L12 21.5001M14 20.889L12.777 21.5684C12.4934 21.726 12.3516 21.8047 12.2015 21.8356C12.0685 21.863 11.9315 21.863 11.7986 21.8356C11.6484 21.8047 11.5066 21.726 11.223 21.5684L3.82297 17.4573C3.52346 17.2909 3.37368 17.2077 3.26463 17.0893C3.16816 16.9847 3.09515 16.8606 3.05048 16.7254C3 16.5726 3 16.4013 3 16.0586V7.94153C3 7.59889 3 7.42757 3.05048 7.27477C3.09515 7.13959 3.16816 7.01551 3.26463 6.91082C3.37368 6.79248 3.52345 6.70928 3.82297 6.54288L11.223 2.43177C11.5066 2.27421 11.6484 2.19543 11.7986 2.16454C11.9315 2.13721 12.0685 2.13721 12.2015 2.16454C12.3516 2.19543 12.4934 2.27421 12.777 2.43177L20.177 6.54288C20.4766 6.70928 20.6263 6.79248 20.7354 6.91082C20.8318 7.01551 20.9049 7.13959 20.9495 7.27477C21 7.42757 21 7.59889 21 7.94153L21 12.5001M7.5 4.50008L16.5 9.50008M19 21.0001V15.0001M16 18.0001H22"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const FilePlus = () => {
  return (
    <>
      <path
        d="M20 10.5V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H12M14 11H8M10 15H8M16 7H8M18 21V15M15 18H21"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const Phone = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.6994 0.832032H7.30187C6.86259 0.832018 6.4836 0.832006 6.17146 0.857508C5.84201 0.884425 5.51433 0.943855 5.19901 1.10452C4.72861 1.3442 4.34615 1.72665 4.10647 2.19706C3.94581 2.51237 3.88638 2.84006 3.85946 3.16951C3.83396 3.48165 3.83397 3.8606 3.83399 4.29988V15.6975C3.83397 16.1368 3.83396 16.5158 3.85946 16.8279C3.88638 17.1573 3.94581 17.485 4.10647 17.8003C4.34615 18.2707 4.72861 18.6532 5.19901 18.8929C5.51433 19.0535 5.84201 19.113 6.17146 19.1399C6.4836 19.1654 6.86257 19.1654 7.30185 19.1654H13.6995C14.1387 19.1654 14.5177 19.1654 14.8298 19.1399C15.1593 19.113 15.487 19.0535 15.8023 18.8929C16.2727 18.6532 16.6552 18.2707 16.8948 17.8003C17.0555 17.485 17.1149 17.1573 17.1418 16.8279C17.1673 16.5158 17.1673 16.1368 17.1673 15.6976V4.29993C17.1673 3.86068 17.1673 3.48163 17.1418 3.16951C17.1149 2.84006 17.0555 2.51237 16.8948 2.19706C16.6552 1.72665 16.2727 1.3442 15.8023 1.10452C15.487 0.943855 15.1593 0.884425 14.8298 0.857508C14.5177 0.832006 14.1387 0.832018 13.6994 0.832032ZM10.5007 13.332C9.8103 13.332 9.25065 13.8917 9.25065 14.582C9.25065 15.2724 9.8103 15.832 10.5007 15.832C11.191 15.832 11.7507 15.2724 11.7507 14.582C11.7507 13.8917 11.191 13.332 10.5007 13.332Z"
        fill="currentColor"
      />
    </>
  )
}

export const HidePassword = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.91045 1.91205C2.23589 1.58661 2.76352 1.58661 3.08896 1.91205C8.09647 6.91955 13.0861 11.9091 18.089 16.912C18.4144 17.2375 18.4144 17.7651 18.089 18.0906C17.7635 18.416 17.2359 18.416 16.9104 18.0906L14.2823 15.4625C13.0783 16.167 11.6427 16.668 9.99969 16.668C7.61497 16.668 5.67082 15.6141 4.23032 14.4118C2.79178 13.2112 1.8055 11.8228 1.31154 11.0406L1.29147 11.009C1.19344 10.8547 1.06617 10.6543 1.00183 10.3736C0.949894 10.147 0.949911 9.85545 1.00188 9.62881C1.06625 9.34807 1.19389 9.14723 1.29217 8.99257L1.3124 8.96067C1.81438 8.16604 2.83379 6.73069 4.32916 5.50927L1.91045 3.09056C1.58501 2.76512 1.58501 2.23748 1.91045 1.91205ZM7.12797 8.30808C6.83484 8.80449 6.66637 9.38388 6.66637 10.0012C6.66637 11.8422 8.15876 13.3346 9.9997 13.3346C10.6171 13.3346 11.1965 13.1661 11.6929 12.873L10.4315 11.6116C10.2939 11.6484 10.1493 11.6679 9.9997 11.6679C9.07923 11.6679 8.33304 10.9217 8.33304 10.0012C8.33304 9.85167 8.35259 9.70699 8.38932 9.56943L7.12797 8.30808Z"
        fill="currentColor"
      />
      <path
        d="M13.3266 9.79267C13.2232 8.11791 11.8831 6.77782 10.2083 6.67439L7.32606 3.79211C8.14239 3.50711 9.035 3.33464 9.99971 3.33464C12.3844 3.33464 14.3286 4.38857 15.7691 5.59083C17.2076 6.79145 18.1939 8.17987 18.6879 8.96201L18.7079 8.99365C18.8059 9.14794 18.9332 9.34826 18.9975 9.62894C19.0495 9.85557 19.0495 10.147 18.9975 10.3737C18.9332 10.6543 18.8059 10.8547 18.7079 11.0089L18.6879 11.0406C18.3349 11.5994 17.7307 12.4677 16.8898 13.3559L13.3266 9.79267Z"
        fill="currentColor"
      />
    </>
  )
}

export const LogoutFilled = () => {
  return (
    <>
      <path
        d="M5.42571 1.33206C5.95596 1.33178 6.34974 1.33156 6.69084 1.42296C7.61108 1.66954 8.32987 2.38833 8.57645 3.30858C8.66785 3.64968 8.66764 4.04346 8.66735 4.57371V4.93211C8.66735 5.30548 8.66735 5.49217 8.59469 5.63477C8.53077 5.76021 8.42879 5.8622 8.30335 5.92612C8.16074 5.99878 7.97405 5.99878 7.60069 5.99878H6.00065C4.89608 5.99878 4.00065 6.89421 4.00065 7.99878C4.00065 9.10335 4.89608 9.99878 6.00065 9.99878H7.60068C7.97405 9.99878 8.16074 9.99878 8.30335 10.0714C8.42879 10.1354 8.53077 10.2373 8.59469 10.3628C8.66735 10.5054 8.66735 10.6921 8.66735 11.0654V11.4238C8.66764 11.9541 8.66785 12.3478 8.57645 12.6889C8.32987 13.6092 7.61108 14.328 6.69084 14.5746C6.34973 14.666 5.95596 14.6657 5.4257 14.6655L4.9778 14.6654C4.53128 14.6654 4.1627 14.6654 3.86096 14.6449C3.5481 14.6235 3.25871 14.5778 2.98016 14.4624C2.32675 14.1918 1.80762 13.6727 1.53697 13.0193C1.4216 12.7407 1.37591 12.4513 1.35456 12.1385C1.33397 11.8367 1.33398 11.4681 1.33398 11.0216V4.9759C1.33398 4.52938 1.33397 4.1608 1.35456 3.85907C1.37591 3.54621 1.4216 3.25682 1.53697 2.97827C1.80762 2.32486 2.32676 1.80573 2.98016 1.53508C3.25871 1.41971 3.5481 1.37402 3.86096 1.35267C4.1627 1.33208 4.53128 1.33209 4.97781 1.3321L5.42571 1.33206Z"
        fill="currentColor"
      />
      <path
        d="M10.1959 4.19404C10.4563 3.93369 10.8784 3.93369 11.1387 4.19404L14.4721 7.52737C14.7324 7.78772 14.7324 8.20983 14.4721 8.47018L11.1387 11.8035C10.8784 12.0639 10.4563 12.0639 10.1959 11.8035C9.93556 11.5432 9.93556 11.1211 10.1959 10.8607L12.3912 8.66545H6.00065C5.63246 8.66545 5.33398 8.36697 5.33398 7.99878C5.33398 7.63059 5.63246 7.33211 6.00065 7.33211H12.3912L10.1959 5.13685C9.93556 4.8765 9.93556 4.45439 10.1959 4.19404Z"
        fill="currentColor"
      />
    </>
  )
}

export const Logout = () => {
  return (
    <>
      <path opacity="0.12" d="M2.5 17.5V2.5H10V17.5H2.5Z" fill="currentColor" />
      <path
        d="M13.3333 14.1667L17.5 10M17.5 10L13.3333 5.83333M17.5 10H7.5M10 14.1667C10 14.9416 10 15.3291 9.91482 15.647C9.68365 16.5098 9.00978 17.1836 8.14705 17.4148C7.82913 17.5 7.44164 17.5 6.66667 17.5H6.25C5.08515 17.5 4.50272 17.5 4.04329 17.3097C3.43072 17.056 2.94404 16.5693 2.6903 15.9567C2.5 15.4973 2.5 14.9149 2.5 13.75V6.25C2.5 5.08515 2.5 4.50272 2.6903 4.04329C2.94404 3.43072 3.43072 2.94404 4.04329 2.6903C4.50272 2.5 5.08515 2.5 6.25 2.5H6.66667C7.44164 2.5 7.82913 2.5 8.14705 2.58519C9.00978 2.81635 9.68365 3.49022 9.91482 4.35295C10 4.67087 10 5.05836 10 5.83333"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const PuzzlePiece1 = () => {
  return (
    <>
      <path
        opacity="0.12"
        d="M7.5 4.5C7.5 3.11929 8.61929 2 10 2C11.3807 2 12.5 3.11929 12.5 4.5V6H13.5C14.8978 6 15.5967 6 16.1481 6.22836C16.8831 6.53284 17.4672 7.11687 17.7716 7.85195C18 8.40326 18 9.10218 18 10.5H19.5C20.8807 10.5 22 11.6193 22 13C22 14.3807 20.8807 15.5 19.5 15.5H18V17.2C18 18.8802 18 19.7202 17.673 20.362C17.3854 20.9265 16.9265 21.3854 16.362 21.673C15.7202 22 14.8802 22 13.2 22H12.5V20.25C12.5 19.0074 11.4926 18 10.25 18C9.00736 18 8 19.0074 8 20.25V22H6.8C5.11984 22 4.27976 22 3.63803 21.673C3.07354 21.3854 2.6146 20.9265 2.32698 20.362C2 19.7202 2 18.8802 2 17.2V15.5H3.5C4.88071 15.5 6 14.3807 6 13C6 11.6193 4.88071 10.5 3.5 10.5H2C2 9.10218 2 8.40326 2.22836 7.85195C2.53284 7.11687 3.11687 6.53284 3.85195 6.22836C4.40326 6 5.10218 6 6.5 6H7.5V4.5Z"
        fill="currentColor"
      />
      <path
        d="M7.5 4.5C7.5 3.11929 8.61929 2 10 2C11.3807 2 12.5 3.11929 12.5 4.5V6H13.5C14.8978 6 15.5967 6 16.1481 6.22836C16.8831 6.53284 17.4672 7.11687 17.7716 7.85195C18 8.40326 18 9.10218 18 10.5H19.5C20.8807 10.5 22 11.6193 22 13C22 14.3807 20.8807 15.5 19.5 15.5H18V17.2C18 18.8802 18 19.7202 17.673 20.362C17.3854 20.9265 16.9265 21.3854 16.362 21.673C15.7202 22 14.8802 22 13.2 22H12.5V20.25C12.5 19.0074 11.4926 18 10.25 18C9.00736 18 8 19.0074 8 20.25V22H6.8C5.11984 22 4.27976 22 3.63803 21.673C3.07354 21.3854 2.6146 20.9265 2.32698 20.362C2 19.7202 2 18.8802 2 17.2V15.5H3.5C4.88071 15.5 6 14.3807 6 13C6 11.6193 4.88071 10.5 3.5 10.5H2C2 9.10218 2 8.40326 2.22836 7.85195C2.53284 7.11687 3.11687 6.53284 3.85195 6.22836C4.40326 6 5.10218 6 6.5 6H7.5V4.5Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const FolderLock = () => {
  return (
    <>
      <path
        d="M14.0013 12.834C13.461 12.834 12.9492 12.9564 12.4923 13.1751L17.1602 17.843C17.3789 17.3861 17.5013 16.8743 17.5013 16.334C17.5013 14.401 15.9343 12.834 14.0013 12.834Z"
        fill="currentColor"
      />
      <path
        d="M10.5013 16.334C10.5013 15.7936 10.6237 15.2819 10.8424 14.825L15.5103 19.4929C15.0534 19.7115 14.5416 19.834 14.0013 19.834C12.0683 19.834 10.5013 18.267 10.5013 16.334Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.16797 7.18927V18.9489C1.16796 19.888 1.16795 20.6631 1.21953 21.2944C1.27311 21.9502 1.3881 22.553 1.67661 23.1193C2.12402 23.9974 2.83793 24.7113 3.71602 25.1587C4.28224 25.4472 4.88506 25.5622 5.54084 25.6158C6.17223 25.6673 6.94734 25.6673 7.88646 25.6673H20.1161C21.0553 25.6673 21.8304 25.6673 22.4618 25.6158C23.1175 25.5622 23.7204 25.4472 24.2866 25.1587C25.1647 24.7113 25.8786 23.9974 26.326 23.1193C26.6145 22.553 26.7295 21.9502 26.7831 21.2944C26.8347 20.6631 26.8347 19.888 26.8346 18.9489V13.7191C26.8347 12.78 26.8347 12.0049 26.7831 11.3735C26.7295 10.7177 26.6145 10.1149 26.326 9.5487C25.8786 8.67061 25.1647 7.9567 24.2866 7.50929C23.7204 7.22078 23.1175 7.10579 22.4618 7.05221C21.8304 7.00062 21.0553 7.00064 20.1161 7.00065H15.8889L14.8452 4.91306C14.5364 4.29327 14.2647 3.74823 13.8416 3.33377C13.4709 2.97076 13.0242 2.69469 12.5338 2.52553C11.9739 2.33239 11.3649 2.33319 10.6724 2.33411L6.023 2.33423C5.408 2.33421 4.87744 2.3342 4.44044 2.3699C3.9792 2.40758 3.52045 2.49079 3.07901 2.71571C2.42044 3.05127 1.88501 3.5867 1.54945 4.24527C1.32452 4.68671 1.24132 5.14547 1.20364 5.6067C1.16793 6.04368 1.16795 6.5743 1.16797 7.18927ZM11.773 4.73133C11.6322 4.68279 11.4495 4.66757 10.5273 4.66757H6.06797C5.39533 4.66757 4.96101 4.66848 4.63045 4.69548C4.31351 4.72138 4.196 4.76534 4.13832 4.79473C3.91879 4.90658 3.74032 5.08506 3.62846 5.30458C3.59907 5.36226 3.55512 5.47977 3.52922 5.79671C3.50548 6.08734 3.50191 6.45817 3.50139 7.00065L13.2801 7.00065L12.823 6.08639C12.4106 5.2616 12.3153 5.10491 12.2089 5.00075C12.0854 4.87975 11.9365 4.78772 11.773 4.73133ZM8.16797 16.334C8.16797 13.1123 10.7796 10.5007 14.0013 10.5007C17.223 10.5007 19.8346 13.1123 19.8346 16.334C19.8346 19.5556 17.223 22.1673 14.0013 22.1673C10.7796 22.1673 8.16797 19.5556 8.16797 16.334Z"
        fill="currentColor"
      />
    </>
  )
}
export const FolderLockOutline = () => {
  return (
    <>
      <path
        d="M13 7L11.8845 4.76892C11.5634 4.1268 11.4029 3.80573 11.1634 3.57116C10.9516 3.36373 10.6963 3.20597 10.4161 3.10931C10.0992 3 9.74021 3 9.02229 3H5.2C4.0799 3 3.51984 3 3.09202 3.21799C2.71569 3.40973 2.40973 3.71569 2.21799 4.09202C2 4.51984 2 5.0799 2 6.2V7M2 7H17.2C18.8802 7 19.7202 7 20.362 7.32698C20.9265 7.6146 21.3854 8.07354 21.673 8.63803C22 9.27976 22 10.1198 22 11.8V16.2C22 17.8802 22 18.7202 21.673 19.362C21.3854 19.9265 20.9265 20.3854 20.362 20.673C19.7202 21 18.8802 21 17.2 21H6.8C5.11984 21 4.27976 21 3.63803 20.673C3.07354 20.3854 2.6146 19.9265 2.32698 19.362C2 18.7202 2 17.8802 2 16.2V7ZM10.1 17.5H13.9C14.4601 17.5 14.7401 17.5 14.954 17.391C15.1422 17.2951 15.2951 17.1422 15.391 16.954C15.5 16.7401 15.5 16.4601 15.5 15.9V15.1C15.5 14.5399 15.5 14.2599 15.391 14.046C15.2951 13.8578 15.1422 13.7049 14.954 13.609C14.7401 13.5 14.4601 13.5 13.9 13.5H10.1C9.53995 13.5 9.25992 13.5 9.04601 13.609C8.85785 13.7049 8.70487 13.8578 8.60899 14.046C8.5 14.2599 8.5 14.5399 8.5 15.1V15.9C8.5 16.4601 8.5 16.7401 8.60899 16.954C8.70487 17.1422 8.85785 17.2951 9.04601 17.391C9.25992 17.5 9.53995 17.5 10.1 17.5ZM13.75 13.5V11.75C13.75 10.7835 12.9665 10 12 10C11.0335 10 10.25 10.7835 10.25 11.75V13.5H13.75Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const FolderSearch = () => {
  return (
    <>
      <path
        d="M11.5 11C10.1193 11 9 12.1193 9 13.5C9 14.8807 10.1193 16 11.5 16C12.8807 16 14 14.8807 14 13.5C14 12.1193 12.8807 11 11.5 11Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 6.16167V16.2413C0.999989 17.0463 0.99998 17.7106 1.0442 18.2518C1.09012 18.8139 1.18869 19.3306 1.43598 19.816C1.81947 20.5686 2.43139 21.1805 3.18404 21.564C3.66938 21.8113 4.18608 21.9099 4.74818 21.9558C5.28937 22 5.95374 22 6.7587 22H17.2413C18.0463 22 18.7106 22 19.2518 21.9558C19.8139 21.9099 20.3306 21.8113 20.816 21.564C21.5686 21.1805 22.1805 20.5686 22.564 19.816C22.8113 19.3306 22.9099 18.8139 22.9558 18.2518C23 17.7106 23 17.0463 23 16.2413V11.7587C23 10.9537 23 10.2894 22.9558 9.74817C22.9099 9.18608 22.8113 8.66937 22.564 8.18404C22.1805 7.43139 21.5686 6.81947 20.816 6.43598C20.3306 6.18868 19.8139 6.09012 19.2518 6.04419C18.7106 5.99998 18.0463 5.99999 17.2413 6H13.6179L12.7234 4.21064C12.4586 3.67939 12.2258 3.21221 11.8631 2.85696C11.5454 2.54581 11.1625 2.30918 10.7421 2.16418C10.2622 1.99863 9.74022 1.99932 9.14666 2.00011L5.16146 2.00021C4.63431 2.0002 4.17955 2.00018 3.80498 2.03078C3.40963 2.06309 3.01641 2.1344 2.63803 2.3272C2.07355 2.61482 1.6146 3.07376 1.32698 3.63824C1.13419 4.01662 1.06287 4.40984 1.03057 4.80519C0.999971 5.17974 0.999985 5.63456 1 6.16167ZM10.09 4.05487C9.96938 4.01326 9.81271 4.00022 9.02229 4.00022H5.2C4.62345 4.00022 4.25118 4.00099 3.96784 4.02414C3.69618 4.04634 3.59546 4.08402 3.54601 4.10921C3.35785 4.20508 3.20487 4.35806 3.109 4.54622C3.0838 4.59567 3.04613 4.69639 3.02393 4.96805C3.00358 5.21716 3.00052 5.53501 3.00008 6L11.3819 6L10.99 5.21635C10.6366 4.50938 10.5548 4.37508 10.4637 4.2858C10.3578 4.18208 10.2301 4.1032 10.09 4.05487ZM7 13.5C7 11.0147 9.01472 9 11.5 9C13.9853 9 16 11.0147 16 13.5C16 14.3805 15.7471 15.202 15.31 15.8957L16.2071 16.7929C16.5976 17.1834 16.5976 17.8166 16.2071 18.2071C15.8166 18.5976 15.1834 18.5976 14.7929 18.2071L13.8957 17.31C13.202 17.7471 12.3805 18 11.5 18C9.01472 18 7 15.9853 7 13.5Z"
        fill="currentColor"
      />
    </>
  )
}

export const FolderSearchOutline = () => {
  return (
    <>
      <path
        d="M13 7L11.8845 4.76892C11.5634 4.1268 11.4029 3.80573 11.1634 3.57116C10.9516 3.36373 10.6963 3.20597 10.4161 3.10931C10.0992 3 9.74021 3 9.02229 3H5.2C4.0799 3 3.51984 3 3.09202 3.21799C2.71569 3.40973 2.40973 3.71569 2.21799 4.09202C2 4.51984 2 5.0799 2 6.2V7M2 7H17.2C18.8802 7 19.7202 7 20.362 7.32698C20.9265 7.6146 21.3854 8.07354 21.673 8.63803C22 9.27976 22 10.1198 22 11.8V16.2C22 17.8802 22 18.7202 21.673 19.362C21.3854 19.9265 20.9265 20.3854 20.362 20.673C19.7202 21 18.8802 21 17.2 21H6.8C5.11984 21 4.27976 21 3.63803 20.673C3.07354 20.3854 2.6146 19.9265 2.32698 19.362C2 18.7202 2 17.8802 2 16.2V7ZM15.5 17.5L14 16M15 13.5C15 15.433 13.433 17 11.5 17C9.567 17 8 15.433 8 13.5C8 11.567 9.567 10 11.5 10C13.433 10 15 11.567 15 13.5Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const FileSearch = () => {
  return (
    <>
      <path
        d="M14 11H8M10 15H8M16 7H8M20 10.5V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H11.5M22 22L20.5 20.5M21.5 18C21.5 19.933 19.933 21.5 18 21.5C16.067 21.5 14.5 19.933 14.5 18C14.5 16.067 16.067 14.5 18 14.5C19.933 14.5 21.5 16.067 21.5 18Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const FolderCheck = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 6.16167V16.2413C0.999989 17.0463 0.99998 17.7106 1.0442 18.2518C1.09012 18.8139 1.18869 19.3306 1.43598 19.816C1.81947 20.5686 2.43139 21.1805 3.18404 21.564C3.66938 21.8113 4.18608 21.9099 4.74818 21.9558C5.28937 22 5.95374 22 6.7587 22H17.2413C18.0463 22 18.7106 22 19.2518 21.9558C19.8139 21.9099 20.3306 21.8113 20.816 21.564C21.5686 21.1805 22.1805 20.5686 22.564 19.816C22.8113 19.3306 22.9099 18.8139 22.9558 18.2518C23 17.7106 23 17.0463 23 16.2413V11.7587C23 10.9537 23 10.2894 22.9558 9.74817C22.9099 9.18608 22.8113 8.66937 22.564 8.18404C22.1805 7.43139 21.5686 6.81947 20.816 6.43598C20.3306 6.18868 19.8139 6.09012 19.2518 6.04419C18.7106 5.99998 18.0463 5.99999 17.2413 6H13.6179L12.7234 4.21064C12.4586 3.67939 12.2258 3.21221 11.8631 2.85696C11.5454 2.54581 11.1625 2.30918 10.7421 2.16418C10.2622 1.99863 9.74022 1.99932 9.14666 2.00011L5.16146 2.00021C4.63431 2.0002 4.17955 2.00018 3.80498 2.03078C3.40963 2.06309 3.01641 2.1344 2.63803 2.3272C2.07355 2.61482 1.6146 3.07376 1.32698 3.63824C1.13419 4.01662 1.06287 4.40984 1.03057 4.80519C0.999971 5.17974 0.999985 5.63456 1 6.16167ZM10.09 4.05487C9.96938 4.01326 9.81271 4.00022 9.02229 4.00022H5.2C4.62345 4.00022 4.25118 4.00099 3.96784 4.02414C3.69618 4.04634 3.59546 4.08402 3.54601 4.10921C3.35785 4.20508 3.20487 4.35806 3.109 4.54622C3.0838 4.59567 3.04613 4.69639 3.02393 4.96805C3.00358 5.21716 3.00052 5.53501 3.00008 6L11.3819 6L10.99 5.21635C10.6366 4.50938 10.5548 4.37508 10.4637 4.2858C10.3578 4.18208 10.2301 4.1032 10.09 4.05487ZM16.2071 12.2071C16.5976 11.8166 16.5976 11.1834 16.2071 10.7929C15.8166 10.4024 15.1834 10.4024 14.7929 10.7929L11 14.5858L9.70711 13.2929C9.31658 12.9024 8.68342 12.9024 8.29289 13.2929C7.90237 13.6834 7.90237 14.3166 8.29289 14.7071L10.2929 16.7071C10.6834 17.0976 11.3166 17.0976 11.7071 16.7071L16.2071 12.2071Z"
        fill="currentColor"
      />
    </>
  )
}

export const FolderPlus = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 6.16167V16.2413C0.999989 17.0463 0.99998 17.7106 1.0442 18.2518C1.09012 18.8139 1.18869 19.3306 1.43598 19.816C1.81947 20.5686 2.43139 21.1805 3.18404 21.564C3.66938 21.8113 4.18608 21.9099 4.74818 21.9558C5.28937 22 5.95374 22 6.7587 22H17.2413C18.0463 22 18.7106 22 19.2518 21.9558C19.8139 21.9099 20.3306 21.8113 20.816 21.564C21.5686 21.1805 22.1805 20.5686 22.564 19.816C22.8113 19.3306 22.9099 18.8139 22.9558 18.2518C23 17.7106 23 17.0463 23 16.2413V11.7587C23 10.9537 23 10.2894 22.9558 9.74817C22.9099 9.18608 22.8113 8.66937 22.564 8.18404C22.1805 7.43139 21.5686 6.81947 20.816 6.43598C20.3306 6.18868 19.8139 6.09012 19.2518 6.04419C18.7106 5.99998 18.0463 5.99999 17.2413 6H13.6179L12.7234 4.21064C12.4586 3.67939 12.2258 3.21221 11.8631 2.85696C11.5454 2.54581 11.1625 2.30918 10.7421 2.16418C10.2622 1.99863 9.74022 1.99932 9.14666 2.00011L5.16146 2.00021C4.63431 2.0002 4.17955 2.00018 3.80498 2.03078C3.40963 2.06309 3.01641 2.1344 2.63803 2.3272C2.07355 2.61482 1.6146 3.07376 1.32698 3.63824C1.13419 4.01662 1.06287 4.40984 1.03057 4.80519C0.999971 5.17974 0.999985 5.63456 1 6.16167ZM10.09 4.05487C9.96938 4.01326 9.81271 4.00022 9.02229 4.00022H5.2C4.62345 4.00022 4.25118 4.00099 3.96784 4.02414C3.69618 4.04634 3.59546 4.08402 3.54601 4.10921C3.35785 4.20508 3.20487 4.35806 3.109 4.54622C3.0838 4.59567 3.04613 4.69639 3.02393 4.96805C3.00358 5.21716 3.00052 5.53501 3.00008 6L11.3819 6L10.99 5.21635C10.6366 4.50938 10.5548 4.37508 10.4637 4.2858C10.3578 4.18208 10.2301 4.1032 10.09 4.05487ZM12 10C12.5523 10 13 10.4477 13 11V13H15C15.5523 13 16 13.4477 16 14C16 14.5523 15.5523 15 15 15H13V17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17V15H9C8.44772 15 8 14.5523 8 14C8 13.4477 8.44772 13 9 13H11V11C11 10.4477 11.4477 10 12 10Z"
        fill="currentColor"
      />
    </>
  )
}

export const FolderPlusOutline = () => {
  return (
    <>
      <path
        d="M13 7L11.8845 4.76892C11.5634 4.1268 11.4029 3.80573 11.1634 3.57116C10.9516 3.36373 10.6963 3.20597 10.4161 3.10931C10.0992 3 9.74021 3 9.02229 3H5.2C4.0799 3 3.51984 3 3.09202 3.21799C2.71569 3.40973 2.40973 3.71569 2.21799 4.09202C2 4.51984 2 5.0799 2 6.2V7M2 7H17.2C18.8802 7 19.7202 7 20.362 7.32698C20.9265 7.6146 21.3854 8.07354 21.673 8.63803C22 9.27976 22 10.1198 22 11.8V16.2C22 17.8802 22 18.7202 21.673 19.362C21.3854 19.9265 20.9265 20.3854 20.362 20.673C19.7202 21 18.8802 21 17.2 21H6.8C5.11984 21 4.27976 21 3.63803 20.673C3.07354 20.3854 2.6146 19.9265 2.32698 19.362C2 18.7202 2 17.8802 2 16.2V7ZM12 17V11M9 14H15"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const Close = () => {
  return (
    <>
      <path
        d="M7.33464 0.666016L0.667969 7.33268M0.667969 0.666016L7.33464 7.33268"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const Close2 = () => {
  return (
    <>
      <path
        d="M18 6L6 18M6 6L18 18"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const CloseSmall = () => {
  return (
    <>
      <path
        d="M17 7L7 17M7 7L17 17"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const SadFace = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.58202 4.08299C0.166016 7.50366 0.166016 13.001 0.166016 24.0003C0.166016 34.9997 0.166016 40.4993 3.58202 43.9153C7.00268 47.3337 12.5 47.3337 23.4994 47.3337C34.4987 47.3337 39.9984 47.3337 43.4144 43.9153C46.8327 40.5017 46.8327 34.9997 46.8327 24.0003C46.8327 13.001 46.8327 7.50133 43.4144 4.08299C40.0007 0.666992 34.4987 0.666992 23.4994 0.666992C12.5 0.666992 7.00035 0.666992 3.58202 4.08299ZM15.0924 36.71C15.2294 36.8947 15.4015 37.0507 15.5988 37.1688C15.7961 37.287 16.0148 37.3651 16.2424 37.3987C16.4699 37.4323 16.7019 37.4207 16.9249 37.3646C17.148 37.3085 17.3578 37.2089 17.5423 37.0717C19.2616 35.7837 21.3512 35.0863 23.4994 35.0837C25.6474 35.0868 27.7369 35.7842 29.4564 37.0717C29.6403 37.2148 29.8511 37.3198 30.0762 37.3804C30.3013 37.441 30.5363 37.456 30.7673 37.4245C30.9983 37.3931 31.2207 37.3158 31.4214 37.1971C31.6221 37.0785 31.7971 36.921 31.9361 36.7338C32.0751 36.5466 32.1753 36.3336 32.2308 36.1071C32.2863 35.8807 32.296 35.6455 32.2593 35.4152C32.2226 35.185 32.1403 34.9644 32.0172 34.7664C31.8941 34.5684 31.7326 34.3971 31.5424 34.2623C29.2201 32.5261 26.399 31.5865 23.4994 31.5837C20.5997 31.5865 17.7787 32.5261 15.4564 34.2623C15.0835 34.5387 14.8358 34.9518 14.7675 35.4108C14.6992 35.8698 14.8161 36.3371 15.0924 36.71ZM32.8327 20.5003C32.8327 22.4323 31.7874 24.0003 30.4994 24.0003C29.2114 24.0003 28.166 22.4323 28.166 20.5003C28.166 18.5683 29.2114 17.0003 30.4994 17.0003C31.7874 17.0003 32.8327 18.5683 32.8327 20.5003ZM16.4993 24.0003C17.7873 24.0003 18.8327 22.4323 18.8327 20.5003C18.8327 18.5683 17.7873 17.0003 16.4993 17.0003C15.2114 17.0003 14.166 18.5683 14.166 20.5003C14.166 22.4323 15.2114 24.0003 16.4993 24.0003Z"
        fill="#CFCDEB"
      />
    </>
  )
}

export const SellersIcon = () => {
  return (
    <>
      <path
        d="M6.16146 2H17.8385C18.3657 1.99998 18.8205 1.99997 19.195 2.03057C19.5904 2.06287 19.9836 2.13419 20.362 2.32698C20.9265 2.6146 21.3854 3.07355 21.673 3.63803C21.8658 4.01641 21.9371 4.40963 21.9694 4.80498C22 5.17954 22 5.6343 22 6.16144L22 7C22 7.9263 21.0031 9 19.3333 9C17.6636 9 16.6667 7.9263 16.6667 7C16.6667 6.44772 16.219 6 15.6667 6C15.1144 6 14.6667 6.44772 14.6667 7C14.6667 7.9263 13.6697 9 12 9C10.3303 9 9.33333 7.9263 9.33333 7C9.33333 6.44772 8.88562 6 8.33333 6C7.78105 6 7.33333 6.44772 7.33333 7C7.33333 7.9263 6.33641 9 4.66667 9C2.99692 9 2 7.9263 2 7V6.16142C1.99998 5.63431 1.99997 5.17953 2.03057 4.80498C2.06287 4.40963 2.13419 4.01641 2.32698 3.63803C2.6146 3.07355 3.07355 2.6146 3.63803 2.32698C4.01641 2.13419 4.40963 2.06287 4.80498 2.03057C5.17953 1.99997 5.63434 1.99998 6.16146 2Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.3333 11C20.2837 11 21.2191 10.7429 22 10.2821V17.8386C22 18.3657 22 18.8205 21.9694 19.195C21.9371 19.5904 21.8658 19.9836 21.673 20.362C21.3854 20.9265 20.9265 21.3854 20.362 21.673C19.9836 21.8658 19.5904 21.9371 19.195 21.9694C18.8205 22 18.3657 22 17.8386 22H6.16144C5.6343 22 5.17954 22 4.80498 21.9694C4.40963 21.9371 4.01641 21.8658 3.63803 21.673C3.07355 21.3854 2.6146 20.9265 2.32698 20.362C2.13419 19.9836 2.06287 19.5904 2.03057 19.195C1.99997 18.8205 1.99998 18.3657 2 17.8386V10.2821C2.78088 10.7429 3.71628 11 4.66667 11C6.07207 11 7.4447 10.4379 8.33333 9.486C9.22197 10.4379 10.5946 11 12 11C13.4054 11 14.778 10.4379 15.6667 9.486C16.5553 10.4379 17.9279 11 19.3333 11ZM10.6 14H13.4C13.9601 14 14.2401 14 14.454 14.109C14.6422 14.2049 14.7951 14.3578 14.891 14.546C15 14.7599 15 15.0399 15 15.6V20H9V15.6C9 15.0399 9 14.7599 9.10899 14.546C9.20487 14.3578 9.35785 14.2049 9.54601 14.109C9.75992 14 10.0399 14 10.6 14Z"
        fill="currentColor"
      />
    </>
  )
}

export const Eye = () => {
  return (
    <>
      <path
        opacity="0.12"
        d="M10 13C11.3807 13 12.5 11.8807 12.5 10.5C12.5 9.11929 11.3807 8 10 8C8.61929 8 7.5 9.11929 7.5 10.5C7.5 11.8807 8.61929 13 10 13Z"
        fill="currentColor"
      />
      <path
        d="M10 16.3333C14.2542 16.3333 17.0458 12.5793 17.9836 11.0943C18.0967 10.9146 18.1535 10.8247 18.1852 10.6861C18.2091 10.582 18.2091 10.4178 18.1852 10.3137C18.1535 10.1751 18.0967 10.0852 17.9836 9.90552C17.0458 8.4205 14.2542 4.66659 10 4.66659C5.74581 4.66659 2.95425 8.4205 2.01641 9.90552C1.90327 10.0852 1.84651 10.1751 1.81475 10.3137C1.79088 10.4178 1.79088 10.582 1.81475 10.6861C1.84651 10.8247 1.90327 10.9146 2.01641 11.0943C2.95425 12.5793 5.74581 16.3333 10 16.3333Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 13C11.3807 13 12.5 11.8807 12.5 10.5C12.5 9.11929 11.3807 8 10 8C8.61929 8 7.5 9.11929 7.5 10.5C7.5 11.8807 8.61929 13 10 13Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const EyeOff = () => {
  return (
    <>
      <path
        opacity="0.12"
        d="M7.5 10.5002C7.5 11.8809 8.61929 13.0002 10 13.0002C10.6904 13.0002 11.3154 12.7204 11.7678 12.268L8.23223 8.73242C7.77982 9.18483 7.5 9.80983 7.5 10.5002Z"
        fill="currentColor"
      />
      <path
        d="M8.95245 4.7436C9.29113 4.69353 9.6405 4.66667 10.0003 4.66667C14.2545 4.66667 17.0461 8.4207 17.9839 9.90569C18.0974 10.0854 18.1542 10.1753 18.1859 10.3139C18.2098 10.418 18.2098 10.5822 18.1859 10.6863C18.1541 10.8249 18.097 10.9154 17.9827 11.0963C17.7328 11.4918 17.3518 12.0476 16.8471 12.6504M5.6036 6.09586C3.80187 7.31808 2.57871 9.01615 2.01759 9.9044C1.90357 10.0849 1.84656 10.1751 1.81478 10.3137C1.79091 10.4178 1.7909 10.582 1.81476 10.6861C1.84652 10.8247 1.90328 10.9146 2.01678 11.0943C2.95462 12.5793 5.74618 16.3333 10.0003 16.3333C11.7157 16.3333 13.1932 15.723 14.4073 14.8972M2.50035 3L17.5003 18M8.23258 8.73223C7.78017 9.18464 7.50035 9.80964 7.50035 10.5C7.50035 11.8807 8.61963 13 10.0003 13C10.6907 13 11.3157 12.7202 11.7681 12.2678"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

// for 24 24
export const EyeOff2 = () => {
  return (
    <>
      <path
        d="M10.7429 5.09232C11.1494 5.03223 11.5686 5 12.0004 5C17.1054 5 20.4553 9.50484 21.5807 11.2868C21.7169 11.5025 21.785 11.6103 21.8231 11.7767C21.8518 11.9016 21.8517 12.0987 21.8231 12.2236C21.7849 12.3899 21.7164 12.4985 21.5792 12.7156C21.2793 13.1901 20.8222 13.8571 20.2165 14.5805M6.72432 6.71504C4.56225 8.1817 3.09445 10.2194 2.42111 11.2853C2.28428 11.5019 2.21587 11.6102 2.17774 11.7765C2.1491 11.9014 2.14909 12.0984 2.17771 12.2234C2.21583 12.3897 2.28393 12.4975 2.42013 12.7132C3.54554 14.4952 6.89541 19 12.0004 19C14.0588 19 15.8319 18.2676 17.2888 17.2766M3.00042 3L21.0004 21M9.8791 9.87868C9.3362 10.4216 9.00042 11.1716 9.00042 12C9.00042 13.6569 10.3436 15 12.0004 15C12.8288 15 13.5788 14.6642 14.1217 14.1213"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const KeyPassword = () => {
  return (
    <>
      <path
        d="M15 9.5H15.01M15 15.5C18.3137 15.5 21 12.8137 21 9.5C21 6.18629 18.3137 3.5 15 3.5C11.6863 3.5 9 6.18629 9 9.5C9 9.77368 9.01832 10.0431 9.05381 10.307C9.11218 10.7412 9.14136 10.9583 9.12172 11.0956C9.10125 11.2387 9.0752 11.3157 9.00469 11.4419C8.937 11.563 8.81771 11.6823 8.57913 11.9209L3.46863 17.0314C3.29568 17.2043 3.2092 17.2908 3.14736 17.3917C3.09253 17.4812 3.05213 17.5787 3.02763 17.6808C3 17.7959 3 17.9182 3 18.1627V19.9C3 20.4601 3 20.7401 3.10899 20.954C3.20487 21.1422 3.35785 21.2951 3.54601 21.391C3.75992 21.5 4.03995 21.5 4.6 21.5H6.33726C6.58185 21.5 6.70414 21.5 6.81923 21.4724C6.92127 21.4479 7.01881 21.4075 7.10828 21.3526C7.2092 21.2908 7.29568 21.2043 7.46863 21.0314L12.5791 15.9209C12.8177 15.6823 12.937 15.563 13.0581 15.4953C13.1843 15.4248 13.2613 15.3987 13.4044 15.3783C13.5417 15.3586 13.7588 15.3878 14.193 15.4462C14.4569 15.4817 14.7263 15.5 15 15.5Z"
        stroke="#646E78"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const KeyPasswordLight = () => {
  return (
    <>
      <path
        d="M15 9.5H15.01M15 15.5C18.3137 15.5 21 12.8137 21 9.5C21 6.18629 18.3137 3.5 15 3.5C11.6863 3.5 9 6.18629 9 9.5C9 9.77368 9.01832 10.0431 9.05381 10.307C9.11218 10.7412 9.14136 10.9583 9.12172 11.0956C9.10125 11.2387 9.0752 11.3157 9.00469 11.4419C8.937 11.563 8.81771 11.6823 8.57913 11.9209L3.46863 17.0314C3.29568 17.2043 3.2092 17.2908 3.14736 17.3917C3.09253 17.4812 3.05213 17.5787 3.02763 17.6808C3 17.7959 3 17.9182 3 18.1627V19.9C3 20.4601 3 20.7401 3.10899 20.954C3.20487 21.1422 3.35785 21.2951 3.54601 21.391C3.75992 21.5 4.03995 21.5 4.6 21.5H6.33726C6.58185 21.5 6.70414 21.5 6.81923 21.4724C6.92127 21.4479 7.01881 21.4075 7.10828 21.3526C7.2092 21.2908 7.29568 21.2043 7.46863 21.0314L12.5791 15.9209C12.8177 15.6823 12.937 15.563 13.0581 15.4953C13.1843 15.4248 13.2613 15.3987 13.4044 15.3783C13.5417 15.3586 13.7588 15.3878 14.193 15.4462C14.4569 15.4817 14.7263 15.5 15 15.5Z"
        stroke="#CFCDEB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const TicketFilled = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.16146 3H18.8385C19.3657 2.99998 19.8205 2.99997 20.195 3.03057C20.5904 3.06287 20.9836 3.13419 21.362 3.32698C21.9265 3.6146 22.3854 4.07355 22.673 4.63803C22.8658 5.01641 22.9371 5.40963 22.9694 5.80498C23 6.17954 23 6.6343 23 7.16144V8.5C23 9.05229 22.5523 9.5 22 9.5C20.6193 9.5 19.5 10.6193 19.5 12C19.5 13.3807 20.6193 14.5 22 14.5C22.5523 14.5 23 14.9477 23 15.5V16.8386C23 17.3657 23 17.8205 22.9694 18.195C22.9371 18.5904 22.8658 18.9836 22.673 19.362C22.3854 19.9265 21.9265 20.3854 21.362 20.673C20.9836 20.8658 20.5904 20.9371 20.195 20.9694C19.8205 21 19.3657 21 18.8386 21H5.16144C4.6343 21 4.17954 21 3.80498 20.9694C3.40963 20.9371 3.01641 20.8658 2.63803 20.673C2.07355 20.3854 1.6146 19.9265 1.32698 19.362C1.13419 18.9836 1.06287 18.5904 1.03057 18.195C0.999971 17.8205 0.999985 17.3657 1 16.8386V15.5C1 14.9477 1.44772 14.5 2 14.5C3.38072 14.5 4.5 13.3807 4.5 12C4.5 10.6193 3.38072 9.5 2 9.5C1.44772 9.5 1 9.05229 1 8.5V7.16142C0.999985 6.6343 0.999971 6.17953 1.03057 5.80498C1.06287 5.40963 1.13419 5.01641 1.32698 4.63803C1.6146 4.07355 2.07355 3.6146 2.63803 3.32698C3.01641 3.13419 3.40963 3.06287 3.80498 3.03057C4.17953 2.99997 4.63434 2.99998 5.16146 3ZM11 6.5C11 5.94772 10.5523 5.5 10 5.5C9.44772 5.5 9 5.94772 9 6.5V7.5C9 8.05229 9.44772 8.5 10 8.5C10.5523 8.5 11 8.05229 11 7.5V6.5ZM10 10.5C10.5523 10.5 11 10.9477 11 11.5V12.5C11 13.0523 10.5523 13.5 10 13.5C9.44772 13.5 9 13.0523 9 12.5V11.5C9 10.9477 9.44772 10.5 10 10.5ZM11 16.5C11 15.9477 10.5523 15.5 10 15.5C9.44772 15.5 9 15.9477 9 16.5V17.5C9 18.0523 9.44772 18.5 10 18.5C10.5523 18.5 11 18.0523 11 17.5V16.5Z"
        fill="currentColor"
      />
    </>
  )
}
export const Ticket = () => {
  return (
    <>
      <path
        d="M10 8V7M10 12.5V11.5M10 17V16M5.2 4H18.8C19.9201 4 20.4802 4 20.908 4.21799C21.2843 4.40973 21.5903 4.71569 21.782 5.09202C22 5.51984 22 6.0799 22 7.2V8.5C20.067 8.5 18.5 10.067 18.5 12C18.5 13.933 20.067 15.5 22 15.5V16.8C22 17.9201 22 18.4802 21.782 18.908C21.5903 19.2843 21.2843 19.5903 20.908 19.782C20.4802 20 19.9201 20 18.8 20H5.2C4.0799 20 3.51984 20 3.09202 19.782C2.71569 19.5903 2.40973 19.2843 2.21799 18.908C2 18.4802 2 17.9201 2 16.8V15.5C3.933 15.5 5.5 13.933 5.5 12C5.5 10.067 3.933 8.5 2 8.5V7.2C2 6.0799 2 5.51984 2.21799 5.09202C2.40973 4.71569 2.71569 4.40973 3.09202 4.21799C3.51984 4 4.0799 4 5.2 4Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

// for 24 24
export const Ticket2 = () => {
  return (
    <>
      <path
        d="M10 8V7M10 12.5V11.5M10 17V16M5.2 4H18.8C19.9201 4 20.4802 4 20.908 4.21799C21.2843 4.40973 21.5903 4.71569 21.782 5.09202C22 5.51984 22 6.0799 22 7.2V8.5C20.067 8.5 18.5 10.067 18.5 12C18.5 13.933 20.067 15.5 22 15.5V16.8C22 17.9201 22 18.4802 21.782 18.908C21.5903 19.2843 21.2843 19.5903 20.908 19.782C20.4802 20 19.9201 20 18.8 20H5.2C4.0799 20 3.51984 20 3.09202 19.782C2.71569 19.5903 2.40973 19.2843 2.21799 18.908C2 18.4802 2 17.9201 2 16.8V15.5C3.933 15.5 5.5 13.933 5.5 12C5.5 10.067 3.933 8.5 2 8.5V7.2C2 6.0799 2 5.51984 2.21799 5.09202C2.40973 4.71569 2.71569 4.40973 3.09202 4.21799C3.51984 4 4.0799 4 5.2 4Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const ShowPassword = () => {
  return (
    <>
      <path
        xmlns="http://www.w3.org/2000/svg"
        clipRule="evenodd"
        d="M17.7469 15.4149C17.9855 14.8742 18.1188 14.2724 18.1188 14.0016C18.1188 11.6544 16.2952 9.7513 14.046 9.7513C11.7969 9.7513 9.97332 11.6544 9.97332 14.0016C9.97332 16.3487 12.0097 17.8886 14.046 17.8886C15.3486 17.8886 16.508 17.2515 17.2517 16.2595C17.4466 16.0001 17.6137 15.7168 17.7469 15.4149ZM14.046 15.7635C14.5551 15.7635 15.0205 15.5684 15.3784 15.2457C15.81 14.8566 16 14.2807 16 14.0016C16 12.828 15.1716 11.8764 14.046 11.8764C12.9205 11.8764 12 12.8264 12 14C12 14.8104 12.9205 15.7635 14.046 15.7635Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        xmlns="http://www.w3.org/2000/svg"
        clipRule="evenodd"
        d="M1.09212 14.2724C1.07621 14.2527 1.10803 14.2931 1.09212 14.2724C0.96764 14.1021 0.970773 13.8996 1.09268 13.7273C1.10161 13.7147 1.11071 13.7016 1.11993 13.6882C4.781 8.34319 9.32105 5.5 14.0142 5.5C18.7025 5.5 23.2385 8.33554 26.8956 13.6698C26.965 13.771 27 13.875 27 13.9995C27 14.1301 26.9593 14.2399 26.8863 14.3461C23.2302 19.6702 18.6982 22.5 14.0142 22.5C9.30912 22.5 4.75717 19.6433 1.09212 14.2724ZM3.93909 13.3525C3.6381 13.7267 3.6381 14.2722 3.93908 14.6465C7.07417 18.5443 10.6042 20.3749 14.0142 20.3749C17.4243 20.3749 20.9543 18.5443 24.0894 14.6465C24.3904 14.2722 24.3904 13.7267 24.0894 13.3525C20.9543 9.45475 17.4243 7.62513 14.0142 7.62513C10.6042 7.62513 7.07417 9.45475 3.93909 13.3525Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  )
}

export const ShieldTick = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.7142 1.08843C11.9039 1.06102 12.0966 1.06102 12.2863 1.08843C12.5049 1.12002 12.7084 1.19688 12.8699 1.2579L12.9132 1.27422L18.4056 3.33374C19.0234 3.56439 19.566 3.76694 19.9838 4.13517C20.3493 4.45729 20.6309 4.86358 20.8041 5.31893C21.0022 5.83944 21.0014 6.41855 21.0004 7.07799L21.0003 11.9999C21.0003 14.8265 19.463 17.1831 17.8012 18.9143C16.1283 20.6571 14.2143 21.888 13.2022 22.4785L13.1612 22.5025C12.9765 22.611 12.7368 22.7517 12.4196 22.8198C12.1602 22.8754 11.8404 22.8754 11.5809 22.8198C11.2638 22.7518 11.0241 22.611 10.8394 22.5025L10.7984 22.4785C9.78626 21.888 7.87222 20.6571 6.19932 18.9143C4.53756 17.1831 3.00026 14.8265 3.00026 11.9999L3.00013 7.078C2.99918 6.41856 2.99834 5.83944 3.19641 5.31893C3.36968 4.86358 3.65124 4.45729 4.01675 4.13517C4.43457 3.76695 4.97712 3.56439 5.59491 3.33374L11.0873 1.27422L11.1306 1.2579C11.2922 1.19688 11.4956 1.12002 11.7142 1.08843ZM16.2074 9.70711C16.5979 9.31658 16.5979 8.68342 16.2074 8.29289C15.8168 7.90237 15.1837 7.90237 14.7931 8.29289L11.0002 12.0858L9.70735 10.7929C9.31683 10.4024 8.68366 10.4024 8.29314 10.7929C7.90261 11.1834 7.90261 11.8166 8.29314 12.2071L10.2931 14.2071C10.6837 14.5976 11.3168 14.5976 11.7074 14.2071L16.2074 9.70711Z"
        fill="currentColor"
      />
    </>
  )
}
export const ShieldTickOutline = () => {
  return (
    <>
      <path
        d="M9 11.4999L11 13.4999L15.5 8.99987M20 11.9999C20 16.9083 14.646 20.4783 12.698 21.6147C12.4766 21.7439 12.3659 21.8085 12.2097 21.842C12.0884 21.868 11.9116 21.868 11.7903 21.842C11.6341 21.8085 11.5234 21.7439 11.302 21.6147C9.35396 20.4783 4 16.9083 4 11.9999V7.21747C4 6.41796 4 6.0182 4.13076 5.67457C4.24627 5.37101 4.43398 5.10015 4.67766 4.8854C4.9535 4.64231 5.3278 4.50195 6.0764 4.22122L11.4382 2.21054C11.6461 2.13258 11.75 2.0936 11.857 2.07815C11.9518 2.06444 12.0482 2.06444 12.143 2.07815C12.25 2.0936 12.3539 2.13258 12.5618 2.21054L17.9236 4.22122C18.6722 4.50195 19.0465 4.64231 19.3223 4.8854C19.566 5.10015 19.7537 5.37101 19.8692 5.67457C20 6.0182 20 6.41796 20 7.21747V11.9999Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const PDFFile = () => {
  return (
    <>
      <g clip-path="url(#clip0_523_13274)">
        <path
          d="M8.75 0.5C7.54688 0.5 6.5625 1.48438 6.5625 2.6875V33.3125C6.5625 34.5156 7.54688 35.5 8.75 35.5H30.625C31.8281 35.5 32.8125 34.5156 32.8125 33.3125V9.25L24.0625 0.5H8.75Z"
          fill="#E2E5E7"
        />
        <path d="M26.25 9.25H32.8125L24.0625 0.5V7.0625C24.0625 8.26562 25.0469 9.25 26.25 9.25Z" fill="#B0B7BD" />
        <path d="M32.8125 15.8125L26.25 9.25H32.8125V15.8125Z" fill="#CAD1D8" />
        <path
          d="M28.4375 28.9375C28.4375 29.5391 27.9453 30.0312 27.3438 30.0312H3.28125C2.67969 30.0312 2.1875 29.5391 2.1875 28.9375V18C2.1875 17.3984 2.67969 16.9062 3.28125 16.9062H27.3438C27.9453 16.9062 28.4375 17.3984 28.4375 18V28.9375Z"
          fill="#F15642"
        />
        <path
          d="M6.95703 21.2229C6.95703 20.9341 7.18453 20.6191 7.55094 20.6191H9.57109C10.7086 20.6191 11.7323 21.3804 11.7323 22.8395C11.7323 24.222 10.7086 24.992 9.57109 24.992H8.11094V26.147C8.11094 26.532 7.86594 26.7496 7.55094 26.7496C7.26219 26.7496 6.95703 26.532 6.95703 26.147V21.2229ZM8.11094 21.7205V23.8993H9.57109C10.1573 23.8993 10.6211 23.382 10.6211 22.8395C10.6211 22.228 10.1573 21.7205 9.57109 21.7205H8.11094Z"
          fill="white"
        />
        <path
          d="M13.4436 26.749C13.1548 26.749 12.8398 26.5915 12.8398 26.2076V21.2398C12.8398 20.9259 13.1548 20.6973 13.4436 20.6973H15.4462C19.4428 20.6973 19.3553 26.749 15.525 26.749H13.4436ZM13.9948 21.7648V25.6826H15.4462C17.8077 25.6826 17.9127 21.7648 15.4462 21.7648H13.9948Z"
          fill="white"
        />
        <path
          d="M20.773 21.8359V23.226H23.0031C23.3181 23.226 23.6331 23.541 23.6331 23.8462C23.6331 24.1349 23.3181 24.3712 23.0031 24.3712H20.773V26.2076C20.773 26.5138 20.5553 26.749 20.2491 26.749C19.8641 26.749 19.6289 26.5138 19.6289 26.2076V21.2398C19.6289 20.9259 19.8652 20.6973 20.2491 20.6973H23.3192C23.7042 20.6973 23.9317 20.9259 23.9317 21.2398C23.9317 21.5198 23.7042 21.8348 23.3192 21.8348H20.773V21.8359Z"
          fill="white"
        />
        <path
          d="M27.3438 30.0312H6.5625V31.125H27.3438C27.9453 31.125 28.4375 30.6328 28.4375 30.0312V28.9375C28.4375 29.5391 27.9453 30.0312 27.3438 30.0312Z"
          fill="#CAD1D8"
        />
      </g>
      <defs>
        <clipPath id="clip0_523_13274">
          <rect width="35" height="35" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </>
  )
}

export const FilterFunnel01ICon = () => {
  return (
    <path
      d="M2 4.6C2 4.03995 2 3.75992 2.10899 3.54601C2.20487 3.35785 2.35785 3.20487 2.54601 3.10899C2.75992 3 3.03995 3 3.6 3H20.4C20.9601 3 21.2401 3 21.454 3.10899C21.6422 3.20487 21.7951 3.35785 21.891 3.54601C22 3.75992 22 4.03995 22 4.6V5.26939C22 5.53819 22 5.67259 21.9672 5.79756C21.938 5.90831 21.8901 6.01323 21.8255 6.10776C21.7526 6.21443 21.651 6.30245 21.4479 6.4785L15.0521 12.0215C14.849 12.1975 14.7474 12.2856 14.6745 12.3922C14.6099 12.4868 14.562 12.5917 14.5328 12.7024C14.5 12.8274 14.5 12.9618 14.5 13.2306V18.4584C14.5 18.6539 14.5 18.7517 14.4685 18.8363C14.4406 18.911 14.3953 18.9779 14.3363 19.0315C14.2695 19.0922 14.1787 19.1285 13.9971 19.2012L10.5971 20.5612C10.2296 20.7082 10.0458 20.7817 9.89827 20.751C9.76927 20.7242 9.65605 20.6476 9.58325 20.5377C9.5 20.4122 9.5 20.2142 9.5 19.8184V13.2306C9.5 12.9618 9.5 12.8274 9.46715 12.7024C9.43805 12.5917 9.39014 12.4868 9.32551 12.3922C9.25258 12.2856 9.15102 12.1975 8.94789 12.0215L2.55211 6.4785C2.34898 6.30245 2.24742 6.21443 2.17449 6.10776C2.10986 6.01323 2.06195 5.90831 2.03285 5.79756C2 5.67259 2 5.53819 2 5.26939V4.6Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  )
}

export const KeyPasswordFilled = () => {
  return (
    <>
      <g filter="url(#filter0_d_523_13604)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.4989 2.83398C12.9886 2.83398 9.33225 6.49033 9.33225 11.0007C9.33225 11.3721 9.35713 11.7383 9.40544 12.0976C9.44073 12.3601 9.46261 12.5244 9.47417 12.6442C9.47624 12.6655 9.47769 12.683 9.47872 12.6971L9.46835 12.7086C9.41152 12.771 9.32986 12.8531 9.18295 13L3.2207 18.9623L3.17851 19.0043C3.02142 19.1606 2.82362 19.3573 2.67609 19.5981C2.54816 19.8068 2.45388 20.0344 2.39672 20.2725C2.33081 20.5471 2.33156 20.8261 2.33215 21.0476L2.33225 21.1072L2.33225 23.1712C2.33222 23.4656 2.33218 23.7524 2.35202 23.9953C2.37381 24.2619 2.42523 24.5766 2.58657 24.8933C2.81028 25.3323 3.16723 25.6893 3.60628 25.913C3.92294 26.0743 4.23763 26.1258 4.50432 26.1475C4.74713 26.1674 5.03382 26.1674 5.32822 26.1673L8.16559 26.1673C8.80992 26.1673 9.33225 25.645 9.33225 25.0007V23.834H10.4989C11.1433 23.834 11.6656 23.3116 11.6656 22.6673V21.5007H12.8323C13.1417 21.5007 13.4384 21.3777 13.6572 21.1589L15.4995 19.3166C15.6464 19.1697 15.7285 19.0881 15.7909 19.0312L15.8024 19.0208C15.8165 19.0219 15.8341 19.0233 15.8554 19.0254C15.9752 19.037 16.1394 19.0588 16.4019 19.0941C16.7613 19.1424 17.1275 19.1673 17.4989 19.1673C22.0092 19.1673 25.6656 15.511 25.6656 11.0007C25.6656 6.49033 22.0092 2.83398 17.4989 2.83398ZM17.4991 9.83377C17.7995 9.83377 18.096 9.94744 18.3241 10.1755C18.5521 10.4035 18.6658 10.7 18.6658 11.0004C18.6658 11.6447 19.1881 12.1671 19.8325 12.167C20.4768 12.167 20.9991 11.6447 20.9991 11.0003C20.9991 10.1064 20.6571 9.20872 19.974 8.52556C19.2908 7.84237 18.393 7.50043 17.4991 7.50043C16.8548 7.50043 16.3324 8.02277 16.3324 8.6671C16.3324 9.31143 16.8548 9.83377 17.4991 9.83377Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_523_13604"
          x="0.332031"
          y="2.83398"
          width="27.332"
          height="27.334"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_523_13604" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_523_13604" result="shape" />
        </filter>
      </defs>
    </>
  )
}

export const Percentage03 = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM16.7071 8.70711C17.0976 8.31658 17.0976 7.68342 16.7071 7.29289C16.3166 6.90237 15.6834 6.90237 15.2929 7.29289L7.29289 15.2929C6.90237 15.6834 6.90237 16.3166 7.29289 16.7071C7.68342 17.0976 8.31658 17.0976 8.70711 16.7071L16.7071 8.70711ZM7.5 9C7.5 8.17157 8.17157 7.5 9 7.5C9.82843 7.5 10.5 8.17157 10.5 9C10.5 9.82843 9.82843 10.5 9 10.5C8.17157 10.5 7.5 9.82843 7.5 9ZM13.5 15C13.5 14.1716 14.1716 13.5 15 13.5C15.8284 13.5 16.5 14.1716 16.5 15C16.5 15.8284 15.8284 16.5 15 16.5C14.1716 16.5 13.5 15.8284 13.5 15Z"
        fill="currentColor"
      />
    </>
  )
}

export const LowPerformance = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM6 12C6 8.68629 8.68629 6 12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C7.58172 4 4 7.58172 4 12C4 12.5523 4.44772 13 5 13C5.55228 13 6 12.5523 6 12ZM17.207 8.20711C17.5975 7.81658 17.5975 7.18342 17.207 6.79289C16.8165 6.40237 16.1833 6.40237 15.7928 6.79289L12.5179 10.0677C12.3527 10.0235 12.1791 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12C14 11.8208 13.9764 11.6471 13.9322 11.4819L17.207 8.20711Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const HighPerformance = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM6 12C6 8.68629 8.68629 6 12 6C12.363 6 12.7177 6.03212 13.0615 6.09344C13.6053 6.1904 14.1246 5.82823 14.2216 5.28452C14.3185 4.74082 13.9564 4.22146 13.4126 4.1245C12.9534 4.04261 12.4813 4 12 4C7.58172 4 4 7.58172 4 12C4 13.6984 4.53037 15.2759 5.4345 16.5721C5.75046 17.0251 6.37381 17.1361 6.82679 16.8202C7.27976 16.5042 7.39084 15.8809 7.07487 15.4279C6.39726 14.4564 6 13.2761 6 12ZM19.8159 10.2867C19.6981 9.74709 19.1652 9.40518 18.6256 9.52298C18.086 9.64079 17.7441 10.1737 17.8619 10.7133C17.9522 11.1269 18 11.5573 18 12C18 13.2761 17.6027 14.4564 16.9251 15.4279C16.6092 15.8809 16.7203 16.5042 17.1732 16.8202C17.6262 17.1361 18.2496 17.025 18.5655 16.5721C19.4696 15.2759 20 13.6984 20 12C20 11.4129 19.9366 10.8395 19.8159 10.2867ZM17.207 8.20711C17.5975 7.81658 17.5975 7.18342 17.207 6.79289C16.8165 6.40237 16.1833 6.40237 15.7928 6.79289L12.5179 10.0677C12.3527 10.0235 12.1791 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12C14 11.8208 13.9764 11.6471 13.9322 11.4819L17.207 8.20711Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const LowPerformanceOutline = () => {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18 11C18 7.13401 15 4 11 4M6.5 6.5L8.5 8.5L10.2929 10.2928M10.9999 11L11.7071 10.2928M11.7071 10.2928C11.8881 10.4738 12 10.7238 12 11C12 11.5523 11.5523 12 11 12C10.4477 12 10 11.5523 10 11C10 10.4477 10.4477 10 11 10C11.2761 10 11.5261 10.1119 11.7071 10.2928ZM21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const FlowChart = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 21.5C4.067 21.5 2.5 19.933 2.5 18C2.5 16.067 4.067 14.5 6 14.5C7.5852 14.5 8.92427 15.5539 9.35481 16.9992L15 16.9994V15L17 14.9994V9.24339L14.757 6.99938H9V9.00003H3V3.00003H9V4.99939H14.757L18 1.75739L22.2426 6.00003L19 9.24139V14.9994L21 15V21H15V18.9994L9.35499 19.0003C8.92464 20.4459 7.58543 21.5 6 21.5ZM6 16.5C5.17157 16.5 4.5 17.1716 4.5 18C4.5 18.8285 5.17157 19.5 6 19.5C6.82843 19.5 7.5 18.8285 7.5 18C7.5 17.1716 6.82843 16.5 6 16.5ZM19 17H17V19H19V17ZM18 4.58581L16.5858 6.00003L18 7.41424L19.4142 6.00003L18 4.58581ZM7 5.00003H5V7.00003H7V5.00003Z"></path>
    </svg>
  )
}

export const Container = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.152.682a2.251 2.251 0 0 1 2.269 0l.007.004 6.957 4.276a2.277 2.277 0 0 1 1.126 1.964v7.516c0 .81-.432 1.56-1.133 1.968l-.002.001-11.964 7.037-.004.003c-.706.41-1.578.41-2.284 0l-.026-.015-6.503-4.502a2.268 2.268 0 0 1-1.096-1.943V9.438c0-.392.1-.77.284-1.1l.003-.006.014-.026c.197-.342.48-.627.82-.827h.002L13.152.681Zm.757 1.295h-.001L2.648 8.616l6.248 4.247a.775.775 0 0 0 .758-.01h.001l11.633-6.804-6.629-4.074a.75.75 0 0 0-.75.003ZM8.517 14.33a2.286 2.286 0 0 1-.393-.18l-.023-.014-6.102-4.147v7.003c0 .275.145.528.379.664l.025.014 6.114 4.232V14.33ZM18 9.709l-3.25 1.9v7.548L18 17.245Zm-7.59 4.438-.002.002a2.296 2.296 0 0 1-.391.18v7.612l3.233-1.902v-7.552Zm9.09-5.316v7.532l2.124-1.25a.776.776 0 0 0 .387-.671V7.363Z"></path>
    </svg>
  )
}

export const HighPerformanceOutline = () => {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.7453 15C17.5362 13.8661 18 12.4872 18 11C18 10.4851 17.9444 9.9832 17.8389 9.49996M5.25469 15C4.46381 13.8662 4 12.4872 4 11C4 7.13401 7.13401 4 11 4C11.4221 4 11.8355 4.03737 12.2371 4.10897M15.4999 6.5L10.9999 11M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11ZM12 11C12 11.5523 11.5523 12 11 12C10.4477 12 10 11.5523 10 11C10 10.4477 10.4477 10 11 10C11.5523 10 12 10.4477 12 11Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const ExitButton = () => {
  return (
    <>
      <path d="M17 7L7 17M7 7L17 17" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </>
  )
}

export const Loading = () => {
  return (
    <>
      <g clip-path="url(#clip0_523_13281)">
        <path
          d="M8.0013 4.66797C7.63464 4.66797 7.33464 4.36797 7.33464 4.0013V1.33464C7.33464 0.967969 7.63464 0.667969 8.0013 0.667969C8.36797 0.667969 8.66797 0.967969 8.66797 1.33464V4.0013C8.66797 4.36797 8.36797 4.66797 8.0013 4.66797ZM8.0013 15.3346C7.63464 15.3346 7.33464 15.0346 7.33464 14.668V12.0013C7.33464 11.6346 7.63464 11.3346 8.0013 11.3346C8.36797 11.3346 8.66797 11.6346 8.66797 12.0013V14.668C8.66797 15.0346 8.36797 15.3346 8.0013 15.3346ZM14.668 8.66797H12.0013C11.6346 8.66797 11.3346 8.36797 11.3346 8.0013C11.3346 7.63464 11.6346 7.33464 12.0013 7.33464H14.668C15.0346 7.33464 15.3346 7.63464 15.3346 8.0013C15.3346 8.36797 15.0346 8.66797 14.668 8.66797ZM4.0013 8.66797H1.33464C0.967969 8.66797 0.667969 8.36797 0.667969 8.0013C0.667969 7.63464 0.967969 7.33464 1.33464 7.33464H4.0013C4.36797 7.33464 4.66797 7.63464 4.66797 8.0013C4.66797 8.36797 4.36797 8.66797 4.0013 8.66797ZM12.7146 13.3813C12.5413 13.3813 12.3746 13.3146 12.2413 13.188L10.3546 11.3013C10.2929 11.2396 10.244 11.1663 10.2106 11.0857C10.1771 11.005 10.16 10.9186 10.16 10.8313C10.16 10.744 10.1771 10.6576 10.2106 10.5769C10.244 10.4963 10.2929 10.423 10.3546 10.3613C10.4164 10.2996 10.4896 10.2506 10.5703 10.2172C10.6509 10.1838 10.7373 10.1666 10.8246 10.1666C10.9119 10.1666 10.9984 10.1838 11.079 10.2172C11.1596 10.2506 11.2329 10.2996 11.2946 10.3613L13.1813 12.248C13.2743 12.3411 13.3376 12.4597 13.3631 12.5888C13.3885 12.718 13.375 12.8518 13.3243 12.9732C13.2736 13.0947 13.1879 13.1983 13.0782 13.271C12.9684 13.3436 12.8396 13.382 12.708 13.3813H12.7146ZM5.17464 5.8413C5.0013 5.8413 4.83464 5.77464 4.7013 5.64797L2.81464 3.7613C2.75291 3.69958 2.70395 3.62631 2.67055 3.54566C2.63715 3.46502 2.61996 3.37859 2.61996 3.2913C2.61996 3.20402 2.63715 3.11758 2.67055 3.03694C2.70395 2.9563 2.75291 2.88302 2.81464 2.8213C2.87636 2.75958 2.94963 2.71062 3.03027 2.67722C3.11092 2.64381 3.19735 2.62662 3.28464 2.62662C3.37192 2.62662 3.45835 2.64381 3.539 2.67722C3.61964 2.71062 3.69291 2.75958 3.75464 2.8213L5.6413 4.70797C5.73433 4.80107 5.7976 4.91972 5.82306 5.04885C5.84853 5.17798 5.83504 5.31176 5.78432 5.43321C5.73359 5.55466 5.64792 5.65829 5.53818 5.73095C5.42844 5.80362 5.29958 5.84202 5.16797 5.8413H5.17464ZM3.28797 13.3813C3.11464 13.3813 2.94797 13.3146 2.81464 13.188C2.75283 13.1263 2.7038 13.053 2.67035 12.9724C2.63689 12.8917 2.61967 12.8053 2.61967 12.718C2.61967 12.6307 2.63689 12.5442 2.67035 12.4636C2.7038 12.3829 2.75283 12.3096 2.81464 12.248L4.7013 10.3613C4.76302 10.2996 4.8363 10.2506 4.91694 10.2172C4.99758 10.1838 5.08402 10.1666 5.1713 10.1666C5.25859 10.1666 5.34502 10.1838 5.42566 10.2172C5.50631 10.2506 5.57958 10.2996 5.6413 10.3613C5.70302 10.423 5.75198 10.4963 5.78539 10.5769C5.81879 10.6576 5.83598 10.744 5.83598 10.8313C5.83598 10.9186 5.81879 11.005 5.78539 11.0857C5.75198 11.1663 5.70302 11.2396 5.6413 11.3013L3.75464 13.188C3.6213 13.3213 3.45464 13.3813 3.2813 13.3813H3.28797ZM10.828 5.8413C10.6546 5.8413 10.488 5.77464 10.3546 5.64797C10.2928 5.58629 10.2438 5.51303 10.2103 5.43239C10.1769 5.35174 10.1597 5.26528 10.1597 5.17797C10.1597 5.09066 10.1769 5.0042 10.2103 4.92355C10.2438 4.8429 10.2928 4.76964 10.3546 4.70797L12.2413 2.8213C12.303 2.75958 12.3763 2.71062 12.4569 2.67722C12.5376 2.64381 12.624 2.62662 12.7113 2.62662C12.7986 2.62662 12.885 2.64381 12.9657 2.67722C13.0463 2.71062 13.1196 2.75958 13.1813 2.8213C13.243 2.88302 13.292 2.9563 13.3254 3.03694C13.3588 3.11758 13.376 3.20402 13.376 3.2913C13.376 3.37859 13.3588 3.46502 13.3254 3.54566C13.292 3.62631 13.243 3.69958 13.1813 3.7613L11.2946 5.64797C11.1613 5.7813 10.9946 5.8413 10.8213 5.8413H10.828Z"
          fill="#362EAD"
        />
      </g>
      <defs>
        <clipPath id="clip0_523_13281">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </>
  )
}

export const RoundCheck = () => {
  return (
    <>
      <path
        d="M9 1.5C4.8675 1.5 1.5 4.8675 1.5 9C1.5 13.1325 4.8675 16.5 9 16.5C13.1325 16.5 16.5 13.1325 16.5 9C16.5 4.8675 13.1325 1.5 9 1.5ZM12.585 7.275L8.3325 11.5275C8.2275 11.6325 8.085 11.6925 7.935 11.6925C7.785 11.6925 7.6425 11.6325 7.5375 11.5275L5.415 9.405C5.1975 9.1875 5.1975 8.8275 5.415 8.61C5.6325 8.3925 5.9925 8.3925 6.21 8.61L7.935 10.335L11.79 6.48C12.0075 6.2625 12.3675 6.2625 12.585 6.48C12.8025 6.6975 12.8025 7.05 12.585 7.275Z"
        fill="#33D692"
      />
    </>
  )
}

export const RubbishBin = () => {
  return (
    <>
      <path
        d="M7 1H13M1 4H19M17 4L16.2987 14.5193C16.1935 16.0975 16.1409 16.8867 15.8 17.485C15.4999 18.0118 15.0472 18.4353 14.5017 18.6997C13.882 19 13.0911 19 11.5093 19H8.49065C6.90891 19 6.11803 19 5.49834 18.6997C4.95276 18.4353 4.50009 18.0118 4.19998 17.485C3.85911 16.8867 3.8065 16.0975 3.70129 14.5193L3 4"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const Package = () => {
  return (
    <>
      <path
        d="M5.87544 2.00004C5.25697 1.99963 4.79072 1.99931 4.36592 2.14584C3.99225 2.27472 3.65191 2.48506 3.36953 2.76164C3.04849 3.07607 2.84026 3.49323 2.56405 4.04659C2.2251 4.72451 1.67642 5.82396 1.30796 6.56246C1.18066 6.81761 1.117 6.94518 1.13241 7.049C1.14586 7.13965 1.19604 7.22078 1.27115 7.27328C1.35718 7.33341 1.4999 7.33341 1.78536 7.33341H3.92067C4.62999 7.33341 5.27843 7.73417 5.59565 8.36861C5.68701 8.55133 5.87376 8.66675 6.07805 8.66675H9.92067C10.125 8.66675 10.3117 8.55133 10.4031 8.36861C10.7203 7.73417 11.3687 7.33341 12.0781 7.33341H14.2134C14.4988 7.33341 14.6416 7.33341 14.7276 7.27328C14.8027 7.22078 14.8529 7.13965 14.8663 7.049C14.8817 6.94518 14.8181 6.81761 14.6908 6.56246C14.3223 5.82396 13.7737 4.72452 13.4347 4.0466C13.1585 3.49324 12.9503 3.07607 12.6292 2.76164C12.3468 2.48506 12.0065 2.27472 11.6328 2.14584C11.208 1.99931 10.7418 1.99963 10.1233 2.00004H5.87544Z"
        fill="currentColor"
      />
      <path
        d="M15.3327 9.73317C15.3328 9.36 15.3328 9.17341 15.2601 9.03079C15.1962 8.90536 15.0942 8.80333 14.9688 8.73942C14.8262 8.66675 14.6395 8.66675 14.2663 8.66675H12.0781C11.8738 8.66675 11.687 8.78217 11.5956 8.96489C11.2784 9.59932 10.63 10.0001 9.92067 10.0001H6.07805C5.36873 10.0001 4.72029 9.59932 4.40308 8.96489C4.31172 8.78217 4.12496 8.66675 3.92067 8.66675H1.73243C1.3592 8.66675 1.17258 8.66675 1.02997 8.73942C0.904551 8.80333 0.80252 8.90537 0.738623 9.03079C0.665966 9.17341 0.665983 9.35999 0.666017 9.73315C0.66603 9.87575 0.666042 10.0184 0.666042 10.161C0.666034 10.6976 0.666027 11.1405 0.695505 11.5013C0.726122 11.876 0.791831 12.2205 0.956692 12.5441C1.21235 13.0458 1.6203 13.4538 2.12207 13.7094C2.44562 13.8743 2.79009 13.94 3.16483 13.9706C3.52562 14.0001 3.96852 14.0001 4.50516 14.0001H11.4936C12.0302 14.0001 12.4731 14.0001 12.8339 13.9706C13.2087 13.94 13.5531 13.8743 13.8767 13.7094C14.3784 13.4538 14.7864 13.0458 15.0421 12.5441C15.2069 12.2205 15.2726 11.876 15.3032 11.5013C15.3327 11.1405 15.3327 10.6976 15.3327 10.161C15.3327 10.0184 15.3327 9.87577 15.3327 9.73317Z"
        fill="currentColor"
      />
    </>
  )
}
export const PackageSearch = () => {
  return (
    <>
      <path
        d="M20.5 7.27783L12 12.0001M12 12.0001L3.49997 7.27783M12 12.0001L12 21.5001M21 12.0001V7.94153C21 7.59889 21 7.42757 20.9495 7.27477C20.9049 7.13959 20.8318 7.01551 20.7354 6.91082C20.6263 6.79248 20.4766 6.70928 20.177 6.54288L12.777 2.43177C12.4934 2.27421 12.3516 2.19543 12.2015 2.16454C12.0685 2.13721 11.9315 2.13721 11.7986 2.16454C11.6484 2.19543 11.5066 2.27421 11.223 2.43177L3.82297 6.54288C3.52345 6.70928 3.37368 6.79248 3.26463 6.91082C3.16816 7.01551 3.09515 7.13959 3.05048 7.27477C3 7.42757 3 7.59889 3 7.94153V16.0586C3 16.4013 3 16.5726 3.05048 16.7254C3.09515 16.8606 3.16816 16.9847 3.26463 17.0893C3.37368 17.2077 3.52346 17.2909 3.82297 17.4573L11.223 21.5684C11.5066 21.726 11.6484 21.8047 11.7986 21.8356C11.9315 21.863 12.0685 21.863 12.2015 21.8356C12.3516 21.8047 12.4934 21.726 12.777 21.5684L13 21.4445M7.5 4.50008L16.5 9.50008M22 21.5001L21 20.5001M22 18.0001C22 19.6569 20.6569 21.0001 19 21.0001C17.3431 21.0001 16 19.6569 16 18.0001C16 16.3432 17.3431 15.0001 19 15.0001C20.6569 15.0001 22 16.3432 22 18.0001Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const FileCheck03 = () => {
  return (
    <path
      d="M14 2.26953V6.40007C14 6.96012 14 7.24015 14.109 7.45406C14.2049 7.64222 14.3578 7.7952 14.546 7.89108C14.7599 8.00007 15.0399 8.00007 15.6 8.00007H19.7305M9 16L11 18L15.5 13.5M14 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9265 19.673 20.362C20 19.7202 20 18.8802 20 17.2V8L14 2Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  )
}

export const FileQuestion03 = () => {
  return (
    <>
      <path
        d="M14 2.26953V6.40007C14 6.96012 14 7.24015 14.109 7.45406C14.2049 7.64222 14.3578 7.7952 14.546 7.89108C14.7599 8.00007 15.0399 8.00007 15.6 8.00007H19.7305M9.84998 12.0022C10.0262 11.5014 10.3739 11.079 10.8317 10.81C11.2895 10.5409 11.8277 10.4426 12.351 10.5324C12.8743 10.6221 13.349 10.8942 13.6909 11.3004C14.0329 11.7066 14.22 12.2207 14.2192 12.7517C14.2192 14.2506 11.9709 15 11.9709 15M12 18H12.01M14 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9265 19.673 20.362C20 19.7202 20 18.8802 20 17.2V8L14 2Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const FileShield02 = () => {
  return (
    <>
      <path
        d="M14 11H8M10 15H8M16 7H8M20 10V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H12.5M18 21C18 21 21 19.5701 21 17.4252V14.9229L18.8124 14.1412C18.2868 13.9529 17.712 13.9529 17.1864 14.1412L15 14.9229V17.4252C15 19.5701 18 21 18 21Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const File02 = () => {
  return (
    <>
      <path
        d="M14 11H8M10 15H8M16 7H8M20 6.8V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V6.8C4 5.11984 4 4.27976 4.32698 3.63803C4.6146 3.07354 5.07354 2.6146 5.63803 2.32698C6.27976 2 7.11984 2 8.8 2H15.2C16.8802 2 17.7202 2 18.362 2.32698C18.9265 2.6146 19.3854 3.07354 19.673 3.63803C20 4.27976 20 5.11984 20 6.8Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const FileX02 = () => {
  return (
    <>
      <path
        d="M14 11H8M10 15H8M16 7H8M20 12V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H12M16 16L21 21M21 16L16 21"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const FileX03 = () => {
  return (
    <>
      <path
        d="M14 2.26953V6.40007C14 6.96012 14 7.24015 14.109 7.45406C14.2049 7.64222 14.3578 7.7952 14.546 7.89108C14.7599 8.00007 15.0399 8.00007 15.6 8.00007H19.7305M9.5 12L14.5 17M14.5 12L9.5 17M14 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9265 19.673 20.362C20 19.7202 20 18.8802 20 17.2V8L14 2Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const FileX03Filled = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 2.01558C13 1.98928 13 1.97612 12.9989 1.95227C12.9753 1.4585 12.541 1.02448 12.0473 1.00112C12.0234 0.999992 12.0156 0.999995 12 1H8.75866C7.95372 0.99999 7.28935 0.999981 6.74818 1.0442C6.18608 1.09012 5.66938 1.18869 5.18404 1.43598C4.43139 1.81947 3.81947 2.43139 3.43598 3.18404C3.18869 3.66938 3.09012 4.18608 3.0442 4.74818C2.99998 5.28936 2.99999 5.95372 3 6.75867V17.2413C2.99999 18.0463 2.99998 18.7106 3.0442 19.2518C3.09012 19.8139 3.18869 20.3306 3.43598 20.816C3.81947 21.5686 4.43139 22.1805 5.18404 22.564C5.66938 22.8113 6.18608 22.9099 6.74818 22.9558C7.28937 23 7.95372 23 8.75868 23H15.2413C16.0463 23 16.7106 23 17.2518 22.9558C17.8139 22.9099 18.3306 22.8113 18.816 22.564C19.5686 22.1805 20.1805 21.5686 20.564 20.816C20.8113 20.3306 20.9099 19.8139 20.9558 19.2518C21 18.7106 21 18.0463 21 17.2413V9.99994C21 9.98441 21 9.97664 20.9989 9.95282C20.9756 9.45899 20.5415 9.02471 20.0477 9.00115C20.0238 9.00001 20.0107 9.00001 19.9845 9.00001L15.5681 9.00001C15.3157 9.00004 15.0699 9.00007 14.8618 8.98307C14.6332 8.96439 14.3634 8.92032 14.092 8.78202C13.7157 8.59028 13.4097 8.28432 13.218 7.90799C13.0797 7.63657 13.0356 7.36683 13.017 7.13824C12.9999 6.93008 13 6.68429 13 6.43191L13 2.01558ZM8.79289 12.2929C9.18342 11.9024 9.81658 11.9024 10.2071 12.2929L12 14.0858L13.7929 12.2929C14.1834 11.9024 14.8166 11.9024 15.2071 12.2929C15.5976 12.6834 15.5976 13.3166 15.2071 13.7071L13.4142 15.5L15.2071 17.2929C15.5976 17.6834 15.5976 18.3166 15.2071 18.7071C14.8166 19.0976 14.1834 19.0976 13.7929 18.7071L12 16.9142L10.2071 18.7071C9.81658 19.0976 9.18342 19.0976 8.79289 18.7071C8.40237 18.3166 8.40237 17.6834 8.79289 17.2929L10.5858 15.5L8.79289 13.7071C8.40237 13.3166 8.40237 12.6834 8.79289 12.2929Z"
        fill="currentColor"
      />
      <path
        d="M18.908 6.99999C19.2016 7 19.3484 7 19.4686 6.92627C19.6385 6.82215 19.74 6.57684 19.6935 6.38313C19.6605 6.24598 19.5648 6.15033 19.3733 5.95904L16.041 2.62672C15.8497 2.43523 15.754 2.33949 15.6169 2.30652C15.4232 2.25996 15.1779 2.3615 15.0737 2.53134C15 2.65161 15 2.79842 15 3.09204L15 6.19996C15 6.47998 15 6.61999 15.0545 6.72694C15.1024 6.82102 15.1789 6.89751 15.273 6.94545C15.38 6.99995 15.52 6.99995 15.8 6.99995L18.908 6.99999Z"
        fill="currentColor"
      />
    </>
  )
}

export const CheckDocument = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.66667 1.34307C8.66667 1.32553 8.66667 1.31677 8.66591 1.30086C8.65018 0.97168 8.3607 0.682335 8.03151 0.666762C8.01562 0.666011 8.0104 0.666012 8.00001 0.666016H5.8391C5.30248 0.666009 4.85957 0.666003 4.49878 0.69548C4.12405 0.726097 3.77958 0.791806 3.45603 0.956667C2.95426 1.21233 2.54631 1.62028 2.29065 2.12204C2.12579 2.4456 2.06008 2.79007 2.02946 3.1648C1.99999 3.52559 1.99999 3.9685 2 4.50513V11.4936C1.99999 12.0302 1.99999 12.4731 2.02946 12.8339C2.06008 13.2086 2.12579 13.5531 2.29065 13.8767C2.54631 14.3784 2.95426 14.7864 3.45603 15.042C3.77958 15.2069 4.12405 15.2726 4.49878 15.3032C4.85958 15.3327 5.30248 15.3327 5.83912 15.3327H10.1609C10.6975 15.3327 11.1404 15.3327 11.5012 15.3032C11.8759 15.2726 12.2204 15.2069 12.544 15.042C13.0457 14.7864 13.4537 14.3784 13.7093 13.8767C13.8742 13.5531 13.9399 13.2086 13.9705 12.8339C14 12.4731 14 12.0302 14 11.4936V6.66598C14 6.65562 14 6.65044 13.9993 6.63456C13.9837 6.30534 13.6943 6.01583 13.3651 6.00011C13.3492 5.99936 13.3405 5.99936 13.323 5.99936L10.3787 5.99936C10.2105 5.99938 10.0466 5.9994 9.90785 5.98806C9.75545 5.97561 9.57563 5.94623 9.39468 5.85403C9.1438 5.7262 8.93983 5.52223 8.81199 5.27134C8.7198 5.0904 8.69042 4.91057 8.67797 4.75818C8.66663 4.6194 8.66665 4.45554 8.66667 4.28729L8.66667 1.34307ZM10.8047 9.47075C11.0651 9.21041 11.0651 8.78829 10.8047 8.52795C10.5444 8.2676 10.1223 8.2676 9.86193 8.52795L7.33333 11.0565L6.4714 10.1946C6.21106 9.93426 5.78894 9.93426 5.5286 10.1946C5.26825 10.455 5.26825 10.8771 5.5286 11.1374L6.86193 12.4708C7.12228 12.7311 7.54439 12.7311 7.80474 12.4708L10.8047 9.47075Z"
        fill="currentColor"
      />
      <path
        d="M12.6053 4.66601C12.8011 4.66601 12.8989 4.66601 12.9791 4.61686C13.0923 4.54745 13.16 4.38391 13.129 4.25477C13.107 4.16333 13.0432 4.09957 12.9155 3.97204L10.694 1.75049C10.5664 1.62284 10.5027 1.55901 10.4112 1.53703C10.2821 1.50599 10.1186 1.57368 10.0492 1.68691C10 1.76709 10 1.86496 10 2.06071L10 4.13266C10 4.31933 10 4.41267 10.0363 4.48398C10.0683 4.5467 10.1193 4.59769 10.182 4.62965C10.2533 4.66598 10.3466 4.66598 10.5333 4.66598L12.6053 4.66601Z"
        fill="currentColor"
      />
    </>
  )
}

export const DocumentAttachment = () => {
  return (
    <>
      <path
        d="M12.5 2H15.2C16.8802 2 17.7202 2 18.362 2.32698C18.9265 2.6146 19.3854 3.07354 19.673 3.63803C20 4.27976 20 5.11984 20 6.8V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V16.5M16 13H11.5M16 9H12.5M16 17H8M6 10V4.5C6 3.67157 6.67157 3 7.5 3C8.32843 3 9 3.67157 9 4.5V10C9 11.6569 7.65685 13 6 13C4.34315 13 3 11.6569 3 10V6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const FileCheck2 = () => {
  return (
    <>
      <path
        d="M20 12.5V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H12M14 11H8M10 15H8M16 7H8M14.5 19L16.5 21L21 16.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const ScriptDocument = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.66667 1.34307C8.66667 1.32553 8.66667 1.31677 8.66591 1.30086C8.65018 0.97168 8.3607 0.682335 8.03151 0.666762C8.01562 0.666011 8.0104 0.666012 8.00001 0.666016H5.8391C5.30248 0.666009 4.85957 0.666003 4.49878 0.69548C4.12405 0.726097 3.77958 0.791806 3.45603 0.956667C2.95426 1.21233 2.54631 1.62028 2.29065 2.12204C2.12579 2.4456 2.06008 2.79007 2.02946 3.1648C1.99999 3.52559 1.99999 3.9685 2 4.50513V11.4936C1.99999 12.0302 1.99999 12.4731 2.02946 12.8339C2.06008 13.2086 2.12579 13.5531 2.29065 13.8767C2.54631 14.3784 2.95426 14.7864 3.45603 15.042C3.77958 15.2069 4.12405 15.2726 4.49878 15.3032C4.85958 15.3327 5.30248 15.3327 5.83912 15.3327H10.1609C10.6975 15.3327 11.1404 15.3327 11.5012 15.3032C11.8759 15.2726 12.2204 15.2069 12.544 15.042C13.0457 14.7864 13.4537 14.3784 13.7093 13.8767C13.8742 13.5531 13.9399 13.2086 13.9705 12.8339C14 12.4731 14 12.0302 14 11.4936V6.66598C14 6.65562 14 6.65044 13.9993 6.63456C13.9837 6.30534 13.6943 6.01583 13.3651 6.00011C13.3492 5.99936 13.3405 5.99936 13.323 5.99936L10.3787 5.99936C10.2105 5.99938 10.0466 5.9994 9.90785 5.98806C9.75545 5.97561 9.57563 5.94623 9.39468 5.85403C9.1438 5.7262 8.93983 5.52223 8.81199 5.27134C8.7198 5.0904 8.69042 4.91057 8.67797 4.75818C8.66663 4.6194 8.66665 4.45554 8.66667 4.28729L8.66667 1.34307ZM5.33333 8.66602C4.96514 8.66602 4.66667 8.96449 4.66667 9.33268C4.66667 9.70087 4.96514 9.99935 5.33333 9.99935H10.6667C11.0349 9.99935 11.3333 9.70087 11.3333 9.33268C11.3333 8.96449 11.0349 8.66602 10.6667 8.66602H5.33333ZM5.33333 11.3327C4.96514 11.3327 4.66667 11.6312 4.66667 11.9993C4.66667 12.3675 4.96514 12.666 5.33333 12.666H9.33333C9.70152 12.666 10 12.3675 10 11.9993C10 11.6312 9.70152 11.3327 9.33333 11.3327H5.33333Z"
        fill="currentColor"
      />
      <path
        d="M12.6053 4.66601C12.8011 4.66601 12.8989 4.66601 12.9791 4.61686C13.0923 4.54745 13.16 4.38391 13.129 4.25477C13.107 4.16333 13.0432 4.09957 12.9155 3.97204L10.694 1.75049C10.5664 1.62284 10.5027 1.55901 10.4112 1.53703C10.2821 1.50599 10.1186 1.57368 10.0492 1.68691C10 1.76709 10 1.86496 10 2.06071L10 4.13266C10 4.31933 10 4.41267 10.0363 4.48398C10.0683 4.5467 10.1193 4.59769 10.182 4.62965C10.2533 4.66598 10.3466 4.66598 10.5333 4.66598L12.6053 4.66601Z"
        fill="currentColor"
      />
    </>
  )
}

export const PlatformLayout = () => {
  return (
    <>
      <path
        d="M3 9H21M7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const LayoutLeft = () => {
  return (
    <>
      <path
        opacity="0.12"
        d="M9 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H9V3Z"
        fill="currentColor"
      />
      <path
        d="M9 3V21M7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const ImageX = () => {
  return (
    <>
      <path
        d="M16.5 2.5L21.5 7.5M21.5 2.5L16.5 7.5M12.5 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H17C17.93 21 18.395 21 18.7765 20.8978C19.8117 20.6204 20.6204 19.8117 20.8978 18.7765C21 18.395 21 17.93 21 17M10.5 8.5C10.5 9.60457 9.60457 10.5 8.5 10.5C7.39543 10.5 6.5 9.60457 6.5 8.5C6.5 7.39543 7.39543 6.5 8.5 6.5C9.60457 6.5 10.5 7.39543 10.5 8.5ZM14.99 11.9181L6.53115 19.608C6.05536 20.0406 5.81747 20.2568 5.79643 20.4442C5.77819 20.6066 5.84045 20.7676 5.96319 20.8755C6.10478 21 6.42628 21 7.06929 21H16.456C17.8951 21 18.6147 21 19.1799 20.7582C19.8894 20.4547 20.4547 19.8894 20.7582 19.1799C21 18.6147 21 17.8951 21 16.456C21 15.9717 21 15.7296 20.9471 15.5042C20.8805 15.2208 20.753 14.9554 20.5733 14.7264C20.4303 14.5442 20.2412 14.3929 19.8631 14.0905L17.0658 11.8527C16.6874 11.5499 16.4982 11.3985 16.2898 11.3451C16.1061 11.298 15.9129 11.3041 15.7325 11.3627C15.5279 11.4291 15.3486 11.5921 14.99 11.9181Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const ImageCircle = () => {
  return (
    <>
      <path
        d="M5.99958 20.0004L14.8686 11.1314C15.2646 10.7354 15.4627 10.5373 15.691 10.4632C15.8918 10.3979 16.1082 10.3979 16.309 10.4632C16.5373 10.5373 16.7354 10.7354 17.1314 11.1314L21.4053 15.4053M10.5 8.5C10.5 9.60457 9.60457 10.5 8.5 10.5C7.39543 10.5 6.5 9.60457 6.5 8.5C6.5 7.39543 7.39543 6.5 8.5 6.5C9.60457 6.5 10.5 7.39543 10.5 8.5ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const HtmlLogo = () => {
  return (
    <>
      <path
        d="M17 17L22 12L17 7M7 7L2 12L7 17M14 3L10 21"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const Link04Icon = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 8C4.79086 8 3 9.79086 3 12C3 14.2091 4.79086 16 7 16H9C11.2091 16 13 14.2091 13 12C13 11.4477 13.4477 11 14 11C14.5523 11 15 11.4477 15 12C15 15.3137 12.3137 18 9 18H7C3.68629 18 1 15.3137 1 12C1 8.68629 3.68629 6 7 6H7.5C8.05228 6 8.5 6.44772 8.5 7C8.5 7.55229 8.05228 8 7.5 8H7Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 8L15 8C12.7909 8 11 9.79086 11 12C11 12.5523 10.5523 13 10 13C9.44772 13 9 12.5523 9 12C9 8.68629 11.6863 6 15 6L17 6C20.3137 6 23 8.68629 23 12C23 15.3137 20.3137 18 17 18H16.5C15.9477 18 15.5 17.5523 15.5 17C15.5 16.4477 15.9477 16 16.5 16H17C19.2091 16 21 14.2091 21 12C21 9.79086 19.2091 8 17 8Z"
        fill="currentColor"
      />
    </>
  )
}

export const Download01Icon = () => {
  return (
    <>
      <path
        d="M13 3C13 2.44772 12.5523 2 12 2C11.4477 2 11 2.44772 11 3V12.5858L7.70711 9.29289C7.31658 8.90237 6.68342 8.90237 6.29289 9.29289C5.90237 9.68342 5.90237 10.3166 6.29289 10.7071L11.2929 15.7071C11.6834 16.0976 12.3166 16.0976 12.7071 15.7071L17.7071 10.7071C18.0976 10.3166 18.0976 9.68342 17.7071 9.29289C17.3166 8.90237 16.6834 8.90237 16.2929 9.29289L13 12.5858V3Z"
        fill="currentColor"
      />
      <path
        d="M3 14C3.55229 14 4 14.4477 4 15V16.2C4 17.0566 4.00078 17.6389 4.03755 18.089C4.07337 18.5274 4.1383 18.7516 4.21799 18.908C4.40973 19.2843 4.7157 19.5903 5.09202 19.782C5.24842 19.8617 5.47262 19.9266 5.91104 19.9624C6.36113 19.9992 6.94342 20 7.8 20H16.2C17.0566 20 17.6389 19.9992 18.089 19.9624C18.5274 19.9266 18.7516 19.8617 18.908 19.782C19.2843 19.5903 19.5903 19.2843 19.782 18.908C19.8617 18.7516 19.9266 18.5274 19.9624 18.089C19.9992 17.6389 20 17.0566 20 16.2V15C20 14.4477 20.4477 14 21 14C21.5523 14 22 14.4477 22 15V16.2413C22 17.0463 22 17.7106 21.9558 18.2518C21.9099 18.8139 21.8113 19.3306 21.564 19.816C21.1805 20.5686 20.5686 21.1805 19.816 21.564C19.3306 21.8113 18.8139 21.9099 18.2518 21.9558C17.7106 22 17.0463 22 16.2413 22H7.7587C6.95373 22 6.28937 22 5.74818 21.9558C5.18608 21.9099 4.66937 21.8113 4.18404 21.564C3.43139 21.1805 2.81947 20.5686 2.43598 19.816C2.18868 19.3306 2.09012 18.8139 2.04419 18.2518C1.99998 17.7106 1.99999 17.0463 2 16.2413V15C2 14.4477 2.44772 14 3 14Z"
        fill="currentColor"
      />
    </>
  )
}

export const CloudDownload = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 12C0 16.9706 4.02944 21 9 21H16.5C20.6421 21 24 17.6421 24 13.5C24 9.35786 20.6421 6 16.5 6C16.2441 6 15.9913 6.01281 15.742 6.03783C14.0931 4.17464 11.6837 3 9 3C4.02944 3 0 7.02944 0 12ZM12 8C12.5523 8 13 8.44772 13 9V14.5858L15.2929 12.2929C15.6834 11.9024 16.3166 11.9024 16.7071 12.2929C17.0976 12.6834 17.0976 13.3166 16.7071 13.7071L12.7071 17.7071C12.3166 18.0976 11.6834 18.0976 11.2929 17.7071L7.29289 13.7071C6.90237 13.3166 6.90237 12.6834 7.29289 12.2929C7.68342 11.9024 8.31658 11.9024 8.70711 12.2929L11 14.5858V9C11 8.44772 11.4477 8 12 8Z"
        fill="currentColor"
      />
    </>
  )
}
export const Link = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2071 7.79284C16.5976 8.18336 16.5976 8.81653 16.2071 9.20705L9.20707 16.207C8.81655 16.5976 8.18338 16.5976 7.79286 16.207C7.40233 15.8165 7.40233 15.1834 7.79286 14.7928L14.7929 7.79284C15.1834 7.40231 15.8165 7.40231 16.2071 7.79284Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.34311 10.5858C6.73363 10.9763 6.73363 11.6094 6.34311 12L4.9289 13.4142C3.3668 14.9763 3.3668 17.5089 4.9289 19.071C6.49099 20.6331 9.02365 20.6331 10.5858 19.071L12 17.6568C12.3905 17.2663 13.0237 17.2663 13.4142 17.6568C13.8047 18.0473 13.8047 18.6805 13.4142 19.071L12 20.4852C9.65682 22.8284 5.85783 22.8284 3.51468 20.4852C1.17154 18.1421 1.17154 14.3431 3.51468 12L4.9289 10.5858C5.31942 10.1952 5.95259 10.1952 6.34311 10.5858Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3.51468C14.3431 1.17154 18.1421 1.17154 20.4852 3.51468C22.8284 5.85783 22.8284 9.65682 20.4852 12L19.071 13.4142C18.6805 13.8047 18.0473 13.8047 17.6568 13.4142C17.2663 13.0237 17.2663 12.3905 17.6568 12L19.071 10.5858C20.6331 9.02365 20.6331 6.49099 19.071 4.9289C17.5089 3.3668 14.9763 3.3668 13.4142 4.9289L12 6.34311C11.6094 6.73363 10.9763 6.73363 10.5858 6.34311C10.1952 5.95259 10.1952 5.31942 10.5858 4.9289L12 3.51468Z"
        fill="currentColor"
      />
    </>
  )
}

export const LinkBroken = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2071 7.79287C16.5976 8.1834 16.5976 8.81656 16.2071 9.20708L9.20711 16.2071C8.81658 16.5976 8.18342 16.5976 7.79289 16.2071C7.40237 15.8166 7.40237 15.1834 7.79289 14.7929L14.7929 7.79287C15.1834 7.40235 15.8166 7.40235 16.2071 7.79287Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 1C9.55229 1 10 1.44772 10 2V4C10 4.55228 9.55229 5 9 5C8.44772 5 8 4.55228 8 4V2C8 1.44772 8.44772 1 9 1Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 19C15.5523 19 16 19.4477 16 20V22C16 22.5523 15.5523 23 15 23C14.4477 23 14 22.5523 14 22V20C14 19.4477 14.4477 19 15 19Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 8H4C4.55228 8 5 8.44772 5 9C5 9.55228 4.55228 10 4 10H2C1.44772 10 1 9.55229 1 9C1 8.44772 1.44772 8 2 8Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 15C19 14.4477 19.4477 14 20 14H22C22.5523 14 23 14.4477 23 15C23 15.5523 22.5523 16 22 16H20C19.4477 16 19 15.5523 19 15Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.79289 2.79289C3.18342 2.40237 3.81658 2.40237 4.20711 2.79289L5.62132 4.20711C6.01184 4.59763 6.01184 5.2308 5.62132 5.62132C5.2308 6.01184 4.59763 6.01184 4.20711 5.62132L2.79289 4.20711C2.40237 3.81658 2.40237 3.18342 2.79289 2.79289Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.3787 18.3786C18.7692 17.9881 19.4024 17.9881 19.7929 18.3786L21.2071 19.7928C21.5977 20.1833 21.5977 20.8165 21.2071 21.207C20.8166 21.5975 20.1834 21.5975 19.7929 21.207L18.3787 19.7928C17.9882 19.4023 17.9882 18.7691 18.3787 18.3786Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.4142 3.51463C15.3669 1.56201 18.5327 1.56201 20.4853 3.51463C22.4379 5.46725 22.4379 8.63308 20.4853 10.5857L18.364 12.707C17.9735 13.0975 17.3403 13.0975 16.9498 12.707C16.5593 12.3165 16.5593 11.6833 16.9498 11.2928L19.0711 9.17148C20.2427 7.99991 20.2427 6.10042 19.0711 4.92884C17.8995 3.75727 16 3.75727 14.8285 4.92884L12.7071 7.05017C12.3166 7.44069 11.6835 7.44069 11.2929 7.05017C10.9024 6.65964 10.9024 6.02648 11.2929 5.63595L13.4142 3.51463ZM7.05029 11.2928C7.44081 11.6833 7.44081 12.3165 7.05029 12.707L4.92897 14.8283C3.75739 15.9999 3.75739 17.8994 4.92897 19.071C6.10054 20.2426 8.00003 20.2426 9.17161 19.071L11.2929 16.9497C11.6835 16.5591 12.3166 16.5591 12.7071 16.9497C13.0977 17.3402 13.0977 17.9733 12.7071 18.3639L10.5858 20.4852C8.6332 22.4378 5.46737 22.4378 3.51475 20.4852C1.56213 18.5326 1.56213 15.3667 3.51475 13.4141L5.63607 11.2928C6.0266 10.9023 6.65976 10.9023 7.05029 11.2928Z"
        fill="currentColor"
      />
    </>
  )
}

export const ExternalLink = () => {
  return (
    <>
      <path
        d="M21 9L21 3M21 3H15M21 3L13 11M10 5H7.8C6.11984 5 5.27976 5 4.63803 5.32698C4.07354 5.6146 3.6146 6.07354 3.32698 6.63803C3 7.27976 3 8.11984 3 9.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H14.2C15.8802 21 16.7202 21 17.362 20.673C17.9265 20.3854 18.3854 19.9265 18.673 19.362C19 18.7202 19 17.8802 19 16.2V14"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const BoxX = () => {
  return (
    <>
      <path
        d="M16.207 14.2929C15.8165 13.9024 15.1833 13.9024 14.7928 14.2929C14.4022 14.6834 14.4022 15.3166 14.7928 15.7071L16.5857 17.5L14.7928 19.2929C14.4022 19.6834 14.4022 20.3166 14.7928 20.7071C15.1833 21.0976 15.8165 21.0976 16.207 20.7071L17.9999 18.9142L19.7928 20.7071C20.1833 21.0976 20.8165 21.0976 21.207 20.7071C21.5975 20.3166 21.5975 19.6834 21.207 19.2929L19.4141 17.5L21.207 15.7071C21.5975 15.3166 21.5975 14.6834 21.207 14.2929C20.8165 13.9024 20.1833 13.9024 19.7928 14.2929L17.9999 16.0858L16.207 14.2929Z"
        fill="currentColor"
      />
      <path
        d="M9.59698 0.185046C9.8628 0.130375 10.137 0.130375 10.4028 0.185046C10.7101 0.248242 10.9847 0.402069 11.203 0.524362L11.2626 0.557609C13.0255 1.53701 16.0078 3.19466 17.6892 4.12926C18.0974 4.35619 18.3015 4.46965 18.3697 4.61961C18.4292 4.75034 18.4296 4.90033 18.3708 5.03136C18.3033 5.18166 18.0996 5.29625 17.6922 5.52544L15.3631 6.83555L6.40026 1.85619L8.73721 0.55761L8.79673 0.524362C9.01507 0.402069 9.28971 0.248242 9.59698 0.185046Z"
        fill="currentColor"
      />
      <path
        d="M4.34156 3.00039L13.3168 7.98661L10.3921 9.63177C10.249 9.71225 10.1775 9.75249 10.1016 9.76825C10.0345 9.78221 9.96521 9.78221 9.89808 9.76825C9.82223 9.75249 9.7507 9.71225 9.60763 9.63177L2.30757 5.52545C1.90012 5.29627 1.6964 5.18167 1.62895 5.03137C1.57015 4.90034 1.57053 4.75035 1.62999 4.61962C1.69821 4.46967 1.90233 4.3562 2.31057 4.12928L4.34156 3.00039Z"
        fill="currentColor"
      />
      <path
        d="M19.9958 7.89013C19.9954 7.4418 19.9952 7.21764 19.9007 7.08675C19.8182 6.97256 19.6914 6.89845 19.5514 6.88267C19.3909 6.86457 19.1952 6.97469 18.8036 7.19493L11.4077 11.3552C11.2592 11.4387 11.185 11.4805 11.1309 11.5395C11.0831 11.5918 11.047 11.6536 11.0249 11.7209C10.9999 11.7969 10.9999 11.8821 10.9999 12.0524V20.2277C10.9999 20.6749 10.9999 20.8985 11.0939 21.0293C11.1759 21.1434 11.3022 21.2177 11.4418 21.234C11.6018 21.2527 11.7966 21.1445 12.1864 20.9281C12.2572 20.8888 12.2925 20.8692 12.3154 20.8528C12.4608 20.7492 12.5203 20.6374 12.5251 20.4589C12.5258 20.4308 12.5209 20.3735 12.511 20.2588C12.4377 19.4072 12.7269 18.5304 13.3786 17.8787L13.7572 17.5L13.3786 17.1213C12.207 15.9497 12.207 14.0503 13.3786 12.8787C14.5501 11.7071 16.4496 11.7071 17.6212 12.8787L17.9999 13.2574L18.3786 12.8787C18.6657 12.5916 18.9965 12.3748 19.3496 12.2284C19.6316 12.1115 19.7725 12.0531 19.8381 11.9925C19.9073 11.9285 19.9352 11.8867 19.9677 11.7982C19.9986 11.7144 19.9985 11.598 19.9984 11.365C19.9975 10.0765 19.9965 8.80592 19.9958 7.89013Z"
        fill="currentColor"
      />
      <path
        d="M7.81339 20.9281C8.20311 21.1445 8.39797 21.2527 8.55795 21.234C8.69754 21.2177 8.82382 21.1434 8.90585 21.0293C8.99988 20.8985 8.99988 20.6749 8.99988 20.2277V12.0525C8.99988 11.8821 8.99988 11.797 8.97488 11.7209C8.95277 11.6536 8.91662 11.5918 8.86881 11.5396C8.81479 11.4805 8.74054 11.4387 8.59209 11.3552L1.19611 7.19496C0.80458 6.97472 0.608813 6.8646 0.448369 6.88269C0.308397 6.89848 0.181563 6.97259 0.0990844 7.08677C0.00454248 7.21766 0.00435507 7.44183 0.00398025 7.89017C0.0024201 9.75633 -0.00011952 13.0956 -0.00011952 15.0586L-0.000297142 15.1308C-0.00125845 15.3946 -0.00246712 15.7264 0.10085 16.0391C0.190175 16.3095 0.336196 16.5576 0.529147 16.767C0.752312 17.0092 1.04291 17.1692 1.27404 17.2966L1.33721 17.3314C3.1184 18.321 6.14703 20.0028 7.81339 20.9281Z"
        fill="currentColor"
      />
    </>
  )
}

export const Edit = () => {
  return (
    <>
      <path
        d="M12 20H21M3 20H4.67454C5.16372 20 5.40832 20 5.63849 19.9447C5.84256 19.8957 6.03765 19.8149 6.2166 19.7053C6.41843 19.5816 6.59138 19.4086 6.93729 19.0627L19.5 6.49998C20.3285 5.67156 20.3285 4.32841 19.5 3.49998C18.6716 2.67156 17.3285 2.67156 16.5 3.49998L3.93726 16.0627C3.59136 16.4086 3.4184 16.5816 3.29472 16.7834C3.18506 16.9624 3.10425 17.1574 3.05526 17.3615C3 17.5917 3 17.8363 3 18.3255V20Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const EditPaperOutline = () => {
  return (
    <>
      <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M10 3.99998H5.8C4.11984 3.99998 3.27976 3.99998 2.63803 4.32696C2.07354 4.61458 1.6146 5.07353 1.32698 5.63801C1 6.27975 1 7.11983 1 8.79998V17.2C1 18.8801 1 19.7202 1.32698 20.362C1.6146 20.9264 2.07354 21.3854 2.63803 21.673C3.27976 22 4.11984 22 5.8 22H14.2C15.8802 22 16.7202 22 17.362 21.673C17.9265 21.3854 18.3854 20.9264 18.673 20.362C19 19.7202 19 18.8801 19 17.2V13M6.99997 16H8.67452C9.1637 16 9.40829 16 9.63846 15.9447C9.84254 15.8957 10.0376 15.8149 10.2166 15.7053C10.4184 15.5816 10.5914 15.4086 10.9373 15.0627L20.5 5.49998C21.3284 4.67156 21.3284 3.32841 20.5 2.49998C19.6716 1.67156 18.3284 1.67155 17.5 2.49998L7.93723 12.0627C7.59133 12.4086 7.41838 12.5816 7.29469 12.7834C7.18504 12.9624 7.10423 13.1574 7.05523 13.3615C6.99997 13.5917 6.99997 13.8363 6.99997 14.3255V16Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  )
}

export const EditPaper = () => {
  return (
    <>
      <path
        d="M11 3.99998H6.8C5.11984 3.99998 4.27976 3.99998 3.63803 4.32696C3.07354 4.61458 2.6146 5.07353 2.32698 5.63801C2 6.27975 2 7.11983 2 8.79998V17.2C2 18.8801 2 19.7202 2.32698 20.362C2.6146 20.9264 3.07354 21.3854 3.63803 21.673C4.27976 22 5.11984 22 6.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9264 19.673 20.362C20 19.7202 20 18.8801 20 17.2V13M7.99997 16H9.67452C10.1637 16 10.4083 16 10.6385 15.9447C10.8425 15.8957 11.0376 15.8149 11.2166 15.7053C11.4184 15.5816 11.5914 15.4086 11.9373 15.0627L21.5 5.49998C22.3284 4.67156 22.3284 3.32841 21.5 2.49998C20.6716 1.67156 19.3284 1.67155 18.5 2.49998L8.93723 12.0627C8.59133 12.4086 8.41838 12.5816 8.29469 12.7834C8.18504 12.9624 8.10423 13.1574 8.05523 13.3615C7.99997 13.5917 7.99997 13.8363 7.99997 14.3255V16Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const Message = () => {
  return (
    <>
      <path
        d="M19.7955 1.33865C19.4327 1.21745 19.095 1.3051 18.9271 1.35388C18.7441 1.40703 18.526 1.49218 18.3071 1.57762L2.76314 7.64357C2.51854 7.73899 2.28163 7.8314 2.09878 7.92182C1.94079 7.99994 1.60498 8.17381 1.41753 8.53462C1.21082 8.93251 1.2111 9.4062 1.41828 9.80385C1.60615 10.1644 1.94216 10.3379 2.10025 10.4159C2.2832 10.506 2.52018 10.5982 2.76488 10.6933L7.09157 12.3759C7.41434 12.5014 7.57573 12.5642 7.73629 12.568C7.87821 12.5714 8.01897 12.5418 8.1475 12.4816C8.29291 12.4134 8.41535 12.2909 8.66024 12.046L13.1019 7.60442C13.4598 7.24644 14.0402 7.24644 14.3982 7.60442C14.7562 7.9624 14.7562 8.54281 14.3982 8.90079L9.9566 13.3424C9.71171 13.5873 9.58927 13.7097 9.52108 13.8551C9.4608 13.9837 9.4312 14.1244 9.43461 14.2664C9.43847 14.4269 9.50123 14.5883 9.62675 14.9111L11.3093 19.2377C11.4045 19.4824 11.4966 19.7194 11.5868 19.9024C11.6647 20.0605 11.8382 20.3965 12.1988 20.5844C12.5964 20.7915 13.0701 20.7918 13.468 20.5851C13.8288 20.3977 14.0027 20.0619 14.0808 19.9039C14.1712 19.721 14.2636 19.4841 14.3591 19.2395L20.425 3.6955C20.5105 3.47668 20.5956 3.25859 20.6488 3.07559C20.6975 2.90767 20.7852 2.56991 20.664 2.20713C20.5271 1.79724 20.2054 1.47558 19.7955 1.33865Z"
        fill="currentColor"
      />
    </>
  )
}

export const Document = () => {
  return (
    <>
      <path
        d="M14 2.26946V6.4C14 6.96005 14 7.24008 14.109 7.45399C14.2049 7.64215 14.3578 7.79513 14.546 7.89101C14.7599 8 15.0399 8 15.6 8H19.7305M20 9.98822V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V6.8C4 5.11984 4 4.27976 4.32698 3.63803C4.6146 3.07354 5.07354 2.6146 5.63803 2.32698C6.27976 2 7.11984 2 8.8 2H12.0118C12.7455 2 13.1124 2 13.4577 2.08289C13.7638 2.15638 14.0564 2.27759 14.3249 2.44208C14.6276 2.6276 14.887 2.88703 15.4059 3.40589L18.5941 6.59411C19.113 7.11297 19.3724 7.3724 19.5579 7.67515C19.7224 7.94356 19.8436 8.2362 19.9171 8.5423C20 8.88757 20 9.25445 20 9.98822Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const EditTools = () => {
  return (
    <>
      <path
        d="M6 6L10.5 10.5M6 6H3L2 3L3 2L6 3V6ZM19.259 2.74101L16.6314 5.36863C16.2354 5.76465 16.0373 5.96265 15.9632 6.19098C15.8979 6.39183 15.8979 6.60817 15.9632 6.80902C16.0373 7.03735 16.2354 7.23535 16.6314 7.63137L16.8686 7.86863C17.2646 8.26465 17.4627 8.46265 17.691 8.53684C17.8918 8.6021 18.1082 8.6021 18.309 8.53684C18.5373 8.46265 18.7354 8.26465 19.1314 7.86863L21.5893 5.41072C21.854 6.05488 22 6.76039 22 7.5C22 10.5376 19.5376 13 16.5 13C16.1338 13 15.7759 12.9642 15.4298 12.8959C14.9436 12.8001 14.7005 12.7521 14.5532 12.7668C14.3965 12.7824 14.3193 12.8059 14.1805 12.8802C14.0499 12.9501 13.919 13.081 13.657 13.343L6.5 20.5C5.67157 21.3284 4.32843 21.3284 3.5 20.5C2.67157 19.6716 2.67157 18.3284 3.5 17.5L10.657 10.343C10.919 10.081 11.0499 9.95005 11.1198 9.81949C11.1941 9.68068 11.2176 9.60347 11.2332 9.44681C11.2479 9.29945 11.1999 9.05638 11.1041 8.57024C11.0358 8.22406 11 7.86621 11 7.5C11 4.46243 13.4624 2 16.5 2C17.5055 2 18.448 2.26982 19.259 2.74101ZM12.0001 14.9999L17.5 20.4999C18.3284 21.3283 19.6716 21.3283 20.5 20.4999C21.3284 19.6715 21.3284 18.3283 20.5 17.4999L15.9753 12.9753C15.655 12.945 15.3427 12.8872 15.0408 12.8043C14.6517 12.6975 14.2249 12.7751 13.9397 13.0603L12.0001 14.9999Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const Printer = () => {
  return (
    <>
      <path
        d="M18 7V5.2C18 4.0799 18 3.51984 17.782 3.09202C17.5903 2.71569 17.2843 2.40973 16.908 2.21799C16.4802 2 15.9201 2 14.8 2H9.2C8.0799 2 7.51984 2 7.09202 2.21799C6.71569 2.40973 6.40973 2.71569 6.21799 3.09202C6 3.51984 6 4.0799 6 5.2V7M6 18C5.07003 18 4.60504 18 4.22354 17.8978C3.18827 17.6204 2.37962 16.8117 2.10222 15.7765C2 15.395 2 14.93 2 14V11.8C2 10.1198 2 9.27976 2.32698 8.63803C2.6146 8.07354 3.07354 7.6146 3.63803 7.32698C4.27976 7 5.11984 7 6.8 7H17.2C18.8802 7 19.7202 7 20.362 7.32698C20.9265 7.6146 21.3854 8.07354 21.673 8.63803C22 9.27976 22 10.1198 22 11.8V14C22 14.93 22 15.395 21.8978 15.7765C21.6204 16.8117 20.8117 17.6204 19.7765 17.8978C19.395 18 18.93 18 18 18M15 10.5H18M9.2 22H14.8C15.9201 22 16.4802 22 16.908 21.782C17.2843 21.5903 17.5903 21.2843 17.782 20.908C18 20.4802 18 19.9201 18 18.8V17.2C18 16.0799 18 15.5198 17.782 15.092C17.5903 14.7157 17.2843 14.4097 16.908 14.218C16.4802 14 15.9201 14 14.8 14H9.2C8.0799 14 7.51984 14 7.09202 14.218C6.71569 14.4097 6.40973 14.7157 6.21799 15.092C6 15.5198 6 16.0799 6 17.2V18.8C6 19.9201 6 20.4802 6.21799 20.908C6.40973 21.2843 6.71569 21.5903 7.09202 21.782C7.51984 22 8.07989 22 9.2 22Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const Hash = () => {
  return (
    <>
      <path
        d="M4 9H20M4 15H20M10 3L8 21M16 3L14 21"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const Number = () => {
  return (
    <>
      <path
        d="M5 12H19M5 8H19M8 3V21M12 3V21"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const ArrowUpRight = () => {
  return (
    <>
      <path
        d="M7 17L17 7M17 7H7M17 7V17"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const PanelRight = () => {
  return (
    <>
      <rect
        width="18"
        height="18"
        x="3"
        y="3"
        rx="2"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path d="M15 3v18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </>
  )
}

export const Inbox = () => {
  return (
    <>
      <path
        d="M3 9V17.4C3 18.9601 3 19.7401 3.32698 20.362C3.6146 20.9265 4.07354 21.3854 4.63803 21.673C5.25992 22 6.03995 22 7.6 22H16.4C17.9601 22 18.7401 22 19.362 21.673C19.9265 21.3854 20.3854 20.9265 20.673 20.362C21 19.7401 21 18.9601 21 17.4V9M3 9H8.5C9.05228 9 9.5 9.44772 9.5 10V10.5C9.5 11.6046 10.3954 12.5 11.5 12.5H12.5C13.6046 12.5 14.5 11.6046 14.5 10.5V10C14.5 9.44772 14.9477 9 15.5 9H21M3 9V6.2C3 4.61984 3 3.82976 3.32698 3.20787C3.6146 2.64338 4.07354 2.18444 4.63803 1.89682C5.25992 1.56984 6.03995 1.56984 7.6 1.56984H16.4C17.9601 1.56984 18.7401 1.56984 19.362 1.89682C19.9265 2.18444 20.3854 2.64338 20.673 3.20787C21 3.82976 21 4.61984 21 6.2V9"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </>
  )
}

export const BellOutline = () => {
  return (
    <>
      <path
        d="M9.35419 21C10.0593 21.6224 10.9856 22 12 22C13.0145 22 13.9407 21.6224 14.6458 21M18 8C18 6.4087 17.3679 4.88258 16.2427 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 11.0902 5.22047 13.206 4.34966 14.6054C3.61513 15.7859 3.24786 16.3761 3.26132 16.5408C3.27624 16.7231 3.31486 16.7926 3.46178 16.9016C3.59448 17 4.19261 17 5.38887 17H18.6111C19.8074 17 20.4055 17 20.5382 16.9016C20.6851 16.7926 20.7238 16.7231 20.7387 16.5408C20.7521 16.3761 20.3849 15.7859 19.6503 14.6054C18.7795 13.206 18 11.0902 18 8Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </>
  )
}

export const ExclamationMark = () => {
  return (
    <>
      <path
        d="M12 16V12M12 8H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </>
  )
}

export const ArrowUp = () => {
  return (
    <>
      <path
        d="M12 5V19M12 5L6 11M12 5L18 11"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </>
  )
}

export const ArrowDown = () => {
  return (
    <>
      <path
        d="M12 19V5M12 19L6 13M12 19L18 13"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </>
  )
}

export const WhiteList = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
      <path d="M15 12h-5" />
      <path d="M15 8h-5" />
      <path d="M19 17V5a2 2 0 0 0-2-2H4" />
      <path d="M8 21h12a2 2 0 0 0 2-2v-1a1 1 0 0 0-1-1H11a1 1 0 0 0-1 1v1a2 2 0 1 1-4 0V5a2 2 0 1 0-4 0v2a1 1 0 0 0 1 1h3" />
    </svg>
  )
}

export const Maximize2Icon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide lucide-maximize2-icon lucide-maximize-2"
    >
      <path d="M15 3h6v6" />
      <path d="m21 3-7 7" />
      <path d="m3 21 7-7" />
      <path d="M9 21H3v-6" />
    </svg>
  )
}

export const Company = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z" />
      <path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2" />
      <path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2" />
      <path d="M10 6h4" />
      <path d="M10 10h4" />
      <path d="M10 14h4" />
      <path d="M10 18h4" />
    </svg>
  )
}

export const Member = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  )
}

export const Global = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M21.54 15H17a2 2 0 0 0-2 2v4.54" />
      <path d="M7 3.34V5a3 3 0 0 0 3 3a2 2 0 0 1 2 2c0 1.1.9 2 2 2a2 2 0 0 0 2-2c0-1.1.9-2 2-2h3.17" />
      <path d="M11 21.95V18a2 2 0 0 0-2-2a2 2 0 0 1-2-2v-1a2 2 0 0 0-2-2H2.05" />
      <circle cx="12" cy="12" r="10" />
    </svg>
  )
}

export const ClipboardPlusIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.86178 1.01695C9.06993 0.999943 9.31573 0.999973 9.56811 1L14.4319 1C14.6843 0.999973 14.9301 0.999943 15.1382 1.01695C15.3668 1.03563 15.6366 1.07969 15.908 1.21799C16.2843 1.40974 16.5903 1.7157 16.782 2.09202C16.9203 2.36345 16.9644 2.63318 16.9831 2.86178C16.9869 2.90874 16.9899 2.95762 16.9922 3.00805C17.3874 3.02081 17.7258 3.05345 18.0354 3.13639C19.4157 3.50626 20.4939 4.58445 20.8638 5.96482C21.0009 6.47647 21.0006 7.06713 21.0001 7.86252L21.0001 17.2414C21.0001 18.0464 21.0001 18.7107 20.9559 19.2519C20.91 19.814 20.8114 20.3307 20.5641 20.8161C20.1806 21.5687 19.5687 22.1806 18.8161 22.5641C18.3307 22.8114 17.814 22.91 17.2519 22.9559C16.7107 23.0001 16.0464 23.0001 15.2414 23.0001H8.75877C7.95381 23.0001 7.28946 23.0001 6.74827 22.9559C6.18617 22.91 5.66947 22.8114 5.18413 22.5641C4.43149 22.1806 3.81956 21.5687 3.43607 20.8161C3.18878 20.3307 3.09022 19.814 3.04429 19.2519C3.00007 18.7107 3.00008 18.0464 3.0001 17.2414L3.00005 7.86252C2.99962 7.06713 2.9993 6.47647 3.13639 5.96482C3.50626 4.58445 4.58445 3.50626 5.96482 3.13639C6.27431 3.05347 6.61271 3.02082 7.00784 3.00806C7.01014 2.95762 7.01311 2.90874 7.01695 2.86178C7.03563 2.63318 7.07969 2.36345 7.21799 2.09202C7.40974 1.7157 7.7157 1.40974 8.09202 1.21799C8.36345 1.07969 8.63318 1.03563 8.86178 1.01695ZM9.10899 3.54601C9 3.75992 9 4.03995 9 4.6V5H15V4.6C15 4.03995 15 3.75992 14.891 3.54601C14.7951 3.35785 14.6422 3.20487 14.454 3.10899C14.2401 3 13.9601 3 13.4 3H10.6C10.0399 3 9.75992 3 9.54601 3.10899C9.35785 3.20487 9.20487 3.35785 9.10899 3.54601ZM16.2071 13.2071C16.5976 12.8166 16.5976 12.1834 16.2071 11.7929C15.8166 11.4024 15.1834 11.4024 14.7929 11.7929L11 15.5858L9.70711 14.2929C9.31658 13.9024 8.68342 13.9024 8.29289 14.2929C7.90237 14.6834 7.90237 15.3166 8.29289 15.7071L10.2929 17.7071C10.6834 18.0976 11.3166 18.0976 11.7071 17.7071L16.2071 13.2071Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const Bot = () => {
  return (
    <>
      <path
        d="M8 1.5C8 0.671573 8.67157 0 9.5 0H14.5C15.3284 0 16 0.671573 16 1.5V3H14.5C14.7761 3 15 3.22386 15 3.5V5.5C15 5.77614 14.7761 6 14.5 6H1.5C1.22386 6 1 5.77614 1 5.5V3.5C1 3.22386 1.22386 3 1.5 3H2V1.5C2 0.671573 2.67157 0 3.5 0H8.5C9.32843 0 10 0.671573 10 1.5V3H8V1.5ZM3.5 7.5C3.5 7.22386 3.72386 7 4 7H12C12.2761 7 12.5 7.22386 12.5 7.5V11.5C12.5 11.7761 12.2761 12 12 12H4C3.72386 12 3.5 11.7761 3.5 11.5V7.5ZM5.5 9C5.5 8.72386 5.72386 8.5 6 8.5H6.5C6.77614 8.5 7 8.72386 7 9V9.5C7 9.77614 6.77614 10 6.5 10H6C5.72386 10 5.5 9.77614 5.5 9.5V9ZM9 9C9 8.72386 9.22386 8.5 9.5 8.5H10C10.2761 8.5 10.5 8.72386 10.5 9V9.5C10.5 9.77614 10.2761 10 10 10H9.5C9.22386 10 9 9.77614 9 9.5V9Z"
        fill="currentColor"
      />
    </>
  )
}

export const Play = () => {
  return (
    <>
      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" fill="currentColor" />
      <path
        d="M6.271 5.055a.5.5 0 0 1 .52.016L11 7.055a.5.5 0 0 1 0 .89L6.791 9.929a.5.5 0 0 1-.791-.394V5.465a.5.5 0 0 1 .271-.41z"
        fill="currentColor"
      />
    </>
  )
}

export const SearchRefraction = () => {
  return (
    <>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M21 21L16.65 16.65M11 6C13.7614 6 16 8.23858 16 11M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  )
}

export const GraphCollapseIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 3L5 8L10 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

export const GraphExpandIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 3L11 8L6 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

export const O2OSellersIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
)

export const O2OItemsIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
    <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
    <line x1="12" y1="22.08" x2="12" y2="12" />
  </svg>
)

export const O2OGlobeIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <line x1="2" y1="12" x2="22" y2="12" />
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
  </svg>
)

export const O2OGraphIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="18" cy="5" r="3" />
    <circle cx="6" cy="12" r="3" />
    <circle cx="18" cy="19" r="3" />
    <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
    <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
  </svg>
)

export const O2OEntityIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="16" y1="13" x2="8" y2="13" />
    <line x1="16" y1="17" x2="8" y2="17" />
  </svg>
)

export const O2OSeizureIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
  </svg>
)

export const O2OProductIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="16.5" y1="9.4" x2="7.5" y2="4.21" />
    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
    <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
    <line x1="12" y1="22.08" x2="12" y2="12" />
  </svg>
)
